export default [["en", {
  "api-error-messages": {
    "campaign-creation": {
      "custom-landing-page_too_long": "Please choose a shorter text to display on the starting page.",
      "external-user-id-required": "Please specify the type of external user ID which the participants will be required to fill when starting the customised test.",
      "id-pix-type-required": "Please select an external identifier type.",
      "name-required": "Please name your campaign.",
      "owner_not_in_organization": "Please select a member of your organization.",
      "purpose-required": "Please select the purpose of your campaign: assess participants or collect their profiles.",
      "target-profile-required": "Please select a customised test for your campaign.",
      "title_too_long": "Please choose a shorter title."
    },
    "csv-import": {
      "property-not-uniq": "Row {line} : The field “{field}” must be unique within the file."
    },
    "default": "The service is temporarily unavailable. Please try again later.",
    "edit-student-number": {
      "student-number-exists": "The student number entered is already used by {firstName} {lastName}"
    },
    "global": "An error occurred. Please try again later.",
    "or-separator": " or ",
    "student-csv-import": {
      "bad-csv-format": "The file must be in csv format with comma or semicolon separator.",
      "encoding-not-supported": "File encoding not supported.",
      "field-bad-values": "Row {line} : The field “{field}” must be “{valids}”.",
      "field-date-format": "Row {line} : The field “{field}” must be in the format “{acceptedFormat}”.",
      "field-email-format": "Row {line} : The field “{field}” must be a valid email address.",
      "field-length": "Row {line} : The field “{field}” must contain {limit} characters.",
      "field-max-length": "Row {line} : The field “{field}” must contain less than {limit} characters.",
      "field-min-length": "Row {line} : The field “{field}” must contain at least {limit} characters.",
      "field-required": "Row {line} : The field “{field}” is mandatory.",
      "header-required": "The “{field}” is mandatory.",
      "header-unknown": "Column headers must be identical to the ones on the template.",
      "identifier-unique": "Row {line} : The field “{field}” of this row is repeated several times within the file.",
      "insee-code-invalid": "Row {line} : The field “{field}” is not in the INSEE format.",
      "payload-too-large": "The file must be less than {maxSize}MB.",
      "student-number-format": "Row {line} : The field “{field}” must not contain any special characters.",
      "student-number-unique": "Row {line} : The field “{field}” must be unique within the file."
    },
    "student-password-reset": {
      "organization-learner-does-not-belong-to-organization-error": "Some of the selected students are no longer part of this organisation.",
      "organization-learner-without-username-error": "Some of the selected students no longer have a username. Please refresh this page.",
      "user-does-not-belong-to-organization-error": "You no longer have the rights for this organisation."
    },
    "student-xml-import": {
      "birth-city-code-required-for-french-student": "Student with {nationalStudentId} INE has no birth city code filled out. This field is mandatory for each student born in France.",
      "birthdate-required": "Student with {nationalStudentId} INE has no date of birth filled out. This field is mandatory for each student.",
      "empty": "Each student must have an INE and a class.",
      "encoding-not-supported": "File encoding not supported.",
      "first-name-required": "Student with {nationalStudentId} INE has no first name filled out. This field is mandatory for each student.",
      "ine-required": "INE is mandatory for each student.",
      "ine-unique": "The INE {nationalStudentId} is repeated several times within the file for several students.",
      "invalid-birthdate-format": "Student with {nationalStudentId} INE has the wrong date of birth format. It must be in 'DD/MM/YYYY' format.",
      "invalid-file": "File does not match the requirements.",
      "invalid-file-extension": "File with extension {fileExtension} not supported.",
      "last-name-required": "Student with {nationalStudentId} INE has no last name filled out. This field is mandatory for each student.",
      "payload-too-large": "The file must be less than {maxSize}MB.",
      "sex-code-required": "Student with {nationalStudentId} INE has no sex code filled out. This field is mandatory for each student.",
      "uai-mismatched": "The UAI of your SIECLE file does not match your school."
    }
  },
  "application": {
    "description": "The platform dedicated to educational assessment and monitoring. Pix Orga lets you launch an assessment campaign or collect Pix profiles, track the progress of your students or learners in a campaign, or access their results."
  },
  "banners": {
    "certification": {
      "message": "'<strong>'Certifications :'</strong>' Please don't forget to '<'a href={documentationLink} class=\"{linkClasses}\" target=\"_blank\" rel=\"noopener noreferrer\"'>'to finalize your sessions in Pix Certif'</a>' and to download the certificates via the \"Certifications\" tab before the start of the {year} academic year."
    },
    "import": {
      "message": "The main stages of the school year :",
      "step1a": " Setting up&nbsp;: '<'a href='https://cloud.pix.fr/s/WjTnkSbFs9TDcSC' title='Downloading results how-to' class='link link--banner link--bold link--underlined' '>'downloading certification results'</a>' and",
      "step1b": "importing",
      "step1c": "the student database (admin)",
      "step2": "'<'a href='https://cloud.pix.fr/s/RaPpKjFHNX2kSR4' title='Back-to-school how-to' class='link link--banner link--bold link--underlined' '>'Create campaigns'</a>' (back-to-school, 6th grade, thematic, subject-based, targeted courses, etc.).",
      "step3": "Certify learners. '<'a href='https://cloud.pix.fr/s/2q4c4QT9jGbGbEq' title='Preparing and organising student certification how-to' class='link link--banner link--bold link--underlined' '>'Find out more about the new certification'</a>'."
    },
    "language-availability": {
      "message": "Your language is not yet available on Pix Orga. For your convenience, the application will be presented in English. The entire Pix team is working to add your language."
    },
    "last-places-lot-available": {
      "message": "Please note that your seats will expire in {days, number} days."
    },
    "maximum-places-exceeded": {
      "message": "<b>Your organisation no longer has any seats available !</b><br />To take advantage of all the features, please free up some seats, get in touch with your Pix representative or '<'a href='https://pix.org/en/support-contact-form' title='contact us' class=\"{linkClasses}\" '>contact us using this form</a>'."
    },
    "over-capacity": {
      "message": "Please note that you are using more seats than your total capacity."
    },
    "survey": {
      "message": "Help Pix to develop Pix Orga by answering this short survey on how you use our campaigns! '<'a href={documentationLink} class=\"{linkClasses}\" target=\"_blank\" rel=\"noopener noreferrer\"'>'Access the survey'</a>'"
    }
  },
  "cards": {
    "available-seats-count": {
      "title": "Seats available",
      "value": "/{total} seats"
    },
    "badges-acquisitions": {
      "information": "Find here the number of badges obtained by your participants in this campaign as well as their percentage.",
      "obtained": "obtained",
      "title": "Badges"
    },
    "occupied-seats-count": {
      "anonymous": "including {count, plural, =1 {1 seat} other {{count, number} seats}} with no-account access",
      "title": "Seats occupied",
      "value": "/{total} seats"
    },
    "participants-average-results": {
      "information": "Find here the average results of your campaign. This includes all the participants who have completed their customised test and sent their results.",
      "title": "Average result"
    },
    "participants-average-stages": {
      "information": "Find here the average rating of your campaign. This includes all the participants who have completed their customised test and sent their results.",
      "title": "Average rating"
    },
    "participants-count": {
      "information": "Find here the total number of participations in your campaign. This includes all the participants who have entered the code and started their customised test or submitted their profile.",
      "loader": "Loading total participants",
      "title": "Total participants"
    },
    "place-info": {
      "with-account": {
        "heading": "'<strong>'The participant has a Pix account:'</strong>'",
        "message-description": "You can free up seats by deleting participants from the Participants tab.",
        "message-main": "1 participant with at least one participation in a campaign = 1 seat occupied."
      },
      "without-account": {
        "heading": "'<strong>'The participant does not have a Pix account'</strong>' (no-account campaign):",
        "message-description": "You can free up these seats by deleting participations in the relevant no-account campaign or by deleting the campaign.",
        "message-main": "1 participation without account = 1 seat occupied."
      }
    },
    "submitted-count": {
      "information": "Find here the results submitted by your participants. This includes all the participants who have finished and clicked on the button \"Submit my results\" or \"Submit my profile\".",
      "loader": "Loading submitted results or profiles",
      "title": "Submitted results",
      "title-profiles": "Submitted profiles"
    }
  },
  "charts": {
    "participants-by-day": {
      "captions": {
        "shared": "Submitted results by day",
        "shared-profile": "Submitted profiles by day",
        "started": "Total participants by day"
      },
      "labels-a11y": {
        "date": "Date",
        "shared": "Submitted results",
        "shared-profile": "Submitted profiles",
        "started": "Total participants"
      },
      "labels-legend": {
        "shared": "Submitted results",
        "shared-profile": "Submitted profiles",
        "started": "Total participants"
      },
      "loader": "Loading participant's activity",
      "title": "Participant's activity"
    },
    "participants-by-mastery-percentage": {
      "label-a11y": "From {from, number, ::percent} to {to, number, ::percent}: {count, plural, =0 {0 participant} =1 {1 participant} other {{count, number} participants}}",
      "loader": "Loading participants grouped by success rates",
      "title": "Distribution of participants grouped by success rate",
      "tooltip": {
        "label": "Number of participants : {count}",
        "legend": "{from, number, ::percent} - {to, number, ::percent}",
        "title": "Results {legend}"
      }
    },
    "participants-by-stage": {
      "loader": "Loading and sorting the participants grouped by success rates",
      "participants": "{count, plural, =0 {0 participants} =1 {1 participant} other {{count, number} participants}}",
      "title": "Distribution of participants grouped by success rate"
    },
    "participants-by-status": {
      "a11y-title": "Detail by participation status",
      "labels-a11y": {
        "completed": "{count, plural, =0 {0 participants} =1 {1 participant} other {{count, number} participants}} with pending results",
        "shared": "{count, plural, =0 {0 participants} =1 {1 participant} other {{count, number} participants}} with submitted results",
        "shared-profile": "{count, plural, =0 {0 participants} =1 {1 participant} other {{count, number} participants}} with submitted profiles",
        "started": "{count, plural, =0 {0 participants} =1 {1 participant} other {{count, number} participants}} in progress"
      },
      "labels-legend": {
        "completed-assessment": "Pending results ({count})",
        "completed-assessment-tooltip": "Pending results: These participants have finished their customised test but haven’t submitted their results yet.",
        "completed-profile": "Pending profiles ({count})",
        "completed-profile-tooltip": "Pending profiles: These participants haven’t submitted their profiles yet.",
        "shared": "Submitted results ({count})",
        "shared-profile": "Submitted profiles ({count})",
        "shared-profile-tooltip": "Submitted profiles: These participants have submitted their profiles.",
        "shared-tooltip": "Submitted results: These participants have finished their customised test and submitted their results.",
        "started": "In progress ({count})",
        "started-tooltip": "In progress: These participants haven’t finished their customised test yet."
      },
      "labels-tooltip": {
        "completed-assessment": "Pending results: {percentage, number, ::percent .0}",
        "completed-profile": "Pending profiles: {percentage, number, ::percent .0}",
        "shared": "Submitted results: {percentage, number, ::percent .0}",
        "shared-profile": "Submitted profiles: {percentage, number, ::percent .0}",
        "started": "In progress: {percentage, number, ::percent .0}"
      },
      "loader": "Loading statuses distribution",
      "title": "Statuses"
    }
  },
  "common": {
    "actions": {
      "back": "Back",
      "cancel": "Cancel",
      "close": "Close",
      "confirm": "Confirm",
      "global": "Actions",
      "link-to-participant": "See whole participant's activity"
    },
    "api-error-messages": {
      "bad-request-error": "The data entered was not in the correct format.",
      "gateway-timeout-error": "The service is being slow. Please try again later.",
      "internal-server-error": "An error occurred, our teams are working on finding a solution. Please try again later.",
      "login-unauthorized-error": "There was an error in the email address or password entered.",
      "login-user-blocked-error": "Your account has reached the maximum number of failed login attempts and has been temporarily blocked. Please '<'a href=\"{url}\"'>'contact us'</a>' to unblock it.",
      "login-user-temporary-blocked-error": "You have reached too many failed login attempts. Please try again later or '<'a href=\"{url}\"'>'reset your password here'</a>'."
    },
    "breadcrumb": "Breadcrumb",
    "filters": {
      "actions": {
        "clear": "Clear filters"
      },
      "divisions": {
        "empty": "No class",
        "label": "Search by classes",
        "placeholder": "Classes"
      },
      "fullname": {
        "label": "Search by last name and first name",
        "placeholder": "Last name, first name"
      },
      "loading": "Loading...",
      "placeholder": "-- Select --",
      "title": "Filters"
    },
    "form": {
      "mandatory-all-fields": "All fields are required.",
      "mandatory-fields": "indicates a required field",
      "mandatory-fields-title": "required"
    },
    "fullname": "{firstName} {lastName}",
    "help-form": "https://pix.org/en/contact-form",
    "home-page": "Pix Orga home page",
    "import": {
      "field": {
        "birthdate": "Birthdate",
        "division": "Class",
        "oralization": "Oralization"
      }
    },
    "loading": "Loading",
    "no-content": "No content available",
    "result": {
      "accessibility-description": "Results obtained = {percentage, number, ::percent},that is success rate {stage} of {totalStage}",
      "percentage": "{value, number, ::percent}",
      "stages": "{count} out of {total} stars"
    },
    "target-profile-details": {
      "results": {
        "common": "Success rate in",
        "percent": "percentage",
        "star": "stars"
      },
      "simplified-access": {
        "with-account": "Access with account",
        "without-account": "Access without account"
      },
      "subjects": "Topics: {value, number}",
      "thematic-results": "Badges: {value, number}"
    }
  },
  "components": {
    "analysis-per-competence": {
      "cover-rate-gauge-label": "Your participants have achieved a level of {reachedLevel} out of a maximum attainable level of {maxLevel}.",
      "description": "Below are the campaign competences and their descriptions, as well as the positioning of the participants.",
      "table": {
        "caption": "Competences",
        "column": {
          "competences": "Competence name and description",
          "level": "Level",
          "positioning": "Positioning"
        }
      }
    },
    "analysis-per-tube": {
      "cover-rate-gauge-label": "On the subject your participants have obtained a level of {reachedLevel} out of a maximum attainable level of {maxLevel}.",
      "description": "Below are the campaign topics and their descriptions, as well as the positioning of the participants.",
      "table": {
        "caption": "{index} - {name}",
        "column": {
          "level": "Level",
          "positioning": "Positioning",
          "tubes": "Subject name and description"
        }
      }
    },
    "analysis-per-tube-or-competence": {
      "title": "Detailed positioning",
      "toggle": {
        "label": "View by:",
        "label-competences": "Competences",
        "label-tubes": "Subjects"
      }
    },
    "campaign": {
      "type": {
        "explanation": {
          "ASSESSMENT": "Campaign of type assessment",
          "EXAM": "Interrogation mode [beta]",
          "PROFILES_COLLECTION": "Campaign of type profiles collection"
        },
        "information": {
          "ASSESSMENT": "Assessment",
          "EXAM": "Interrogation mode [beta]",
          "PROFILES_COLLECTION": "Profiles collection"
        }
      }
    },
    "certificability": {
      "placeholder-select": "Eligible / Non-eligible"
    },
    "certificability-tooltip": {
      "aria-label": "How to know if a participant is eligible for certification and what does it mean?",
      "content": "To be eligible for certification, the participant must have achieved level 1 in at least 5 different competences.",
      "from-collect-notice": "their Pix profile needs to be submitted through a profile collection campaign. If the participant has already submitted their profile, the date and status of the last submission are displayed.",
      "from-compute-certificability": "This status is updated both automatically (every 24 hours) and during profile collection campaigns."
    },
    "cover-rate-gauge": {
      "label": "On this campaign, your participants have achieved a level of {reachedLevel} out of a maximum attainable level of {maxLevel}."
    },
    "date": {
      "no-date": "No date yet"
    },
    "global-positioning": {
      "description": "Overall positioning is the average level achieved by participants (purple bar) compared with the maximum they could have achieved in this campaign (white bar).",
      "gauge-label": "On this test, your participants achieved an average level of {reachedLevel} out of a maximum reachable level of {maxLevel}.",
      "title": "Global positioning"
    },
    "group": {
      "SCO": "Class",
      "SUP": "Group"
    },
    "import-information-banner": {
      "error": "Import failed",
      "error-link": "(see import page).",
      "in-progress": "An import is in progress",
      "in-progress-link": "(check import status).",
      "success": "Participants have been imported on {date} by {firstName} {lastName}."
    },
    "organization-participants-header": {
      "default": {
        "title": "{count, plural, =0 {Participants} =1 {Participant ({count})} other {Participants ({count})}}"
      },
      "import-button": "Import",
      "sco": {
        "title": "{count, plural, =0 {Students} =1 {Students ({count})} other {Students ({count})}}"
      },
      "sco-title": "{count, plural, =0 {Students} =1 {Student ({count})} other {Students ({count})}}",
      "title": "{count, plural, =0 {Participants} =1 {Participant ({count})} other {Participants ({count})}}"
    },
    "participation-status": {
      "SHARED-ASSESSMENT": "Submitted results",
      "SHARED-PROFILES_COLLECTION": "Submitted profile",
      "STARTED-ASSESSMENT": "In progress",
      "TO_SHARE-ASSESSMENT": "Pending results",
      "TO_SHARE-PROFILES_COLLECTION": "Pending profile"
    },
    "terms-of-service": {
      "actions": {
        "accept": "Accept and continue",
        "document-link": "Read terms of service",
        "reject": "Decline and quit"
      },
      "message": {
        "requested": "To continue using Pix, please read and accept our Terms of service.",
        "update-requested": "We have updated our Terms of service. Please review the changes and accept them to continue."
      },
      "title": {
        "requested": "Please accept our Terms of service",
        "update-requested": "Important update to the Terms of service"
      }
    },
    "ui": {
      "deletion-modal": {
        "confirm-deletion": "Yes, I delete",
        "confirmation-checkbox": "I confirm that I have understood the impacts of the {count} deletions"
      }
    }
  },
  "navigation": {
    "assessment-individual-results": {
      "aria-label": "Individual assessment resultas navigation"
    },
    "campaign-page": {
      "aria-label": "Campaign navigation"
    },
    "credits": {
      "number": "{count, plural, =0 {0 credits} =1 {1 credit} other {{count, number} credits}}",
      "tooltip-text": "The number of credits displayed is the number of credits acquired by the organisation and currently valid (regardless of their activation). For more information, please contact us at the following address: '<a href=mailto:pro@pix.fr>'pro@pix.fr'</a>'"
    },
    "external-link-title": "Open in a new window",
    "footer": {
      "a11y": "Accessibility",
      "aria-label": "Footer navigation",
      "copyrights": "©",
      "legal-notice": "Legal notice",
      "pix": "Pix",
      "server-status": "Services Status"
    },
    "main": {
      "aria-label": "Main navigation",
      "attestations": "Attestations",
      "campaigns": "Campaigns",
      "certifications": "Certifications",
      "close": "Close navigation",
      "documentation": "Documentation",
      "home": "Home",
      "missions": "Missions",
      "open": "Open navigation",
      "organization-participants": "Participants",
      "places": "Seats",
      "sco-organization-participants": "Students",
      "statistics": "Statistics",
      "sup-organization-participants": "Students",
      "support": "Help desk",
      "team": "Team"
    },
    "places": {
      "link": "See details",
      "number": "{count, plural, =0 {0 seat available} =1 {1 seat available} other {{count, number} seats available}}"
    },
    "school-sessions": {
      "activate-button": "Activate session",
      "extend-button": "Extend session",
      "status": {
        "active-label": "Active session until {sessionExpirationDate}",
        "aria-label": "How does the session work ?",
        "code-label": "School code",
        "inactive-label": "Inactive session",
        "info-text": "Students can only access missions when the session is active.'<br>'At the end of the session, students who are in the middle of a mission will not be disconnected.",
        "title": "Session status"
      }
    },
    "team-members": {
      "aria-label": "Team members navigation"
    },
    "user-logged-menu": {
      "button": "Change organization",
      "logout": "Log out"
    }
  },
  "pages": {
    "assessment-individual-results": {
      "badges": "Badges",
      "breadcrumb-current-page-label": "Participation of {firstName} {lastName}",
      "participation-label": "Participation #{participationNumber}",
      "participation-not-shared": "Results to submit",
      "participation-selector": "Select a participation",
      "participation-shared": "Submitted results",
      "progression": "Progression",
      "result": "Result",
      "tab": {
        "results": "Results",
        "review": "Review"
      },
      "table": {
        "column": {
          "competences": "Competences ({count, plural, =0 {-} other {{count}}})",
          "results": {
            "label": "Results",
            "tooltip": "'<span class=\"screen-reader-only\">'This participant has validated'</span>' {result, number, ::percent} '<span class=\"screen-reader-only\">'of the competence {competence}.'</span>'"
          }
        },
        "empty": "Pending results",
        "title": "Results by competence"
      },
      "title": "Results of {firstName} {lastName}"
    },
    "attestations": {
      "PARENTHOOD": "Attestation de sensibilisation au numérique",
      "SIXTH_GRADE": "Attestation de sensibilisation au numérique",
      "basic-description": "Export all attestations",
      "download-attestations-button": "Download (.pdf)",
      "no-attestations": "No attestation available",
      "section": {
        "download": "Download",
        "list": "Follow-up"
      },
      "select-divisions-label": "Select attestations for one or more classes",
      "select-label": "Attestation",
      "table": {
        "column": {
          "division": "Class",
          "first-name": "First name",
          "last-name": "Last name",
          "status": "Obtained"
        },
        "filter": {
          "divisions": {
            "empty-option": "Class",
            "label": "Class"
          },
          "legend": "Filters for the attestations table, input fields allow you to filter the table by a student's first or last name and by classes. Buttons can be used to filter attestations obtained or not.",
          "results": "{total, plural, =0 {0 result} =1 {1 result} other {{total, number} results}}",
          "status": {
            "empty-option": "Obtained / Not obtained",
            "label": "Obtained",
            "not-obtained": "Not obtained",
            "obtained": "Obtained"
          }
        },
        "status": {
          "not-obtained": "Not obtained",
          "obtained": "Obtained on {date}"
        }
      },
      "title": "Attestations"
    },
    "campaign": {
      "actions": {
        "export-results": "Export the results (.csv)",
        "unarchive": "Unarchive the campaign"
      },
      "archived": "Archived campaign",
      "code": "Code",
      "copy": {
        "code": {
          "default": "Copy code",
          "success": "Copied!"
        },
        "link": {
          "default": "Copy direct link",
          "success": "Copied!"
        }
      },
      "created-by": "Owner",
      "created-on": "Created on",
      "empty-state": "No participants yet!",
      "empty-state-with-copy-link": "No participants yet! Share with them the following link to join this campaign.",
      "multiple-sendings": {
        "status": {
          "disabled": "No",
          "enabled": "Yes"
        },
        "title": "Multiple Sendings"
      },
      "name": "Name of the campaign",
      "tab": {
        "activity": "Activity",
        "results": "Results ({count, number})",
        "review": "Review",
        "settings": "Settings"
      }
    },
    "campaign-activity": {
      "actions": {
        "delete": "Delete"
      },
      "delete-participation-modal": {
        "actions": {
          "cancel": "No",
          "confirmation": "Yes, delete"
        },
        "error": "An error occurred while removing this participation.",
        "success": "The participation has been successfully deleted",
        "text": "You are about to delete a participation, it will no longer be visible nor included in the statistics of the campaign.",
        "title": "Delete the participation of <strong>{firstName} {lastName}</strong>?",
        "warning": {
          "assessment-campaign-participation": {
            "shared-participation": "The participant will no longer be able to access the results of this test.",
            "started-participation": "The participant will not be able to complete this test.",
            "to-share-participation": "The Participant will not be able to send in their results."
          },
          "profiles-collection-campaign-participation": {
            "shared-participation": "The participant will no longer be able to submit their profile through this campaign.",
            "to-share-participation": "The participant will no longer be able to submit their profile through this campaign."
          }
        }
      },
      "table": {
        "column": {
          "delete": "Delete participation",
          "first-name": "First name",
          "last-name": "Last name",
          "participationCount": "Number of participations",
          "status": "Status"
        },
        "delete-button-label": "Delete participation",
        "empty": "No participants",
        "see-results": "See results of {firstName} {lastName}",
        "title": "List of participants"
      },
      "title": "Activity"
    },
    "campaign-analysis": {
      "description": {
        "explanation": "Each test assesses a selection of digital skills from the Pix reference framework. Positioning reflects the average level achieved by participants in relation to the maximum level achievable on the test.",
        "nota-bene": "All the data presented comes from shared and undeleted participation in assessment campaigns, and is updated in real time.",
        "resume": "Analyse by topic or skill, the positioning of your participants in this campaign, which covers a selection of subjects from the Pix reference framework."
      },
      "levels-correspondence": {
        "infos": {
          "link": "https://pix.org/en/understand-certification-results",
          "text": "Find out more about levels."
        },
        "levels": {
          "advanced": "5 or 6: Advanced level",
          "beginner": "1 or 2: Novice level",
          "expert": "7 or 8: Expert level",
          "independent": "3 or 4: Independent level"
        },
        "title": "levels correspondence"
      },
      "second-title": "Results Analysis",
      "title": "Analysis"
    },
    "campaign-creation": {
      "actions": {
        "create": "Create a campaign",
        "delete": "Delete"
      },
      "copy-of": "Copy of",
      "external-id-label": {
        "label": "external user ID label",
        "question-label": "Do you need an external user ID?",
        "required": "The external user ID label is mandatory.",
        "suggestion": "Example : \"Student Number\" or \"Email address\" *"
      },
      "external-id-type": {
        "question-label": "What is the type of the external ID ?"
      },
      "landing-page-text": {
        "label": "Text to display on the starting page",
        "sublabel": "This field will be displayed to campaign participants."
      },
      "legal-warning": "*In accordance with the French law governing computer technology and freedoms (“Informatique et Libertés”), and as data controller, please be careful not to ask for significant or identifying personal data unless it is absolutely necessary. Asking for social security numbers, as well as any sensitive data, is strictly prohibited.",
      "multiple-sendings": {
        "assessments": {
          "info": "If you choose to allow multiple submissions, the participants will be able to take the test again 4 days after and submit their results several times by re-entering the campaign code.",
          "question-label": "Do you want to allow participants to submit their results more than once?"
        },
        "info-title": "Multiple submissions",
        "knowledge-elements-resettable": "As part of the customised test, participants can try to improve their results by repeating all the questions in the customised test.",
        "profiles": {
          "info": "If you choose to allow multiple submissions, the participants will be able to submit their profile several times by re-entering the campaign code. Within Pix Orga you will find the latest submitted profile.",
          "question-label": "Do you want to allow participants to submit their profile more than once?"
        }
      },
      "name": {
        "label": "Name of the campaign"
      },
      "no": "No",
      "owner": {
        "info": "The campaign owner, along with the organisation administrators, are the only ones who can modify or archive this campaign.",
        "label": "Campaign owner",
        "placeholder": "Owner’s first and last name",
        "search-placeholder": "Search for an owner",
        "title": "Campaign owner"
      },
      "purpose": {
        "assessment": "Assess participants",
        "assessment-info": "An assessment campaign tests participants on specific topics.",
        "exam": "Interrogation mode [beta]",
        "exam-info": "A ‘interrogation mode’ campaign enables participants to be tested on specific subjects, without taking their user profile into account or having any impact on it. The campaign's questions are personalised for each participant, depending on how far they have progressed along the route.",
        "label": "What is the purpose of your campaign?",
        "profiles-collection": "Collect the participants' Pix profiles",
        "profiles-collection-info": "A profile collection campaign retrieves the participants’ Pix profile: their level for each competence and their pix score.",
        "profiles-collection-info-certificability-calculation": "The “Eligible for certification” status is updated automatically in the '<'a href=\"/eleves\" class=\"{linkClasses}\"'>'Students'</a>' tab."
      },
      "tags": {
        "BACK_TO_SCHOOL": "Back to school",
        "COMPETENCES": "Pix Competences",
        "CUSTOM": "Created for you",
        "DISCIPLINE": "Schools",
        "OTHER": "Other",
        "PIX_PLUS": "Pix+",
        "PREDEFINED": "Ready-made",
        "SUBJECT": "Subject",
        "TARGETED": "Targeted"
      },
      "tags-title": "Filter:",
      "target-profiles-category-label": "Filter customised test by category",
      "target-profiles-category-placeholder": "Categories",
      "target-profiles-label": "Select a customised test",
      "target-profiles-list-label": "What would you like to test?",
      "target-profiles-search-placeholder": "Search by name",
      "test-title": {
        "label": "Title of the customised test",
        "sublabel": "This field will be displayed to campaign participants."
      },
      "title": "Create a campaign",
      "yes": "Yes"
    },
    "campaign-individual-results": {
      "shared-date": "Sent on",
      "start-date": "Started on"
    },
    "campaign-individual-review": {
      "title": "Review for {firstName} {lastName}"
    },
    "campaign-modification": {
      "actions": {
        "edit": "Edit"
      },
      "campaign-modification-success-message": "The changes have been successfully saved.",
      "campaign-name": "Name of the campaign",
      "landing-page-text": {
        "label": "Text to display on the starting page",
        "sublabel": "This field will be displayed to campaign participants."
      },
      "owner": {
        "info": "The campaign owner, along with the organisation administrators, are the only ones who can modify or archive this campaign.",
        "label": "Owner of the campaign",
        "placeholder": "Owner’s first and last name",
        "title": "Owner of the campaign"
      },
      "personalised-test-title": {
        "label": "Title of the personalised test",
        "sublabel": "This field will be displayed to campaign participants."
      },
      "title": "Edit a campaign"
    },
    "campaign-results": {
      "average": "Average results",
      "filters": {
        "aria-label": "Filters on participations",
        "participations-count": "{count, plural, =0 {0 participants} =1 {1 participant} other {{count} participants}}",
        "type": {
          "badges": "Acquired badges",
          "groups": {
            "empty": "No group",
            "title": "Groups"
          },
          "stages": "Success rate",
          "status": {
            "empty": "All statuses",
            "title": "Status"
          },
          "unacquired-badges": "Unacquired badges"
        }
      },
      "result": "Result",
      "table": {
        "badge-tooltip": {
          "acquired": "Acquired",
          "unacquired": "Unacquired"
        },
        "caption": "This table lists the participants who have shared their results. For each participant, it shows their surname, first name and elements of results.",
        "column": {
          "ariaSharedResultCount": "Number of sent results",
          "badges": "Badges",
          "evolution": "Evolution",
          "first-name": "First name",
          "last-name": "Last name",
          "results": {
            "label": "Success rate",
            "on-hold": "Pending",
            "under-test": "Test in progress"
          },
          "sharedResultCount": "No of sent results"
        },
        "empty": "No participants",
        "evolution": {
          "decrease": "In decline",
          "increase": "In progress",
          "stable": "Constant",
          "unavailable": "Not available"
        },
        "evolution-tooltip": {
          "content": "Evolution of the participant between their last two shared results."
        },
        "title": "List of submitted results"
      },
      "tested-items": "Items assessed",
      "title": "Results",
      "validated-items": "Items successfully completed"
    },
    "campaign-review": {
      "description": "According to the target profile selected and the results of your campaign, Pix recommends focusing on the following topics, sorted by relevance {bubble}.",
      "sub-table": {
        "column": {
          "source": {
            "value": "By {source}"
          }
        },
        "title": "{count, plural, =1 {1 tutorial} other{{count} tutorials}} recommended by the Pix community"
      },
      "sub-title": "Recommendations of topics to focus on",
      "table": {
        "analysis": {
          "caption": "Table of topics to work on, sorted by relevance. Some have additional columns showing the number of tutorials that exist related to the topic and how to access these tutorials",
          "column": {
            "relevance": {
              "ariaLabelDefaultSort": "The array is not yet sorted by relevance. Click to sort ascending.",
              "ariaLabelSortDown": "The array is sorted by descending relevance. Click to sort ascending.",
              "ariaLabelSortUp": "The array is sorted by ascending relevance. Click to sort descending.",
              "label": "Relevance"
            },
            "subjects": "Topics ({count, plural, =0 {-} other {{count}}})",
            "tutorial": {
              "aria-label": "Show all tutorials"
            },
            "tutorial-count": {
              "aria-label": "Number of recommended tutorials",
              "value": "{count, plural, =1 {1 tutorial} other {{count} tutorials}}"
            }
          },
          "recommendations": {
            "moderately-recommended": "Moderately recommended",
            "recommended": "Recommended",
            "strongly-recommended": "Strongly recommended",
            "very-strongly-recommended": "Very strongly recommended"
          }
        },
        "competences": {
          "column": {
            "competences": "Competences ({count})",
            "results": {
              "label": "Results",
              "tooltip": "'<span class=\"screen-reader-only\">'Participants have validated'</span>' {result} % '<span class=\"screen-reader-only\">'of the competence {competence}.'</span>'"
            }
          },
          "title": "Results by competence"
        },
        "empty": "Pending results"
      },
      "title": "Review"
    },
    "campaign-settings": {
      "actions": {
        "archive": "Archive",
        "duplicate": "Duplicate",
        "edit": "Edit"
      },
      "campaign-type": {
        "assessment": "Assessment campaign",
        "exam": "Questioning campaign [beta]",
        "profiles-collection": "Profiles collection campaign",
        "title": "Type of campaign"
      },
      "direct-link": "Direct link",
      "external-user-id-label": "External user ID label",
      "external-user-id-types": {
        "email": "Email",
        "string": "Other"
      },
      "landing-page-text": "Text to display on the starting page",
      "multiple-sendings": {
        "status": {
          "disabled": "No",
          "enabled": "Yes"
        },
        "title": "Multiple Sendings",
        "tooltip": {
          "aria-label": "Description of multiple sendings",
          "text": "If you choose to allow multiple submissions, the participants will be able to submit their participation several times by re-entering the campaign code. Within Pix Orga you will find the latest sent."
        }
      },
      "personalised-test-title": "Title of the customised test",
      "reset-to-zero": {
        "status": {
          "disabled": "No",
          "enabled": "Yes"
        },
        "title": "Reset to zero",
        "tooltip": {
          "aria-label": "Description of Reset to zero",
          "text": "If the reset to zero function is activated, the participant can reset the entire customised test and submit their results multiple times by re-entering the campaign code."
        }
      },
      "target-profile": {
        "title": "Customised test",
        "tooltip": "Customised test's description"
      },
      "title": "Settings"
    },
    "campaigns-list": {
      "action": {
        "campaign": {
          "archived": "Archived",
          "label": "Show on ongoing or archived campaigns",
          "ongoing": "Ongoing"
        },
        "create": "Create a campaign"
      },
      "action-bar": {
        "delete-button": "Delete",
        "error-message": "{count, plural, =1 {An error has occurred. the campaign has not been deleted from the list.} other {An error has occurred. The {count} selected campaigns have not been deleted from the list}}",
        "information": "{count, plural, =1 {{count} selected campaign} other {{count} selected campaigns}}",
        "success-message": "{count, plural, =1 {The campaign (and the results) has successfully been deleted from the list.} other {The {count} selected campaigns (and the results) have successfully been deleted from the list.}}"
      },
      "deletion-modal": {
        "confirmation-checkbox": "I confirm that I have understood the impacts of the {count} deletions",
        "content": {
          "footer": "Please note that this action is irreversible.",
          "header": "{count, plural, =1 {This campaign} other {These campaigns}} will no longer be visible in Pix Orga.",
          "main-participation-prevent": "All campaign entries and results will be deleted."
        },
        "title": "{count, plural, =1 {Are you sure you want to delete the selected campaign?} other {Are you sure you want to delete '<strong>'{count}'</strong>' campaigns?}}"
      },
      "filter": {
        "by-name": "Search for a campaign",
        "by-owner": "Search for an owner",
        "legend": "Filters for the campaigns table, input fields allow to filter the table by campaign name and/or by owner name. Buttons allow to switch between ongoing and archived campaigns.",
        "results": "{total, plural, =0 {0 campaigns} =1 {1 campaign} other {{total, number} campaigns}}"
      },
      "navigation": "Navigation in the Campaign section",
      "no-campaign": "No campaign. To start, click on 'Create a campaign'.",
      "table": {
        "column": {
          "code": "Code",
          "created-by": "Owner",
          "created-on": "Created on",
          "mainCheckbox": "Select/Unselect whole column",
          "name": "Name of the campaign",
          "participants": "Participants",
          "results": "Results submitted"
        },
        "description-all-campaigns": "This is the list of all the campaigns created in you Pix Orga. It includes their code, their owner name, creation date, number of participants and number of received results.",
        "description-my-campaigns": "This is the list of the campaigns you own. It includes their code, their creation date, number of participants and number of received results.",
        "empty": "No campaign"
      },
      "tabs": {
        "all-campaigns": "All the campaigns",
        "my-campaigns": "My campaigns"
      },
      "title": "Campaigns"
    },
    "certifications": {
      "description": "Please select the class for which you would like to export the certification results (.csv) or download certificates (.pdf).",
      "documentation-link": "https://cloud.pix.fr/s/dqCoeH8q4fjWZjq",
      "documentation-link-label": "Interpreting the results",
      "documentation-link-notice": "Follow this link to find indications on how to interpret the results: ",
      "download-attestations-button": "Download certificates",
      "download-button": "Export the results",
      "errors": {
        "invalid-division": "The class {selectedDivision} does not exist.",
        "no-certificates": "No certificates for the class {selectedDivision}.",
        "no-results": "No certification results for the class {selectedDivision}."
      },
      "no-students-imported-yet": "In this tab, you will find the certification results and certificates of the students. You will first need to import the students database of your school.",
      "select-label": "Class",
      "title": "Certification results"
    },
    "join-request-form": {
      "firstname": "Votre prénom",
      "lastname": "Votre nom",
      "legal-information": {
        "link-text": "En savoir plus sur mes droits.",
        "link-url": "https://pix.fr/dp-formulaire-recuperation-pixorga-sco",
        "text": "Les informations recueillies sur ce formulaire sont enregistrées dans un fichier informatisé par le GIP Pix pour le compte du ministère de l’Éducation nationale en tant que responsable de traitement, pour permettre à votre établissement scolaire d’accéder à son espace Pix Orga en lui envoyant une invitation à rejoindre cet espace."
      },
      "organization-code": "UAI/RNE de l'établissement"
    },
    "login": {
      "choose-language-aria-label": "Select a language",
      "title": "Log in"
    },
    "login-form": {
      "active-or-retrieve": "Are you a headteacher? Activate or become the administrator of your school's Pix Orga space",
      "email": "Email address",
      "errors": {
        "empty-password": "Your password can't be empty.",
        "invalid-email": "Your email address is invalid.",
        "should-change-password": "You currently have a temporary password. '<'a href=\"{url}\"'>'Reset your password here'</a>'.",
        "status": {
          "403": "Access to this Pix Orga space is limited to invited members. Each Pix Orga space is managed by an administrator specific to the organisation using it. Please contact your administrator to get invited.",
          "404": "There was an error in the email address or password entered.",
          "409": "This invitation has been already accepted or cancelled."
        }
      },
      "forgot-password": "Forgot your password?",
      "invitation-already-accepted": "This invitation has already been accepted. Please log in or contact the administrator of your Pix Orga space.",
      "invitation-was-cancelled": "This invitation is no longer valid. Please contact the administrator of your Pix Orga space.",
      "is-only-accessible": "Pix Orga is only accessible to invited members. Please contact your Pix Orga administrator in order to be invited.",
      "login": "Log in",
      "only-for-admin": "only for school administrations",
      "password": "Password"
    },
    "login-or-register": {
      "login-form": {
        "button": "Log in",
        "title": "Already have a PIX account?"
      },
      "register-form": {
        "button": "Sign up",
        "errors": {
          "default": "The service is temporarily unavailable. Please try again later.",
          "email-already-exists": "This email address is already registered, please login.",
          "invalid-or-already-used-email": "Invalid or already used e-mail address"
        },
        "fields": {
          "button": {
            "label": "Sign up"
          },
          "cgu": {
            "accept": "I accept the",
            "and": "and",
            "aria-label": "I accept the terms of use and personal data protection policy of Pix",
            "data-protection-policy": "personal data protection policy",
            "error": "You must accept to the Pix terms of use and personal data protection policy to create an account.",
            "terms-of-use": "Pix terms of use"
          },
          "email": {
            "error": "Please enter a valid email address.",
            "label": "Email address"
          },
          "first-name": {
            "error": "Please enter a first name.",
            "label": "First name"
          },
          "last-name": {
            "error": "Please enter a last name.",
            "label": "Last name"
          },
          "password": {
            "error": "Your password must contain at least 8 characters and include at least one uppercase letter, one lowercase letter and one number.",
            "label": "Password"
          }
        },
        "title": "Sign up"
      },
      "title": "You have been invited to join the organisation {organizationName}"
    },
    "missions": {
      "list": {
        "actions": {
          "see-mission-details": "See details"
        },
        "aria-label": "Mission",
        "banner": {
          "copypaste-container": {
            "abstract": "Start your missions with your students by activating a session with the above button and using this ",
            "button": {
              "success": "copied !",
              "tooltip": "copy code"
            }
          },
          "hint": "Feel free to bookmark it on your posts.",
          "import-text": "school link",
          "step1": {
            "admin": {
              "head": "Step 1 : <b>Please</b>",
              "link": "import the student database",
              "tail": "<b>from Onde</b> (exportable file in the Lists & documents Extractions > School students or their supervisors menu <b>by selecting cycle 3 pupils only</b>)."
            },
            "non-admin": "Step1 : <b>Ask the Pix Orga administrator</b> in your area to import students"
          },
          "step2": {
            "option1": "use the&nbsp'<'a href=\"{pixJuniorUrl}\"'>'junior.pix.fr'</a>'&nbsplink. You will be asked for your school's code each time you connect.",
            "option2": {
              "body": "or use the direct link &nbsp'<'a href=\"{pixJuniorUrl}\" target=_blank '>'junior.pix.fr/schools/{code}'</a>'",
              "hint": "You can save this bookmark on your computers."
            },
            "title": "Step 2 : To enable pupils to access your school's Pix Junior space, you can :"
          },
          "step3": "Step 3 : <b> Activate the Pix Junior session </b> using the button in the sidebar. <b>You should do this before each session with your pupils</b>.",
          "welcome": "Starting to use Pix Junior :"
        },
        "caption": "List of missions",
        "empty-state": "There is not any mission",
        "headers": {
          "actions": "Actions",
          "competences": "Targeted DigComp competence",
          "name": "Mission",
          "started-by": "Started by"
        },
        "no-division": "No division yet",
        "non-admin": {
          "abstract": "To begin, ask your administrator to import the students."
        }
      },
      "mission": {
        "details": {
          "button-label": "See the educational sheet",
          "competence": {
            "title": "Targeted DigComp competence :"
          },
          "objective": {
            "title": "Mission objectives :"
          }
        },
        "table": {
          "activities": {
            "aria-label": "Student",
            "caption": "List of students with their activity for the mission {missionName}",
            "filters": {
              "aria-label": "Filter on students",
              "learners-count": "{count, plural, =0 {No student} =1 {1 student} other {{count} students}}",
              "status": {
                "label": "Mission status"
              }
            },
            "headers": {
              "division": "Division",
              "first-name": "First name",
              "last-name": "Last name",
              "status": "Mission status"
            },
            "mission-status": {
              "completed": "Completed",
              "not-started": "Not started",
              "started": "In progress"
            },
            "no-data": "There is not any participants"
          },
          "result": {
            "aria-label": "Student",
            "caption": "List of students with their result for the mission {missionName}",
            "filters": {
              "aria-label": "Filter on students",
              "global-result": {
                "label": "Mission assessment",
                "options": {
                  "exceeded": "Exceeded",
                  "no-result": "No assessment",
                  "not-reached": "Not reached",
                  "partially-reached": "Partially reached",
                  "reached": "Reached"
                }
              },
              "learners-count": "{count, plural, =0 {No student} =1 {1 student} other {{count} students}}"
            },
            "headers": {
              "dare-challenge": "Dare challenge",
              "division": "Division",
              "first-name": "First name",
              "last-name": "Last name",
              "result": "Mission assessment",
              "step": "Step {number}"
            },
            "mission-dare-result": {
              "not-reached": "NR",
              "reached": "R",
              "undefined": "-"
            },
            "mission-result": {
              "exceeded": "Exceeded",
              "not-reached": "Not reached",
              "partially-reached": "Partially reached",
              "reached": "Reached",
              "undefined": "-"
            },
            "no-data": "There is not any participants",
            "step-result": {
              "not-reached": "NR",
              "partially-reached": "PR",
              "reached": "R",
              "undefined": "-"
            }
          }
        },
        "tabs": {
          "activities": "Activities",
          "aria-label": "Navigation between the activity or results of the mission",
          "results": "Results"
        },
        "title": "Mission's information"
      },
      "title": "Missions"
    },
    "organization-learner": {
      "activity": {
        "assessment-summary": "Customised tests participations summary",
        "cards": {
          "shared": "Submitted: {count}",
          "started": "In progress: {count}",
          "title": {
            "assessment": "Assessments",
            "profiles-collection": "Profile collections"
          },
          "to-share": "Pending: {count}"
        },
        "empty-state": "No activity yet. As soon as {organizationLearnerFirstName} {organizationLearnerLastName} participates in a campaign, you will be able to follow their progress here.",
        "participation-list": {
          "table": {
            "column": {
              "campaign-name": "Campaign",
              "campaign-type": "Type",
              "created-at": "Started on",
              "participation-count": "Number of participations",
              "shared-at": "Sent on",
              "status": "Status"
            }
          }
        },
        "participations-title": "List of all the participations",
        "profile-collection-summary": "Profile collection participations summary",
        "title": "Activity"
      },
      "header": {
        "aria-label-title": "Detail page of {firstName} {lastName}"
      }
    },
    "organization-participant-activity": {
      "title": "Participant activity"
    },
    "organization-participants": {
      "action-bar": {
        "delete-button": "Delete",
        "error-message": "{count, plural, =1 {An error has occurred. {firstname} {lastname} has not been deleted from the participants list.} other {An error has occurred. The {count} selected participants have not been deleted from the list}}",
        "information": "{count, plural, =1 {{count} selected participant} other {{count} selected participants}}",
        "success-message": "{count, plural, =1 {{firstname} {lastname} has successfully been deleted from the participants list.} other {The {count} selected participants have successfully been deleted from the list.}}"
      },
      "deletion-modal": {
        "confirmation-checkbox": "I confirm that I have understood the impacts of the {count} deletions",
        "content": {
          "footer": "Please note that this action is irreversible.",
          "header": "{count, plural, =1 {This participant} other {These participants}} will no longer be visible in Pix Orga.",
          "main-campaign-prevent": "This will have an impact on the results and analytics of your campaigns.",
          "main-participation-prevent": "All their participations to campaigns will be deleted."
        },
        "title": "Delete '<strong>'{count, plural, =1 {{firstname} {lastname}} other {{count}}}'</strong>' {count, plural, =1 {of your} other {selected}} participants?"
      },
      "empty-state": {
        "action": "See my campaigns",
        "call-to-action": "Share with them a link to join an existing campaign or create a new campaign.",
        "message": "No participants yet!"
      },
      "filters": {
        "aria-label": "Filters on participants",
        "participations-count": "{count, plural, =0 {0 participants} =1 {1 participant} other {{count} participants}}",
        "students-count": "{count, plural, =0 {0 students} =1 {1 student} other {{count} students}}",
        "type": {
          "certificability": {
            "label": "Search by certificability",
            "placeholder": "Search by certificability"
          }
        }
      },
      "page-title": "Participants",
      "table": {
        "actions": {
          "disable-oralization": "Deactivate oralization",
          "enable-oralization": "Activate oralization"
        },
        "column": {
          "checkbox": "Select/Unselect {firstname} {lastname}",
          "first-name": "First name",
          "is-certifiable": {
            "label": "Eligibility for certification"
          },
          "last-name": {
            "ariaLabelDefaultSort": "The table is currently not sorted by last name. Click to sort by alphabetical order.",
            "ariaLabelSortDown": "The table is sorted by last name, in reverse alphabetical order. Click to sort by alphabetical order.",
            "ariaLabelSortUp": "The table is sorted by last name, in alphabetical order. Click to sort by reverse alphabetical order.",
            "label": "Last name"
          },
          "latest-participation": {
            "ariaLabelDefaultSort": "The array is not yet sorted by latest participations. Click to sort ascending.",
            "ariaLabelSortDown": "The array is sorted by descending latest participations. Click to sort ascending.",
            "ariaLabelSortUp": "The array is sorted by ascending latest participations. Click to sort descending.",
            "label": "Latest participation"
          },
          "mainCheckbox": "Select/Unselect whole column",
          "participation-count": {
            "ariaLabelDefaultSort": "The array is not yet sorted by number of participations. Click to sort ascending.",
            "ariaLabelSortDown": "The array is sorted by descending number of participations. Click to sort ascending.",
            "ariaLabelSortUp": "The array is sorted by ascending number of participations. Click to sort descending.",
            "label": "Number of participations"
          }
        },
        "description": "Table of participants, sorted by name.",
        "empty": "No participants",
        "oralization-header-tooltip": "Activate “read the instruction” to have the student's oral transcription.",
        "row-value": {
          "oralization": {
            "false": "Deactivated",
            "true": "Activated"
          }
        }
      }
    },
    "organization-participants-import": {
      "actions": {
        "add-sup": {
          "details": "Add a list of students to the one already imported and/or edit the information of students already imported.",
          "label": "Add students",
          "title": "Add / Edit"
        },
        "participants": {
          "details": "This action allows you to :",
          "details-add": "add new participants",
          "details-disable": "deactivate old participants",
          "details-update": "edit previously imported participants",
          "label": "Import list",
          "title": "Import list of participants"
        },
        "replace": {
          "details": "Import a new list of students in replacement of the existing one.",
          "label": "Overwrite list",
          "title": "Overwrite"
        }
      },
      "banner": {
        "anchor-error": "See the list of errors",
        "fix-error-text": "Please correct them and import the file again.",
        "import-error": "The import of participants has failed.",
        "import-in-progress": "The content of the file has been validated and the participants are now being imported in PixOrga.",
        "in-progress-text": "Please refresh this page in a few moments to see the status of the file.",
        "retry-error-text": "An error has occurred, please import later or write to Pix support",
        "upload-completed": "The file was imported on {date} by {firstName} {lastName}.",
        "upload-error": "The file could not be imported.",
        "upload-in-progress": "It may take a few minutes to import the file. Please do not leave this page.",
        "validation-error": "The file content contains errors.",
        "validation-in-progress": "The contents of the file are currently being validated.",
        "warning-banner": "However some values were not recognised. They have been replaced by \"Not recognised\". If you need other values, please contact us at '<a href=\"mailto:sup@pix.fr\">'sup@pix.fr'</a></div>'"
      },
      "error-panel": {
        "error-wrapper": "Import has failed. Please check or edit your file and try to import it again.",
        "global-error": "Import has failed. Please try again or contact us through '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://pix.org/en/contact-form\">'the help form'</a>'.",
        "title": "Errors in the last file imported :"
      },
      "file-type-separator": " or ",
      "global-success": "Last file successfully imported on {date} by {firstName} {lastName}.",
      "sco": {
        "title": "Import students"
      },
      "sup": {
        "title": "Import students"
      },
      "supported-formats": "(supported format: {types})",
      "title": "Import participants",
      "warnings": {
        "diploma": "Diplomas unknown: {diplomas}; ",
        "study-scheme": "Study schemes unknown: {studySchemes}; "
      }
    },
    "participants-list": {
      "latest-participation-information-tooltip": {
        "aria-label": "Latest participation's information",
        "campaign-ASSESSMENT-type": "Assessment",
        "campaign-PROFILES_COLLECTION-type": "Profiles collection",
        "campaign-name": "Campaign:",
        "campaign-status": "Status: ",
        "campaign-type": "Type: ",
        "participation-SHARED-status": "Submitted",
        "participation-STARTED-status": "In progress",
        "participation-TO_SHARE-status": "Pending"
      }
    },
    "places": {
      "before-date": "on",
      "places-lots": {
        "statuses": {
          "active": "Active",
          "expired": "Expired",
          "pending": "Pending"
        },
        "table": {
          "caption": "Table listing your organisation's seat purchases. For each purchase, it shows: the number of tickets, the activation date, the expiry date and the status (active, coming soon or expired). It is ordered according to the status of the purchases and their expiry date.",
          "empty-state": "No seats yet!",
          "headers": {
            "activation-date": "Activation date",
            "count": "Seats count",
            "expiration-date": "Expiration date",
            "status": "Status"
          },
          "title": "Seats purchase history"
        }
      },
      "title": "Seats"
    },
    "preselect-target-profile": {
      "download": "Download topics selection ({ numberOfTubesSelected }) (JSON, { fileSize }kB)",
      "download-filename": "topic-selection-{ organizationName }-{ date }.json",
      "no-tube-selected": "Download topics selection (JSON, { fileSize }kB)",
      "table": {
        "caption": "Topic selection",
        "column": {
          "action": "Select",
          "mobile": "Mobile compliant",
          "name": "Topic name",
          "tablet": "Tablet compliant",
          "theme-name": "Theme name"
        },
        "is-responsive": "yes",
        "not-responsive": "no",
        "row-title": "Topic"
      },
      "title": "Topic selection"
    },
    "profiles-individual-results": {
      "breadcrumb-current-page-label": "Participation of {firstName} {lastName}",
      "certifiable": "Eligible for certification",
      "competences-certifiables": "COMP. ELIGIBLE FOR CERTIFICATION",
      "pix": "PIX",
      "pix-score": "{score, number}",
      "table": {
        "column": {
          "level": "Level",
          "pix-score": "Pix score",
          "skill": "Competence"
        },
        "empty": "Pending results",
        "title": "Results by competence"
      },
      "title": "Profile of {firstName} {lastName}"
    },
    "profiles-list": {
      "table": {
        "caption": "This table contains the list of participants who have shared their profiles. It indicates for each participant their last name, first name, the sent date, the Pix score, the evolution, the certifiability status and the number of certifiable competences.",
        "column": {
          "ariaSharedProfileCount": "Number of profiles shared",
          "certifiable": "Eligible for certification",
          "certifiable-tag": "Eligible",
          "competences-certifiables": "Competences eligible for certification",
          "evolution": "Evolution",
          "first-name": "First name",
          "last-name": "Last name",
          "pix-score": {
            "label": "Pix score",
            "value": "{score, number}"
          },
          "sending-date": {
            "label": "Sent on",
            "on-hold": "Pending"
          },
          "sharedProfileCount": "No. profiles shared"
        },
        "empty": "No profiles yet",
        "evolution": {
          "decrease": "In decline",
          "increase": "In progress",
          "stable": "Constant",
          "unavailable": "Not available"
        },
        "evolution-tooltip": {
          "content": "Evolution of the pix score between the last two profile shares."
        },
        "title": "List of submitted profiles"
      },
      "title": "Submitted profiles"
    },
    "sco-organization-participant-activity": {
      "title": "Student activity"
    },
    "sco-organization-participants": {
      "action-bar": {
        "generate-username-password-button": "Generate logins and/or passwords for selected students",
        "information": "{count, plural, =1 {{count} student selected} other {{count} students selected}}",
        "reset-password-button": "Reset passwords for selected students"
      },
      "actions": {
        "manage-account": "Manage the account",
        "show-actions": "Show actions"
      },
      "connection-types": {
        "email": "Email address",
        "empty": "–",
        "identifiant": "Username",
        "mediacentre": "Mediacentre",
        "none": "None",
        "without-mediacentre": "Without Mediacentre"
      },
      "filter": {
        "aria-label": "Filters on students",
        "certificability": {
          "label": "Search by certificability",
          "placeholder": "Search by certificability"
        },
        "division": {
          "empty": "No class",
          "label": "Search by class"
        },
        "first-name": {
          "label": "Search by first name"
        },
        "last-name": {
          "label": "Search by last name"
        },
        "login-method": {
          "empty-option": "Log in method",
          "label": "Search by log in method"
        },
        "students-count": "{count, plural, =0 {0 students} =1 {1 student} other {{count} students}}"
      },
      "generate-username-password-modal": {
        "content-message-1": "Students who do not yet have a login method must go through a campaign at your school to create their PIX account.",
        "content-message-2": "A CSV file containing login details and one-time passwords will be generated.",
        "content-message-3": "Give these new one-time passwords to the students. When they log in with this password, Pix will ask them to enter a new one.",
        "title": "Generate logins and/or passwords for selected students",
        "warning-message": "A login and password will be generated for students who have access to the Mediacentre and/or an e-mail address. Students who already have a login will have their password reset."
      },
      "manage-authentication-method-modal": {
        "authentication-methods": "Log in methods",
        "copied": "Copied!",
        "error": {
          "default": "An error occurred, our teams are working on finding a solution. Please try again later.",
          "unexpected": "Something went wrong. Please try again."
        },
        "section": {
          "add-username": {
            "button": "Add a username",
            "label": "Add a username log in method"
          },
          "email": {
            "copy": "Copy the email address",
            "label": "Email address"
          },
          "mediacentre": {
            "label": "Mediacentre"
          },
          "password": {
            "copy": "Copy the temporary password",
            "label": "New temporary password",
            "warning-1": "Send this new temporary password to your student.",
            "warning-2": "Your student will be able to log in with the temporary password.",
            "warning-3": "Your student will choose a new password."
          },
          "reset-password": {
            "button": "Reset password",
            "warning": "Resetting will delete the student’s current password."
          },
          "username": {
            "copy": "Copy the username",
            "label": "Username"
          }
        },
        "title": "Managing the student's Pix account"
      },
      "messages": {
        "password-reset-success": "The password reset of the selected students has been done successfuly."
      },
      "no-participants": "No students yet!",
      "no-participants-action": "The administrator must import the students database by clicking on the import button.",
      "page-title": "Students",
      "reset-password-modal": {
        "content-message-1": "Sur {totalSelectedStudents, plural, =1 {<strong>{totalSelectedStudents} élève</strong>} other {<strong>{totalSelectedStudents} élèves</strong>}} que vous avez sélectionné, {totalAffectedStudents, plural, =0 {<strong>aucun mot de passe</strong> sera réinitialisé} =1 {le mot de passe de <strong>{totalAffectedStudents} élève</strong> va être réinitialisé.} other {les mots de passe de <strong>{totalAffectedStudents} élèves</strong> vont être réinitialisé.}}",
        "content-message-2": "Un fichier CSV sera généré contenant les identifiants ainsi que les mots de passe à usage unique.",
        "content-message-3": "Communiquez ces nouveaux mots de passe à usage unique aux élèves. Lorsqu'ils se connecteront avec ce mot de passe, Pix leur demandera d'en saisir un nouveau.",
        "title": "Réinitialisation des <strong>mots de passe</strong> des élèves avec <strong>identifiant</strong>",
        "warning-message": "Seuls les mots de passe des accès par identifiants peuvent être réinitialisés. Les accès par adresse email et Mediacentre ne seront pas impactés."
      },
      "table": {
        "column": {
          "checkbox": "Select/Unselect {firstname} {lastname}",
          "date-of-birth": "Date of birth",
          "division": {
            "ariaLabelDefaultSort": "The table is currently not sorted by class. Click to sort by alphanumeric order.",
            "ariaLabelSortDown": "The table is sorted by class, in reverse alphanumeric order. Click to sort by alphanumeric order.",
            "ariaLabelSortUp": "The table is sorted by class, in alphanumeric order. Click to sort by reverse alphanumeric order.",
            "label": "Class"
          },
          "first-name": "First name",
          "is-certifiable": {
            "eligible": "Eligible",
            "label": "Eligibility for certification",
            "non-eligible": "Non-eligible",
            "not-available": "Unavailable"
          },
          "last-name": {
            "ariaLabelDefaultSort": "The table is currently not sorted by last name. Click to sort by alphabetical order.",
            "ariaLabelSortDown": "The table is sorted by last name, in reverse alphabetical order. Click to sort by alphabetical order.",
            "ariaLabelSortUp": "The table is sorted by last name, in alphabetical order. Click to sort by reverse alphabetical order.",
            "label": "Last name"
          },
          "last-participation-date": "Latest participation",
          "login-method": "Log in method(s)",
          "mainCheckbox": "Select/Unselect whole column",
          "participation-count": {
            "ariaLabelDefaultSort": "The array is not yet sorted by number of participations. Click to sort ascending.",
            "ariaLabelSortDown": "The array is sorted by descending number of participations. Click to sort ascending.",
            "ariaLabelSortUp": "The array is sorted by ascending number of participations. Click to sort descending.",
            "label": "Number of participations"
          }
        },
        "description": "Table of students, sorted by name. For students who have provided an authentication method, you can manage the allowed login modes and reset the student's password through a menu in 'Actions' column",
        "empty": "No students."
      },
      "title": "{count, plural, =0 {Students} =1 {Student ({count})} other {Students ({count})}}"
    },
    "statistics": {
      "before-date": "on",
      "description": "The table below shows how your participants are positioned by subject.'<br>' Positioning reflects the average level of your participants in relation to the maximum level they could have reached.'<br>' This data takes into account all participations shared as part of your organisation's evaluation campaigns that have not been deleted.",
      "empty-state": "No data available",
      "level": {
        "advanced": "Advanced",
        "expert": "Expert",
        "independent": "Independent",
        "novice": "Novice"
      },
      "select-label": "Domain",
      "table": {
        "caption": "This table displays the analysis of all participants' results by topic. For each line, it shows the skill, the topic, the coverage rate and the level achieved.",
        "headers": {
          "competences": "Competences",
          "positioning": "Positioning",
          "reached-level": "Reached level",
          "topics": "Topics"
        }
      },
      "title": "Statistics"
    },
    "sup-organization-participant-activity": {
      "title": "Student activity"
    },
    "sup-organization-participants": {
      "action-bar": {
        "delete-button": "Delete",
        "error-message": "{count, plural, =1 {An error has occurred. {firstname} {lastname} has not been deleted from the students list.} other {An error has occurred. The {count} selected students have not been deleted from the list}}",
        "information": "{count, plural, =1 {{count} selected student} other {{count} selected students}}",
        "success-message": "{count, plural, =1 {{firstname} {lastname} has successfully been deleted from the students list.} other {The {count} selected students have successfully been deleted from the list.}}"
      },
      "actions": {
        "download-template": "Download the template",
        "edit-student-number": "Edit the student number",
        "show-actions": "Show actions"
      },
      "deletion-modal": {
        "content": {
          "footer": "Please note that this action is irreversible.",
          "header": "{count, plural, =1 {This student} other {These students}} will no longer be visible in Pix Orga.",
          "main-campaign-prevent": "This will have an impact on the results and analytics of your campaigns.",
          "main-participation-prevent": "All their participations to campaigns will be deleted."
        },
        "title": "Delete '<strong>'{count, plural, =1 {{firstname} {lastname}} other {{count}}}'</strong>' {count, plural, =1 {of your} other {selected}} students?"
      },
      "edit-student-number-modal": {
        "actions": {
          "update": "Update"
        },
        "form": {
          "error": "The student number can't be empty",
          "new-student-number-label": "New student number",
          "student-number": "{firstName} {lastName}'s current student number is: ",
          "success": "{firstName} {lastName}'s student number has been successfully edited."
        },
        "title": "Edit a student number"
      },
      "empty-state": {
        "no-participants": "No students yet!",
        "no-participants-action": "The administrator must import the students database by clicking on the import button."
      },
      "filter": {
        "aria-label": "Filters on students",
        "certificability": {
          "label": "Search by certificability",
          "placeholder": "Search by certificability"
        },
        "group": {
          "empty": "No group",
          "label": "Enter a group",
          "placeholder": "Search by group"
        },
        "student-number": {
          "label": "Enter a student number",
          "placeholder": "Search by student number"
        },
        "students-count": "{count, plural, =0 {0 students} =1 {1 student} other {{count} students}}"
      },
      "page-title": "Students",
      "replace-students-modal": {
        "confirm": "Yes, overwrite",
        "confirmation-checkbox": "I have fully understood the effect of this action",
        "footer-content": "Existing students in the application and included in the new import will not be deleted and will be updated if necessary.",
        "last-warning": "Please note that this action is irreversible, students who are not included in the new import will be deleted from Pix Orga.",
        "main-content": "All of their campaign participations will be deleted. This will have an impact on the results and analytics of your campaigns. They will no longer be able to take part in any previous campaigns. However, they will still be able to take part in new campaigns.",
        "title": "Are you sure you want to overwrite the existing students?"
      },
      "table": {
        "column": {
          "date-of-birth": "Date of birth",
          "first-name": "First name",
          "group": "Groups",
          "is-certifiable": {
            "label": "Eligibility for certification"
          },
          "last-name": {
            "ariaLabelDefaultSort": "The table is currently not sorted by last name. Click to sort by alphabetical order.",
            "ariaLabelSortDown": "The table is sorted by last name, in reverse alphabetical order. Click to sort by alphabetical order.",
            "ariaLabelSortUp": "The table is sorted by last name, in alphabetical order. Click to sort by reverse alphabetical order.",
            "label": "Last name"
          },
          "last-participation-date": "Latest participation",
          "participation-count": {
            "ariaLabelDefaultSort": "The array is not yet sorted by number of participations. Click to sort ascending.",
            "ariaLabelSortDown": "The array is sorted by descending number of participations. Click to sort ascending.",
            "ariaLabelSortUp": "The array is sorted by ascending number of participations. Click to sort descending.",
            "label": "Number of participations"
          },
          "student-number": "Student number"
        },
        "description": "Table of students, sorted by name.You can edit the student's number through a menu in an additional column",
        "empty": "No students."
      },
      "title": "{count, plural, =0 {Students} =1 {Student ({count})} other {Students ({count})}}"
    },
    "team-invitations": {
      "cancel-invitation": "Delete this invitation",
      "invitation-cancelled-succeed-message": "The invitation has been deleted.",
      "invitation-resent-succeed-message": "The invitation has been resent.",
      "resend-invitation": "Resend the invitation",
      "table": {
        "column": {
          "email-address": "Email address",
          "pending-invitation": "Pending invitation"
        },
        "row": {
          "aria-label": "Pending invitation"
        }
      },
      "title": "Team invitations"
    },
    "team-list": {
      "add-member-button": "Invite a member",
      "tabs": {
        "invitation": "Invitations ({count, plural, =0 {-} other {{count}}})",
        "member": "Members ({count, plural, =0 {-} other {{count}}})"
      },
      "title": "Team"
    },
    "team-members": {
      "actions": {
        "edit-organization-membership-role": "Change role",
        "leave-organization": "Leave this Pix Orga space",
        "manage": "Manage",
        "remove-membership": "Remove",
        "save": "Save",
        "select-role": {
          "label": "Select a role",
          "options": {
            "admin": "Administrator",
            "member": "Member"
          }
        }
      },
      "modals": {
        "leave-organization": {
          "message": "Are you sure you want to leave this Pix Orga space? You will no longer have access to <strong>{organizationName}</strong>.<br/><br/>Your campaigns remain accessible to the rest of the team and will not be archived.<br/><br/>Your access to other Pix Orga spaces will not be affected.<br/><br/>You'll be disconnected.",
          "title": "Leave this Pix Orga space"
        }
      },
      "notifications": {
        "change-member-role": {
          "error": "An error occurred while changing this member's role.",
          "success": "The role has been changed."
        },
        "leave-organization": {
          "error": "An error has occurred while deactivating the member.",
          "success": "You have been successfully removed from the organisation {organizationName}. You will be disconnected from Pix Orga..."
        },
        "remove-membership": {
          "error": "An error occurred while removing this member.",
          "success": "{memberFirstName} {memberLastName} has successfully been removed from your Pix Orga team."
        }
      },
      "remove-membership-modal": {
        "actions": {
          "remove": "Yes, remove the member"
        },
        "message": "{memberFirstName} {memberLastName} will no longer have access to this Pix Orga space.'<br>'The campaigns created by this member will still be accessible to the rest of the team.",
        "title": "Are you sure you want to remove this member?"
      },
      "table": {
        "column": {
          "first-name": "First name",
          "last-name": "Last name",
          "organization-membership-role": "Role"
        },
        "empty": "No members yet"
      },
      "title": "Team members"
    },
    "team-new": {
      "email-requirement": "Enter here the email address of the member you want to invite.",
      "errors": {
        "default": "The service is temporarily unavailable. Please try again later.",
        "invalid-input": "The data entered was not in the correct format",
        "mandatory-email-field": "This field is mandatory",
        "sending-email-to-invalid-email-address": "Sending email to the address {email} failed. The sending server replied: \"{errorMessage}\".",
        "status": {
          "400": "The email address format is invalid.",
          "404": "This email address doesn't match any Pix user.",
          "412": "This member has already been added.",
          "500": "Something went wrong. Please try again."
        }
      },
      "invite-form-modal": {
        "confirm": "Confirm",
        "question": "Do you want to continue? ",
        "title": "Confirm the addition of new team members",
        "warning": "Members you add will have access to participant results and campaign analytics."
      },
      "invited-members": "By clicking on the link provided in the invitation, the invited members will be able to create an account or log in with an existing Pix account.",
      "several-email-requirement": "Invite several members by separating the email addresses with commas.",
      "success": {
        "invitation": "An invitation has been sent to the email address {email}.",
        "multiple-invitations": "An invitation has been sent to the listed email addresses."
      },
      "title": "Invite a member",
      "warning": "The members you add below will have access to participant results and campaign analysis. Please ensure that the people you invite are members of your organisation."
    },
    "team-new-item": {
      "input-label": "Email address(es)",
      "invite-button": "Invite"
    },
    "terms-of-service": {
      "accept": "I accept the terms and conditions",
      "title": "Terms and conditions of use"
    }
  }
}], ["fr", {
  "api-error-messages": {
    "campaign-creation": {
      "custom-landing-page_too_long": "Le texte de présentation de la campagne est trop long.",
      "external-user-id-required": "Veuillez préciser le libellé du champ qui sera demandé à vos participants au démarrage du parcours.",
      "id-pix-type-required": "Veuillez sélectionnez un type d'identifiant externe.",
      "name-required": "Veuillez donner un nom à votre campagne.",
      "owner_not_in_organization": "Le propriétaire ne fait pas partie de l'organisation.",
      "purpose-required": "Veuillez choisir l’objectif de votre campagne : Évaluation ou Collecte de profils.",
      "target-profile-required": "Veuillez sélectionner un parcours pour votre campagne.",
      "title_too_long": "Le titre de la campagne est trop long."
    },
    "csv-import": {
      "property-not-uniq": "Ligne {line} : Le champ “{field}” doit être unique au sein du fichier."
    },
    "default": "Le service est momentanément indisponible. Veuillez réessayer ultérieurement.",
    "edit-student-number": {
      "student-number-exists": "Le numéro étudiant saisi est déjà utilisé par l’étudiant {firstName} {lastName}"
    },
    "global": "Une erreur est survenue. Veuillez réessayer ultérieurement.",
    "or-separator": " ou ",
    "student-csv-import": {
      "bad-csv-format": "Le fichier doit être au format csv avec séparateur virgule ou point-virgule.",
      "encoding-not-supported": "Encodage du fichier non supporté.",
      "field-bad-values": "Ligne {line} : Le champ “{field}” doit être “{valids}”.",
      "field-date-format": "Ligne {line} : Le champ “{field}” doit être au format “{acceptedFormat}”.",
      "field-email-format": "Ligne {line} : Le champ “{field}” doit être une adresse email valide.",
      "field-length": "Ligne {line} : Le champ “{field}” doit faire {limit} caractères.",
      "field-max-length": "Ligne {line} : Le champ “{field}” doit être inférieur à {limit} caractères.",
      "field-min-length": "Ligne {line} : Le champ “{field}” doit être d’au moins {limit} caractères.",
      "field-required": "Ligne {line} : Le champ “{field}” est obligatoire.",
      "header-required": "La colonne “{field}” est obligatoire.",
      "header-unknown": "Les entêtes de colonnes doivent être identiques à celles du modèle.",
      "identifier-unique": "Ligne {line} : Le champ “{field}” de cette ligne est présent plusieurs fois dans le fichier.",
      "insee-code-invalid": "Ligne {line} : Le champ “{field}” n'est pas au format INSEE.",
      "payload-too-large": "La taille du fichier doit être inférieure à {maxSize}Mo.",
      "student-number-format": "Ligne {line} : Le champ “{field}” ne doit pas avoir de caractères spéciaux.",
      "student-number-unique": "Ligne {line} : Le champ “{field}” doit être unique au sein du fichier."
    },
    "student-password-reset": {
      "organization-learner-does-not-belong-to-organization-error": "Certains des élèves sélectionnés ne figurent plus dans cette organisation.",
      "organization-learner-without-username-error": "Certains des élèves sélectionnés n'ont plus d'identifiant. Veuillez rafraichir la page.",
      "user-does-not-belong-to-organization-error": "Vous n'avez plus les droits pour cette organisation."
    },
    "student-xml-import": {
      "birth-city-code-required-for-french-student": "L'élève ayant pour INE {nationalStudentId} n'a pas de champ code commune de naissance renseigné. Il est obligatoire pour chaque élève né en France.",
      "birthdate-required": "L’élève ayant pour INE {nationalStudentId} n’a pas le champ date de naissance renseigné. Il est obligatoire pour chaque élève.",
      "empty": "Les élèves doivent posséder un INE ainsi qu'une classe.",
      "encoding-not-supported": "Encodage du fichier non supporté.",
      "first-name-required": "L’élève ayant pour INE {nationalStudentId} n’a pas le champ prénom renseigné. Il est obligatoire pour chaque élève.",
      "ine-required": "Le champ INE est obligatoire pour chaque élève.",
      "ine-unique": "L’INE {nationalStudentId} est présent plusieurs fois dans le fichier pour plusieurs élèves.",
      "invalid-birthdate-format": "L’élève ayant pour INE {nationalStudentId} n'a pas le bon format de date de naissance. Il doit être au format 'DD/MM/YYYY'",
      "invalid-file": "Le fichier n’est pas conforme.",
      "invalid-file-extension": "Extension {fileExtension} non supportée.",
      "last-name-required": "L’élève ayant pour INE {nationalStudentId} n’a pas le champ Nom de famille renseigné. Il est obligatoire pour chaque élève.",
      "payload-too-large": "La taille du fichier doit être inférieure à {maxSize}Mo.",
      "sex-code-required": "L’élève ayant pour INE {nationalStudentId} n’a pas le champ sexe renseigné. Il est obligatoire pour chaque élève.",
      "uai-mismatched": "L’UAI du fichier SIECLE ne correspond pas à celui de votre établissement."
    }
  },
  "application": {
    "description": "La plateforme dédiée à l’évaluation et au suivi pédagogique. Votre espace Pix Orga vous permet de lancer une campagne d’évaluation ou de collecte de profils Pix, suivre l’avancement de vos élèves ou apprenants dans une campagne, ou encore accéder à leurs résultats."
  },
  "banners": {
    "certification": {
      "message": "'<strong>'Certifications :'</strong>' n’oubliez pas de '<'a href={documentationLink} class=\"{linkClasses}\" target=\"_blank\" rel=\"noopener noreferrer\"'>'finaliser les sessions dans Pix Certif'</a>' puis de télécharger les certificats via l'onglet “Certifications” avant la rentrée {year}."
    },
    "import": {
      "message": "Les grandes étapes de l’année dans l’enseignement scolaire :",
      "step1a": "Mettre en place&nbsp;: '<'a href='https://cloud.pix.fr/s/WjTnkSbFs9TDcSC' title='Guide télécharger les résultats' class='link link--banner link--bold link--underlined' '>'télécharger les résultats'</a>' de certification et",
      "step1b": "importer",
      "step1c": "la base élèves (admin)",
      "step2": "'<'a href='https://cloud.pix.fr/s/RaPpKjFHNX2kSR4' title='Guide Lancer les parcours de rentrée' class='link link--banner link--bold link--underlined' '>'Créer les campagnes'</a>' (parcours rentrée, 6e, thématiques, disciplinaires, ciblés…).",
      "step3": "Certifier les apprenants. '<'a href='https://cloud.pix.fr/s/2q4c4QT9jGbGbEq' title='Guide Préparer et organiser la certification des élèves' class='link link--banner link--bold link--underlined' '>'En savoir plus sur la nouvelle certification'</a>'."
    },
    "language-availability": {
      "message": "Votre langue n'est pas encore disponible sur Pix Orga. Pour votre confort, l'application sera présentée en anglais. Toute l'équipe de Pix travaille à l'ajout de votre langue."
    },
    "last-places-lot-available": {
      "message": "Attention, vos places arrivent à échéance dans {days, number} jours."
    },
    "maximum-places-exceeded": {
      "message": "<b>Votre organisation n'a plus de places disponibles !</b><br />Pour bénéficier de toutes les fonctionnalités, merci de libérer des places, vous rapprocher de votre représentant Pix ou '<'a href='https://pix.fr/support/form/professionnel-le' title='contactez-nous(France)' class=\"{linkClasses}\" '>contactez-nous via ce formulaire</a>'. <br />Si vous êtes une organisation hors France '<'a href='https://pix.org/fr/support/form/contactez-le-support-pix' title='contactez-nous (hors France)' class=\"{linkClasses}\" '>contactez-nous via ce formulaire</a>'."
    },
    "over-capacity": {
      "message": "Attention, vous consommez plus de places que votre capacité totale."
    },
    "survey": {
      "message": "Aidez Pix à faire évoluer Pix Orga en répondant à cette courte enquête sur vos usages des campagnes ! '<'a href={documentationLink} class=\"{linkClasses}\" target=\"_blank\" rel=\"noopener noreferrer\"'>'Accédez à l’enquête'</a>'"
    }
  },
  "cards": {
    "available-seats-count": {
      "title": "Places disponibles",
      "value": "/{total} places"
    },
    "badges-acquisitions": {
      "information": "Retrouvez ici le nombre de Badges obtenus par vos participants dans cette campagne ainsi que leur pourcentage d’obtention. ",
      "obtained": "obtenus",
      "title": "Badges"
    },
    "occupied-seats-count": {
      "anonymous": "dont {count, plural, =1 {1 place} other {{count, number} places}} avec un accès sans compte",
      "title": "Places occupées",
      "value": "/{total} places"
    },
    "participants-average-results": {
      "information": "Retrouvez ici la moyenne des résultats de votre campagne. Ce nombre comprend l'ensemble des participants ayant fini leur parcours et envoyé leur résultat.",
      "title": "Résultat moyen"
    },
    "participants-average-stages": {
      "information": "Retrouvez ici le palier moyen de votre campagne. Ce nombre comprend l'ensemble des participants ayant fini leur parcours et envoyé leur résultat.",
      "title": "Palier moyen"
    },
    "participants-count": {
      "information": "Retrouvez ici le nombre de participants total de votre campagne. Ce nombre comprend l'ensemble des participants ayant saisi le code et commencé leur parcours ou leur envoi de profil.",
      "loader": "Chargement du total de participants",
      "title": "Total de participants"
    },
    "place-info": {
      "with-account": {
        "heading": "'<strong>'Le participant a un compte Pix :'</strong>'",
        "message-description": "Vous pouvez libérer des places en supprimant des participants depuis l'onglet Participants.",
        "message-main": "1 participant ayant au moins une participation à une campagne = 1 place occupée."
      },
      "without-account": {
        "heading": "'<strong>'Le participant n'a pas de compte Pix'</strong>' (campagne avec accès sans compte) :",
        "message-description": "Vous pouvez libérer ces places en supprimant des participations dans la campagne avec accès sans compte concernée ou supprimer la campagne.",
        "message-main": "1 participation sans compte = 1 place occupée."
      }
    },
    "submitted-count": {
      "information": "Retrouvez ici les résultats envoyés par vos participants. Ce nombre comprend l’ensemble des participants ayant terminé et cliqué sur le bouton \"J'envoie mes résultats\" ou \"J'envoie mon profil\".",
      "loader": "Chargement des résultats ou profils reçus",
      "title": "Résultats reçus",
      "title-profiles": "Profils reçus"
    }
  },
  "charts": {
    "participants-by-day": {
      "captions": {
        "shared": "Total de participants par jour ayant envoyé leurs résultats par jour",
        "shared-profile": "Total de participants ayant envoyé leurs profils par jour",
        "started": "Total de participants par jour"
      },
      "labels-a11y": {
        "date": "Date",
        "shared": "Total des participants ayant envoyé leurs résultats",
        "shared-profile": "Total des participants ayant envoyé leurs profils",
        "started": "Total des participants"
      },
      "labels-legend": {
        "shared": "Résultats reçus",
        "shared-profile": "Profils reçus",
        "started": "Total des participants"
      },
      "loader": "Chargement de l'activité des participants",
      "title": "Activité des participants"
    },
    "participants-by-mastery-percentage": {
      "label-a11y": "De {from, number, ::percent} à {to, number, ::percent}: {count, plural, =0 {0 participant} =1 {1 participant} other {{count, number} participants}}",
      "loader": "Chargement de la répartition des participants par résultat",
      "title": "Répartition des participants par résultat",
      "tooltip": {
        "label": "Nombre de participants : {count}",
        "legend": "{from, number, ::percent} - {to, number, ::percent}",
        "title": "Résultats {legend}"
      }
    },
    "participants-by-stage": {
      "loader": "Chargement de la répartition des participants par paliers",
      "participants": "{count, plural, =0 {0 participant} =1 {1 participant} other {{count, number} participants}}",
      "title": "Répartition des participants par paliers"
    },
    "participants-by-status": {
      "a11y-title": "Détail par statut",
      "labels-a11y": {
        "completed": "{count, plural, =0 {0 participant} =1 {1 participant} other {{count, number} participants}} en attente d'envoi",
        "shared": "{count, plural, =0 {0 participant} =1 {1 participant} other {{count, number} participants}} ayant envoyés leurs résultats",
        "shared-profile": "{count, plural, =0 {0 participant} =1 {1 participant} other {{count, number} participants}} ayant envoyés leurs profils",
        "started": "{count, plural, =0 {0 participant} =1 {1 participant} other {{count, number} participants}} en cours de test"
      },
      "labels-legend": {
        "completed-assessment": "En attente d'envoi ({count})",
        "completed-assessment-tooltip": "En attente d’envoi : Ces participants ont terminé leur parcours mais n’ont pas encore envoyé leurs résultats.",
        "completed-profile": "En attente d'envoi ({count})",
        "completed-profile-tooltip": "En attente d’envoi : Ces participants n’ont pas encore envoyé leurs profils.",
        "shared": "Résultats reçus ({count})",
        "shared-profile": "Profils reçus ({count})",
        "shared-profile-tooltip": "Profils reçus : Ces participants ont envoyé leurs profils.",
        "shared-tooltip": "Résultats reçus : Ces participants ont terminé leur parcours et envoyé leurs résultats.",
        "started": "En cours ({count})",
        "started-tooltip": "En cours : Ces participants n’ont pas encore terminé leur parcours."
      },
      "labels-tooltip": {
        "completed-assessment": "En attente d'envoi : {percentage, number, ::percent .0}",
        "completed-profile": "En attente d'envoi : {percentage, number, ::percent .0}",
        "shared": "Résultats reçus : {percentage, number, ::percent .0}",
        "shared-profile": "Profils reçus : {percentage, number, ::percent .0}",
        "started": "En cours : {percentage, number, ::percent .0}"
      },
      "loader": "Chargement des proportions par statut",
      "title": "Statuts"
    }
  },
  "common": {
    "actions": {
      "back": "Retour",
      "cancel": "Annuler",
      "close": "Fermer",
      "confirm": "Confirmer",
      "global": "Actions",
      "link-to-participant": "Voir toute l'activité du participant"
    },
    "api-error-messages": {
      "bad-request-error": "Les données que vous avez soumises ne sont pas au bon format.",
      "gateway-timeout-error": "Le service subit des ralentissements. Veuillez réessayer ultérieurement.",
      "internal-server-error": "Une erreur interne est survenue, nos équipes sont en train de résoudre le problème. Veuillez réessayer ultérieurement.",
      "login-unauthorized-error": "L'adresse e-mail et/ou le mot de passe saisis sont incorrects.",
      "login-user-blocked-error": "Votre compte est bloqué car vous avez effectué trop de tentatives de connexion. Pour le débloquer, '<'a href=\"{url}\"'>'contactez-nous'</a>'.",
      "login-user-temporary-blocked-error": "Vous avez effectué trop de tentatives de connexion. Réessayez plus tard ou cliquez sur '<'a href=\"{url}\"'>'mot de passe oublié'</a>' pour le réinitialiser."
    },
    "breadcrumb": "Fil d'ariane",
    "filters": {
      "actions": {
        "clear": "Effacer les filtres"
      },
      "divisions": {
        "empty": "Aucune classe",
        "label": "Rechercher par classes",
        "placeholder": "Classes"
      },
      "fullname": {
        "label": "Recherche sur le nom et prénom",
        "placeholder": "Nom, prénom"
      },
      "loading": "Chargement...",
      "placeholder": "-- Sélectionner --",
      "title": "Filtres"
    },
    "form": {
      "mandatory-all-fields": "Tous les champs sont obligatoires.",
      "mandatory-fields": "indique un champ obligatoire",
      "mandatory-fields-title": "obligatoire"
    },
    "fullname": "{firstName} {lastName}",
    "help-form": "https://support.pix.fr/support/tickets/new",
    "home-page": "Page d'accueil de Pix Orga",
    "import": {
      "field": {
        "birthdate": "Date de naissance",
        "division": "Classe",
        "oralization": "Lecture de la consigne"
      }
    },
    "loading": "Chargement en cours",
    "no-content": "Aucun contenu",
    "result": {
      "accessibility-description": "Résultat obtenu = {percentage, number, ::percent}, soit le palier {stage} sur {totalStage}",
      "percentage": "{value, number, ::percent}",
      "stages": "{count, plural, =0 {0 étoile} =1 {1 étoile} other {{count, number} étoiles}} sur {total}"
    },
    "target-profile-details": {
      "results": {
        "common": "Résultats affichés en",
        "percent": "pourcentage",
        "star": "étoile"
      },
      "simplified-access": {
        "with-account": "Accès avec compte",
        "without-account": "Accès sans compte"
      },
      "subjects": "Sujets : {value, number}",
      "thematic-results": "Badges : {value, number}"
    }
  },
  "components": {
    "analysis-per-competence": {
      "cover-rate-gauge-label": "Sur la compétence vos participants ont obtenu un niveau de {reachedLevel} sur un niveau maximum atteignable de {maxLevel}.",
      "description": "Ci-dessous, retrouvez les compétences de la campagne et leurs descriptifs ainsi que le positionnement des participants.",
      "table": {
        "caption": "Compétences",
        "column": {
          "competences": "Nom et descriptif de la compétence",
          "level": "Niveau",
          "positioning": "Positionnement"
        }
      }
    },
    "analysis-per-tube": {
      "cover-rate-gauge-label": "Sur le sujet vos participants ont obtenu un niveau de {reachedLevel} sur un niveau maximum atteignable de {maxLevel}.",
      "description": "Ci-dessous, retrouvez les sujets de la campagne et leurs descriptifs ainsi que le positionnement des participants.",
      "table": {
        "caption": "{index} - {name}",
        "column": {
          "level": "Niveau",
          "positioning": "Positionnement",
          "tubes": "Nom et descriptif du sujet"
        }
      }
    },
    "analysis-per-tube-or-competence": {
      "title": "Positionnement détaillé",
      "toggle": {
        "label": "Vue par :",
        "label-competences": "Compétences",
        "label-tubes": "Sujets"
      }
    },
    "campaign": {
      "type": {
        "explanation": {
          "ASSESSMENT": "Campagne d'évaluation",
          "EXAM": "Mode interro [bêta]",
          "PROFILES_COLLECTION": "Campagne de collecte de profil"
        },
        "information": {
          "ASSESSMENT": "Évaluation",
          "EXAM": "Mode interro [bêta]",
          "PROFILES_COLLECTION": "Collecte de profil"
        }
      }
    },
    "certificability": {
      "placeholder-select": "Certifiable / Non certifiable"
    },
    "certificability-tooltip": {
      "aria-label": "Explication sur la certificabilité",
      "content": "La certificabilité signifie que le participant a atteint le niveau 1 dans au moins 5 compétences différentes.",
      "from-collect-notice": "L'information provient des campagnes de collecte de profil réalisées par ce dernier. Si le participant a déjà envoyé son profil, on affiche la date ainsi que le statut du dernier envoi.",
      "from-compute-certificability": "Ce statut est mis à jour automatiquement (toutes les 24h) et lors des campagnes de collectes de profils."
    },
    "cover-rate-gauge": {
      "label": "Sur cette campagne, vos participants ont obtenu un niveau de {reachedLevel} sur un niveau maximum atteignable de {maxLevel}."
    },
    "date": {
      "no-date": "Pas encore de date"
    },
    "global-positioning": {
      "description": "Le positionnement global est le niveau moyen atteint par les participants (barre violette) par rapport au maximum qu’ils auraient pu atteindre dans cette campagne (barre blanche).",
      "gauge-label": "Lors de cette campagne, vos participants ont obtenu en moyenne un niveau de {reachedLevel} sur un niveau maximum atteignable de {maxLevel}.",
      "title": "Positionnement global"
    },
    "group": {
      "SCO": "Classe",
      "SUP": "Groupe"
    },
    "import-information-banner": {
      "error": "Échec de l'import",
      "error-link": "(voir la page d'import).",
      "in-progress": "Un import est en cours",
      "in-progress-link": "(consulter l'état de l'import).",
      "success": "Les participants ont bien été importés le {date} par {firstname} {lastname}."
    },
    "organization-participants-header": {
      "default": {
        "title": "{count, plural, =0 {Participants} =1 {Participant ({count})} other {Participants ({count})}}"
      },
      "import-button": "Importer",
      "sco": {
        "title": "{count, plural, =0 {Élèves} =1 {Élèves ({count})} other {Élèves ({count})}}"
      },
      "sco-title": "{count, plural, =0 {Élèves} =1 {Élève ({count})} other {Élèves ({count})}}",
      "title": "{count, plural, =0 {Participants} =1 {Participant ({count})} other {Participants ({count})}}"
    },
    "participation-status": {
      "SHARED-ASSESSMENT": "Résultats reçus",
      "SHARED-PROFILES_COLLECTION": "Profil reçu",
      "STARTED-ASSESSMENT": "En cours",
      "TO_SHARE-ASSESSMENT": "En attente d'envoi",
      "TO_SHARE-PROFILES_COLLECTION": "En attente d'envoi"
    },
    "terms-of-service": {
      "actions": {
        "accept": "Accepter et continuer",
        "document-link": "Lire les conditions d’utilisation",
        "reject": "Refuser et quitter"
      },
      "message": {
        "requested": "Pour continuer à utiliser Pix, nous vous invitons à lire et accepter nos Conditions Générales d'Utilisation.",
        "update-requested": "Nous avons actualisé nos CGU. Consultez les changements et acceptez-les pour continuer."
      },
      "title": {
        "requested": "Veuillez accepter nos Conditions Générales d'Utilisation (CGU)",
        "update-requested": "Mise à jour importante des Conditions Générales d'Utilisation (CGU)"
      }
    },
    "ui": {
      "deletion-modal": {
        "confirm-deletion": "Oui, je supprime",
        "confirmation-checkbox": "Je confirme avoir bien compris les impacts des {count} suppressions"
      }
    }
  },
  "navigation": {
    "assessment-individual-results": {
      "aria-label": "Navigation de la section résultat d'une évaluation individuelle"
    },
    "campaign-page": {
      "aria-label": "Navigation de la section détails d'une campagne"
    },
    "credits": {
      "number": "{count, plural, =0 {0 crédit} =1 {1 crédit} other {{count, number} crédits}}",
      "tooltip-text": "Le nombre de crédits affichés correspond au nombre de crédits acquis par l’organisation et en cours de validité (indépendamment de leur activation). Pour plus d’information contactez-nous à l’adresse '<a href=mailto:pro@pix.fr>'pro@pix.fr'</a>'"
    },
    "external-link-title": "Ouverture dans une nouvelle fenêtre",
    "footer": {
      "a11y": "Accessibilité : partiellement conforme",
      "aria-label": "Navigation de pied de page",
      "copyrights": "©",
      "legal-notice": "Mentions légales",
      "pix": "Pix",
      "server-status": "Statuts des services"
    },
    "main": {
      "aria-label": "Navigation principale",
      "attestations": "Attestations",
      "campaigns": "Campagnes",
      "certifications": "Certifications",
      "close": "Fermer la navigation",
      "documentation": "Documentation",
      "home": "Accueil",
      "missions": "Missions",
      "open": "Ouvrir la navigation",
      "organization-participants": "Participants",
      "places": "Places",
      "sco-organization-participants": "Élèves",
      "statistics": "Statistiques",
      "sup-organization-participants": "Étudiants",
      "support": "Centre d'aide",
      "team": "Équipe"
    },
    "places": {
      "link": "voir le détail",
      "number": "{count, plural, =0 {0 place disponible} =1 {1 place disponible} other {{count} places disponibles}}"
    },
    "school-sessions": {
      "activate-button": "Activer la session",
      "extend-button": "Prolonger la session",
      "status": {
        "active-label": "Session active jusqu'à {sessionExpirationDate}",
        "aria-label": "Explication sur la session",
        "code-label": "Code école",
        "inactive-label": "Session inactive",
        "info-text": "Les missions sont accessibles par les élèves uniquement lorsque la session est active.'<br>' À la fin de la session, les élèves en cours de mission ne seront pas déconnectés.",
        "title": "Statut de la session"
      }
    },
    "team-members": {
      "aria-label": "Navigation de la section équipe"
    },
    "user-logged-menu": {
      "button": "Changer d'organisation",
      "logout": "Se déconnecter"
    }
  },
  "pages": {
    "assessment-individual-results": {
      "badges": "Badges",
      "breadcrumb-current-page-label": "Participation de {firstName} {lastName}",
      "participation-label": "Participation #{participationNumber}",
      "participation-not-shared": "Résultats non-envoyés",
      "participation-selector": "Choisir une participation",
      "participation-shared": "Résultats envoyés",
      "progression": "Avancement",
      "result": "Résultat",
      "tab": {
        "results": "Résultats",
        "review": "Analyse"
      },
      "table": {
        "column": {
          "competences": "Compétences ({count, plural, =0 {-} other {{count}}})",
          "results": {
            "label": "Résultats",
            "tooltip": "'<span class=\"screen-reader-only\">'Ce participant a validé'</span>' {result, number, ::percent} '<span class=\"screen-reader-only\">'de la compétence {competence}.'</span>'"
          }
        },
        "empty": "En attente de résultats",
        "title": "Résultats par compétence"
      },
      "title": "Résultats de {firstName} {lastName}"
    },
    "attestations": {
      "PARENTHOOD": "Attestation de sensibilisation au numérique",
      "SIXTH_GRADE": "Attestation de sensibilisation au numérique",
      "basic-description": "Exportez toutes les attestations",
      "download-attestations-button": "Télécharger (.pdf)",
      "no-attestations": "Aucune attestation disponible pour votre sélection",
      "section": {
        "download": "Téléchargement",
        "list": "Suivi"
      },
      "select-divisions-label": "Sélectionnez les attestations d'une ou plusieurs classes",
      "select-label": "Attestation",
      "table": {
        "column": {
          "division": "Classe",
          "first-name": "Prénom",
          "last-name": "Nom",
          "status": "Obtention"
        },
        "filter": {
          "divisions": {
            "empty-option": "Classe",
            "label": "Classe"
          },
          "legend": "Filtres pour le tableau des attestations, des champs de saisie permettent de filtrer le tableau par le nom ou prénom d'un élève et par classes. Des boutons permettent de filtrer les attestations obtenues ou non.",
          "results": "{total, plural, =0 {0 résultat} =1 {1 résultat} other {{total, number} résultats}}",
          "status": {
            "empty-option": "Obtenu / Non obtenu",
            "label": "Obtention",
            "not-obtained": "Non obtenu",
            "obtained": "Obtenu"
          }
        },
        "status": {
          "not-obtained": "Non obtenu",
          "obtained": "Obtenu le {date}"
        }
      },
      "title": "Attestations"
    },
    "campaign": {
      "actions": {
        "export-results": "Exporter les résultats (.csv)",
        "unarchive": "Désarchiver la campagne"
      },
      "archived": "Campagne archivée",
      "code": "Code",
      "copy": {
        "code": {
          "default": "Copier le code",
          "success": "Copié !"
        },
        "link": {
          "default": "Copier le lien direct",
          "success": "Copié !"
        }
      },
      "created-by": "Propriétaire",
      "created-on": "Créée le",
      "empty-state": "Aucun participant pour l’instant !",
      "empty-state-with-copy-link": "Aucun participant pour l’instant ! Envoyez-leur le lien suivant pour rejoindre votre campagne.",
      "multiple-sendings": {
        "status": {
          "disabled": "Non",
          "enabled": "Oui"
        },
        "title": "Envoi multiple"
      },
      "name": "Nom de la campagne",
      "tab": {
        "activity": "Activité",
        "results": "Résultats ({count, number})",
        "review": "Analyse",
        "settings": "Paramètres"
      }
    },
    "campaign-activity": {
      "actions": {
        "delete": "Supprimer"
      },
      "delete-participation-modal": {
        "actions": {
          "cancel": "Non",
          "confirmation": "Oui, je supprime"
        },
        "error": "Un problème est survenu lors de la suppression de la participation.",
        "success": "La participation a été supprimée avec succès.",
        "text": "Vous êtes sur le point de supprimer une participation, celle-ci ne sera plus visible ni comprise dans les statistiques de la campagne.",
        "title": "Supprimer la participation de <strong>{firstName} {lastName}</strong> ?",
        "warning": {
          "assessment-campaign-participation": {
            "shared-participation": "Le participant ne pourra plus accéder aux résultats de cette campagne.",
            "started-participation": "Le participant ne pourra plus reprendre cette participation.",
            "to-share-participation": "Le participant ne pourra pas envoyer ses résultats."
          },
          "profiles-collection-campaign-participation": {
            "shared-participation": "Le participant ne pourra plus participer à cette collecte de profil.",
            "to-share-participation": "Le participant ne pourra pas envoyer son profil."
          }
        }
      },
      "table": {
        "column": {
          "delete": "Supprimer la participation",
          "first-name": "Prénom",
          "last-name": "Nom",
          "participationCount": "Nombre de participations",
          "status": "Statut"
        },
        "delete-button-label": "Supprimer la participation",
        "empty": "Aucun participant",
        "see-results": "Voir les résultats de {firstName} {lastName}",
        "title": "Liste des participants"
      },
      "title": "Activité"
    },
    "campaign-analysis": {
      "description": {
        "explanation": "Le positionnement reflète le niveau moyen atteint par les participants, par rapport au niveau maximal accessible dans cette campagne.",
        "nota-bene": "Toutes les données présentées proviennent des participations partagées et non-supprimées des campagnes d’évaluation et sont actualisées à chaque visite.",
        "resume": "Analysez par compétence ou par sujet, le positionnement de vos participants dans cette campagne qui porte sur une sélection de sujets du référentiel Pix."
      },
      "levels-correspondence": {
        "infos": {
          "link": "https://pix.fr/score-et-niveaux",
          "text": "En savoir plus sur les niveaux."
        },
        "levels": {
          "advanced": "5 ou 6 : Avancé",
          "beginner": "1 ou 2 : Novice",
          "expert": "7 ou 8 : Expert",
          "independent": "3 ou 4 : Indépendant"
        },
        "title": "Correspondance des niveaux"
      },
      "second-title": "Analyse de résultats",
      "title": "Analyse"
    },
    "campaign-creation": {
      "actions": {
        "create": "Créer la campagne",
        "delete": "Effacer"
      },
      "copy-of": "Copie de",
      "external-id-label": {
        "label": "Libellé de l’identifiant",
        "question-label": "Souhaitez-vous demander un identifiant externe ?",
        "required": "L'id externe est obligatoire",
        "suggestion": "Exemple: \"Numéro de l'étudiant\" ou \"Adresse e-mail professionnelle\" *"
      },
      "external-id-type": {
        "question-label": "Quel est le type de l'identifiant externe ?"
      },
      "landing-page-text": {
        "label": "Texte de la page d'accueil",
        "sublabel": "Ce champ sera affiché aux participants de la campagne."
      },
      "legal-warning": "* En vertu de la loi Informatique et libertés, et en tant que responsable de traitement, soyez attentifs à ne pas demander de donnée particulièrement identifiante ou signifiante si ce n’est pas absolument indispensable. Le numéro de sécurité sociale (NIR) est à proscrire ainsi que toute donnée sensible.",
      "multiple-sendings": {
        "assessments": {
          "info": "Si vous choisissez l’envoi multiple, le participant pourra repasser la campagne 4 jours après et envoyer ses résultats plusieurs fois, en saisissant à nouveau le code.",
          "question-label": "Souhaitez-vous permettre aux participants d’envoyer plusieurs fois leurs résultats ?"
        },
        "info-title": "Envoi multiple",
        "knowledge-elements-resettable": "Dans le cadre de ce parcours, le participant pourra tenter d'améliorer ses résultats en repassant toutes les questions du parcours.",
        "profiles": {
          "info": "Si vous choisissez l’envoi multiple, le participant pourra envoyer plusieurs fois son profil en saisissant à nouveau le code campagne. Au sein de Pix Orga, vous trouverez le dernier profil envoyé.",
          "question-label": "Souhaitez-vous permettre aux participants d'envoyer plusieurs fois leur profil ?"
        }
      },
      "name": {
        "label": "Nom de la campagne"
      },
      "no": "Non",
      "owner": {
        "info": "Le propriétaire de la campagne ainsi que les administrateurs de cette organisation, sont les seules personnes qui peuvent modifier ou archiver cette campagne.",
        "label": "Propriétaire de la campagne",
        "placeholder": "Nom et prénom du propriétaire",
        "search-placeholder": "Rechercher un propriétaire",
        "title": "Propriétaire de la campagne"
      },
      "purpose": {
        "assessment": "Évaluer les participants",
        "assessment-info": "Une campagne d’évaluation permet de tester les participants sur des sujets précis.",
        "exam": "Mode interro [bêta]",
        "exam-info": "Une campagne de type “mode interro” permet de tester les participants sur des sujets précis, sans prendre en compte le profil utilisateur, et sans impacter celui-ci. Les épreuves proposées sont personnalisées pour chaque participant selon son avancement dans le parcours.",
        "label": "Quel est l'objectif de votre campagne ?",
        "profiles-collection": "Collecter les profils Pix des participants",
        "profiles-collection-info": "Une campagne de collecte de profils permet de récupérer le profil des participants : niveaux par compétence et score pix.",
        "profiles-collection-info-certificability-calculation": "Le statut Certifiable est mis à jour automatiquement dans l’onglet '<'a href=\"/eleves\" class=\"{linkClasses}\"'>'Élèves'</a>'."
      },
      "tags": {
        "BACK_TO_SCHOOL": "Parcours de rentrée / 6e",
        "COMPETENCES": "Les 16 compétences",
        "CUSTOM": "Parcours sur-mesure",
        "DISCIPLINE": "Disciplinaires",
        "OTHER": "Autres",
        "PIX_PLUS": "Pix+",
        "PREDEFINED": "Parcours prédéfinis",
        "SUBJECT": "Thématiques",
        "TARGETED": "Parcours ciblés"
      },
      "tags-title": "Filtrer la recherche :",
      "target-profiles-category-label": "Filtrer les parcours par catégories",
      "target-profiles-category-placeholder": "Catégories",
      "target-profiles-label": "Sélectionner un parcours",
      "target-profiles-list-label": "Que souhaitez-vous tester ?",
      "target-profiles-search-placeholder": "Rechercher par nom",
      "test-title": {
        "label": "Titre du parcours",
        "sublabel": "Ce champ sera affiché aux participants de la campagne."
      },
      "title": "Création d'une campagne",
      "yes": "Oui"
    },
    "campaign-individual-results": {
      "shared-date": "Envoyé le",
      "start-date": "Commencé le"
    },
    "campaign-individual-review": {
      "title": "Analyse pour {firstName} {lastName}"
    },
    "campaign-modification": {
      "actions": {
        "edit": "Modifier"
      },
      "campaign-modification-success-message": "Les modifications ont bien été enregistrées.",
      "campaign-name": "Nom de la campagne",
      "landing-page-text": {
        "label": "Texte de la page d'accueil",
        "sublabel": "Ce champ sera affiché aux participants de la campagne."
      },
      "owner": {
        "info": "Le propriétaire de la campagne ainsi que les administrateurs de cette organisation, sont les seules personnes qui peuvent modifier et archiver cette campagne.",
        "label": "Propriétaire de la campagne",
        "placeholder": "Nom et prénom du propriétaire",
        "title": "Propriétaire de la campagne"
      },
      "personalised-test-title": {
        "label": "Titre du parcours",
        "sublabel": "Ce champ sera affiché aux participants de la campagne."
      },
      "title": "Modification d'une campagne"
    },
    "campaign-results": {
      "average": "Moyenne des résultats",
      "filters": {
        "aria-label": "Filtres sur les participations",
        "participations-count": "{count, plural, =0 {0 participant} =1 {1 participant} other {{count} participants}}",
        "type": {
          "badges": "Badges obtenus",
          "groups": {
            "empty": "Aucun groupe",
            "title": "Groupes"
          },
          "stages": "Paliers",
          "status": {
            "empty": "Tous les statuts",
            "title": "Statut"
          },
          "unacquired-badges": "Badges non obtenus"
        }
      },
      "result": "Résultat",
      "table": {
        "badge-tooltip": {
          "acquired": "Acquis",
          "unacquired": "Non acquis"
        },
        "caption": "Ce tableau comporte la liste des participants ayant partagé leurs résultats. Il indique pour chaque participant leur nom, prénom et des éléments de résultats.",
        "column": {
          "ariaSharedResultCount": "Nombre de résultats envoyés",
          "badges": "Badges",
          "evolution": "Évolution",
          "first-name": "Prénom",
          "last-name": "Nom",
          "results": {
            "label": "Résultats",
            "on-hold": " En attente d'envoi",
            "under-test": "En cours de test"
          },
          "sharedResultCount": "Nb résultats envoyés"
        },
        "empty": "Aucune participation",
        "evolution": {
          "decrease": "En régression",
          "increase": "En progression",
          "stable": "Constant",
          "unavailable": "Non disponible"
        },
        "evolution-tooltip": {
          "content": "Évolution du participant entre ses deux derniers résultats partagés."
        },
        "title": "Liste des résultats reçus"
      },
      "tested-items": "Acquis évalués",
      "title": "Résultats",
      "validated-items": "Acquis validés"
    },
    "campaign-review": {
      "description": "En fonction du référentiel testé et des résultats de la campagne, Pix vous recommande ces sujets à travailler, classés par degré de pertinence {bubble}.",
      "sub-table": {
        "column": {
          "source": {
            "value": "Par {source}"
          }
        },
        "title": "{count, plural, =1 {1 tuto recommandé} other{{count} tutos recommandés}} par la communauté Pix"
      },
      "sub-title": "Recommandation de sujets à travailler",
      "table": {
        "analysis": {
          "caption": "Tableau des sujets à travailler, certains présentent des colonnes supplémentaires indiquant le nombre de tutoriels existant en lien avec le sujet et un accès à ces tutoriels",
          "column": {
            "relevance": {
              "ariaLabelDefaultSort": "Le tableau n'est actuellement pas trié par pertinence. Cliquez pour trier par ordre croissant.",
              "ariaLabelSortDown": "Le tableau est trié par pertinence décroissante. Cliquez pour trier en ordre croissant.",
              "ariaLabelSortUp": "Le tableau est trié par pertinence croissante. Cliquez pour trier en ordre décroissant.",
              "label": "Pertinence"
            },
            "subjects": "Sujets ({count, plural, =0 {-} other {{count}}})",
            "tutorial": {
              "aria-label": "Afficher la liste des tutos"
            },
            "tutorial-count": {
              "aria-label": "Nombre de tutoriels recommandés",
              "value": "{count, plural, =1 {1 tuto} other {{count} tutos}}"
            }
          },
          "recommendations": {
            "moderately-recommended": "Assez recommandé",
            "recommended": "Recommandé",
            "strongly-recommended": "Fortement recommandé",
            "very-strongly-recommended": "Très recommandé"
          }
        },
        "competences": {
          "column": {
            "competences": "Compétences ({count})",
            "results": {
              "label": "Résultats",
              "tooltip": "'<span class=\"screen-reader-only\">'Les participants ont validé'</span>' {result} % '<span class=\"screen-reader-only\">'de la compétence {competence}.'</span>'"
            }
          },
          "title": "Résultats par compétence"
        },
        "empty": "En attente de résultats"
      },
      "title": "Analyse"
    },
    "campaign-settings": {
      "actions": {
        "archive": "Archiver",
        "duplicate": "Dupliquer",
        "edit": "Modifier"
      },
      "campaign-type": {
        "assessment": "Campagne d'évaluation",
        "exam": "Campagne d'interro [bêta]",
        "profiles-collection": "Campagne de collecte de profils",
        "title": "Type de la campagne"
      },
      "direct-link": "Lien direct",
      "external-user-id-label": "Libellé de l'identifiant",
      "external-user-id-types": {
        "email": "Email",
        "string": "Autre"
      },
      "landing-page-text": "Texte de la page d'accueil",
      "multiple-sendings": {
        "status": {
          "disabled": "Non",
          "enabled": "Oui"
        },
        "title": "Envoi multiple",
        "tooltip": {
          "aria-label": "Description de l'envoi multiple",
          "text": "Si l’envoi multiple est activé, le participant peut envoyer plusieurs fois sa participation en saisissant à nouveau le code campagne. Au sein de Pix Orga, vous trouverez la dernière envoyée."
        }
      },
      "personalised-test-title": "Titre du parcours",
      "reset-to-zero": {
        "status": {
          "disabled": "Non",
          "enabled": "Oui"
        },
        "title": "Remise à zéro",
        "tooltip": {
          "aria-label": "Description de Remise à zéro",
          "text": "Si la remise à zéro est activée, le participant peut repasser entièrement son parcours et renvoyer ses résultats, plusieurs fois, en saisissant à nouveau le code campagne."
        }
      },
      "target-profile": {
        "title": "Parcours",
        "tooltip": "Description du parcours"
      },
      "title": "Paramètres"
    },
    "campaigns-list": {
      "action": {
        "campaign": {
          "archived": "Archivées",
          "label": "Afficher les campagnes actives ou archivées",
          "ongoing": "Actives"
        },
        "create": "Créer une campagne"
      },
      "action-bar": {
        "delete-button": "Supprimer",
        "error-message": "{count, plural, =1 {Une erreur est survenue, la campagne n'a pas été supprimée de la liste.} other {Une erreur est survenue, les {count} campagnes sélectionnées n'ont pas été supprimées de la liste.}}",
        "information": "{count, plural, =1 {{count} campagne sélectionnée} other {{count} campagnes sélectionnées}}",
        "success-message": "{count, plural, =1 {La campagne (ainsi que ses résultats) a bien été supprimée de la liste.} other {Les {count} campagnes sélectionnées (ainsi que leurs résultats) ont bien été supprimés de la liste.}}"
      },
      "deletion-modal": {
        "confirmation-checkbox": "Je confirme avoir bien compris les impacts des {count} suppressions",
        "content": {
          "footer": "Attention, cette action est irréversible.",
          "header": "{count, plural, =1 {Cette campagne ne sera plus visible} other {Ces campagnes ne seront plus visibles}} dans Pix Orga.",
          "main-participation-prevent": "Toutes les participations à {count, plural, =1 {cette campagne} other {ces campagnes}} et leurs résultats seront supprimés."
        },
        "title": "{count, plural, =1 {Êtes-vous sûr(e) de vouloir supprimer la campagne sélectionnée ?} other {Êtes-vous sûr(e) de vouloir supprimer les '<strong>'{count}'</strong>' campagnes sélectionnées ?}}"
      },
      "filter": {
        "by-name": "Rechercher une campagne",
        "by-owner": "Rechercher un propriétaire",
        "legend": "Filtres pour le tableau des campagnes, des champs de saisie permettent de filtrer le tableau par le nom de la campagne et par nom du propriétaire. Des boutons permettent de filtrer les campagnes actives et archivées.",
        "results": "{total, plural, =0 {0 campagne} =1 {1 campagne} other {{total, number} campagnes}}"
      },
      "navigation": "Navigation de la section Campagnes",
      "no-campaign": "Aucune campagne, pour commencer cliquez sur le bouton 'Créer une campagne'.",
      "table": {
        "column": {
          "code": "Code",
          "created-by": "Propriétaire",
          "created-on": "Créée le",
          "mainCheckbox": "Selectionner/Deselectionner toute la colonne",
          "name": "Nom de la campagne",
          "participants": "Participants",
          "results": "Résultats reçus"
        },
        "description-all-campaigns": "Ce tableau comporte la liste de toutes les campagnes créées dans votre espace Pix Orga. Il indique pour chaque campagne leur code, leur propriétaire, leur date de création, le nombre de participants et le nombre de résultats reçus.",
        "description-my-campaigns": "Ce tableau comporte la liste des campagnes dont vous êtes propriétaire. Il indique pour chaque campagne leur code, leur date de création, le nombre de participants et le nombre de résultats reçus.",
        "empty": "Aucune campagne"
      },
      "tabs": {
        "all-campaigns": "Toutes les campagnes",
        "my-campaigns": "Mes campagnes"
      },
      "title": "Campagnes"
    },
    "certifications": {
      "description": "Sélectionnez la classe pour laquelle vous souhaitez exporter les résultats de certification (.csv) ou télécharger les certificats (.pdf).\n Vous pouvez filtrer cette liste en renseignant le nom de la classe directement dans le champ.",
      "documentation-link": "https://cloud.pix.fr/s/8pJqgNNntwDtsDY",
      "documentation-link-label": "Interprétation des résultats",
      "documentation-link-notice": "Vous trouverez en suivant ce lien quelques éléments pour interpréter les résultats : ",
      "download-attestations-button": "Télécharger les certificats",
      "download-button": "Exporter les résultats",
      "errors": {
        "invalid-division": "La classe {selectedDivision} n'existe pas.",
        "no-certificates": "Aucun certificat pour la classe {selectedDivision}.",
        "no-results": "Aucun résultat de certification pour la classe {selectedDivision}."
      },
      "no-students-imported-yet": "Dans cet onglet, vous retrouverez les résultats et les certificats des élèves. Vous devez, dans un premier temps, importer la base élèves de votre établissement. ",
      "select-label": "Classe",
      "title": "Résultats de certification"
    },
    "join-request-form": {
      "firstname": "Votre prénom",
      "lastname": "Votre nom",
      "legal-information": {
        "link-text": "En savoir plus sur mes droits.",
        "link-url": "https://pix.fr/dp-formulaire-recuperation-pixorga-sco",
        "text": "Les informations recueillies sur ce formulaire sont enregistrées dans un fichier informatisé par le GIP Pix pour le compte du ministère de l’Éducation nationale en tant que responsable de traitement, pour permettre à votre établissement scolaire d’accéder à son espace Pix Orga en lui envoyant une invitation à rejoindre cet espace."
      },
      "organization-code": "UAI/RNE de l'établissement"
    },
    "login": {
      "choose-language-aria-label": "Sélectionnez une langue",
      "title": "Connectez-vous"
    },
    "login-form": {
      "active-or-retrieve": "Vous êtes personnel de direction ou directeur d'école ? Activez ou devenez l'administrateur de l'espace Pix Orga de votre établissement scolaire",
      "email": "Adresse e-mail",
      "errors": {
        "empty-password": "Le champ mot de passe est obligatoire.",
        "invalid-email": "Votre adresse e-mail n’est pas valide.",
        "should-change-password": "Vous avez actuellement un mot de passe temporaire. Cliquez sur '<'a href=\"{url}\"'>'mot de passe oublié'</a>' pour le réinitialiser.",
        "status": {
          "403": "L'accès à Pix Orga est limité aux membres invités. Chaque espace est géré par un administrateur Pix Orga propre à l'organisation qui l'utilise. Contactez-le pour qu'il vous y invite.",
          "404": "L'adresse e-mail et/ou le mot de passe saisis sont incorrects.",
          "409": "Cette invitation a déjà été acceptée ou annulée."
        }
      },
      "forgot-password": "Mot de passe oublié ?",
      "invitation-already-accepted": "Cette invitation a déjà été acceptée. Connectez-vous ou contactez l'administrateur de votre espace Pix Orga.",
      "invitation-was-cancelled": "Cette invitation n’est plus valide. Contactez l’administrateur de votre espace Pix Orga.",
      "is-only-accessible": "L'accès à Pix Orga est limité aux membres invités. Contactez l’administrateur Pix Orga de votre organisation pour qu'il vous invite.",
      "login": "Je me connecte",
      "only-for-admin": "Réservé aux personnels de direction des établissements scolaires publics et privés sous contrat.",
      "password": "Mot de passe"
    },
    "login-or-register": {
      "login-form": {
        "button": "Se connecter",
        "title": "J'ai déjà un compte PIX"
      },
      "register-form": {
        "button": "S'inscrire",
        "errors": {
          "default": "Le service est momentanément indisponible. Veuillez réessayer ultérieurement.",
          "email-already-exists": "Cette adresse e-mail est déjà enregistrée, connectez-vous.",
          "invalid-or-already-used-email": "Adresse e-mail invalide ou déjà utilisée"
        },
        "fields": {
          "button": {
            "label": "Je m'inscris"
          },
          "cgu": {
            "accept": "J'accepte les",
            "and": "et la",
            "aria-label": "Accepter les conditions d'utilisation de Pix",
            "data-protection-policy": "politique de confidentialité",
            "error": "Vous devez accepter les conditions d’utilisation de Pix et la politique de confidentialité pour créer un compte.",
            "terms-of-use": "conditions d'utilisation de Pix"
          },
          "email": {
            "error": "Votre adresse e-mail n’est pas valide.",
            "label": "Adresse e-mail"
          },
          "first-name": {
            "error": "Votre prénom n’est pas renseigné.",
            "label": "Prénom"
          },
          "last-name": {
            "error": "Votre nom n’est pas renseigné.",
            "label": "Nom"
          },
          "password": {
            "error": "Votre mot de passe doit contenir 8 caractères au minimum et comporter au moins une majuscule, une minuscule et un chiffre.",
            "label": "Mot de passe"
          }
        },
        "title": "Je m’inscris"
      },
      "title": "Vous êtes invité(e) à rejoindre l'organisation {organizationName}"
    },
    "missions": {
      "list": {
        "actions": {
          "see-mission-details": "Voir le détail"
        },
        "aria-label": "Mission",
        "banner": {
          "copypaste-container": {
            "abstract": "Démarrez vos premières missions avec vos élèves en activant la session via le bouton ci-dessus et en utilisant le",
            "button": {
              "success": "copié !",
              "tooltip": "copier le code"
            }
          },
          "hint": "N’hésitez pas à le mettre en favori sur vos postes.",
          "import-text": "lien de l'école",
          "step1": {
            "admin": {
              "head": "Étape 1 : <b>Veuillez</b>",
              "link": "importer la base élève",
              "tail": "<b>depuis Onde</b> (fichier exportable dans le menu Listes & documents > Extractions > Élèves de l’école ou leurs responsables <b>en sélectionnant les élèves de cycle 3 uniquement</b>)."
            },
            "non-admin": "Étape 1 : <b>Demandez à l'administrateur</b> Pix Orga de votre espace afin d’importer les élèves."
          },
          "step2": {
            "option1": "utiliser&nbsp<b>le lien</b>&nbsp'<'a href=\"{pixJuniorUrl}\"'>'junior.pix.fr'</a>'.&nbspLe code de votre établissement vous sera demandé à chaque connexion.",
            "option2": {
              "body": "ou utiliser le lien direct&nbsp'<'a href=\"{pixJuniorUrl}\" target=_blank >junior.pix.fr/schools/{code}'</a>'",
              "hint": "Vous pouvez enregistrer ce favori sur les ordinateurs."
            },
            "title": "Étape 2 : Pour que les élèves accèdent à l’espace Pix Junior de votre école, vous pouvez :"
          },
          "step3": "Étape 3 : <b>Activez la session Pix Junior</b> via le bouton dans la barre latérale. <b>Cette action est à réaliser avant chaque séance avec vos élèves</b>.",
          "welcome": "Pour commencer à utiliser Pix Junior :"
        },
        "caption": "Liste des missions",
        "empty-state": "Il n'y a pas de missions",
        "headers": {
          "actions": "Actions",
          "competences": "Compétences du CRCN travaillées",
          "name": "Mission",
          "started-by": "Commencé par"
        },
        "no-division": "Aucune classe",
        "non-admin": {
          "abstract": "Pour commencer, demandez à votre administrateur d’importer les élèves."
        }
      },
      "mission": {
        "details": {
          "button-label": "Voir la fiche pédagogique",
          "competence": {
            "title": "Compétence du CRCN travaillée :"
          },
          "objective": {
            "title": "Objectifs de la mission :"
          }
        },
        "table": {
          "activities": {
            "aria-label": "Élève",
            "caption": "Tableau des élèves avec leur participation à la mission {missionName}",
            "filters": {
              "aria-label": "Filtre sur les élèves",
              "learners-count": "{count, plural, =0 {Aucun élève} =1 {1 élève} other {{count} élèves}}",
              "status": {
                "label": "Statut de la mission"
              }
            },
            "headers": {
              "division": "Classe",
              "first-name": "Prénom",
              "last-name": "Nom",
              "status": "Statut de la mission"
            },
            "mission-status": {
              "completed": "Terminée",
              "not-started": "Non débutée",
              "started": "En cours"
            },
            "no-data": "Il n'y a aucun participant"
          },
          "result": {
            "aria-label": "Élève",
            "caption": "Tableau des élèves avec le résultat de leur participation à la mission {missionName}",
            "filters": {
              "aria-label": "Filtre sur les élèves",
              "global-result": {
                "label": "Évaluation de la mission",
                "options": {
                  "exceeded": "Dépassé",
                  "no-result": "Pas d'évaluation",
                  "not-reached": "Non atteint",
                  "partially-reached": "Partiellement atteint",
                  "reached": "Atteint"
                }
              },
              "learners-count": "{count, plural, =0 {Aucun élève} =1 {1 élève} other {{count} élèves}}"
            },
            "headers": {
              "dare-challenge": "Défi",
              "division": "Classe",
              "first-name": "Prénom",
              "last-name": "Nom",
              "result": "Évaluation de la mission",
              "step": "Étape {number}"
            },
            "mission-dare-result": {
              "not-reached": "NA",
              "reached": "A",
              "undefined": "-"
            },
            "mission-result": {
              "exceeded": "Dépassé",
              "not-reached": "Non atteint",
              "partially-reached": "Partiellement atteint",
              "reached": "Atteint",
              "undefined": "-"
            },
            "no-data": "Il n'y a aucun participant",
            "step-result": {
              "not-reached": "NA",
              "partially-reached": "PA",
              "reached": "A",
              "undefined": "-"
            }
          }
        },
        "tabs": {
          "activities": "Activités",
          "aria-label": "Navigation entre l'activité ou les résultats de la mission",
          "results": "Résultats"
        },
        "title": "Détails d'une mission"
      },
      "title": "Missions"
    },
    "organization-learner": {
      "activity": {
        "assessment-summary": "Récapitulatif des participations aux campagnes d'évaluation",
        "cards": {
          "shared": "Envoyées : {count}",
          "started": "En cours : {count}",
          "title": {
            "assessment": "Évaluations",
            "profiles-collection": "Collectes de profil"
          },
          "to-share": "En attente : {count}"
        },
        "empty-state": "Aucune activité pour l’instant ! Envoyez une campagne à {organizationLearnerFirstName} {organizationLearnerLastName} et commencez à suivre sa progression.",
        "participation-list": {
          "table": {
            "column": {
              "campaign-name": "Campagne",
              "campaign-type": "Type",
              "created-at": "Date de début",
              "participation-count": "Nombre de participations",
              "shared-at": "Date d'envoi",
              "status": "Statut"
            }
          }
        },
        "participations-title": "Liste de toutes les participations",
        "profile-collection-summary": "Récapitulatif des participations aux campagnes de collecte de profil",
        "title": "Activité"
      },
      "header": {
        "aria-label-title": "Page de détail de {firstName} {lastName}"
      }
    },
    "organization-participant-activity": {
      "title": "Activité du participant"
    },
    "organization-participants": {
      "action-bar": {
        "delete-button": "Supprimer",
        "error-message": "{count, plural, =1 {Une erreur est survenue, {firstname} {lastname} n'a pas été supprimé de la liste des participants.} other {Une erreur est survenue, les {count} participants sélectionnés n'ont pas été supprimés de la liste.}}",
        "information": "{count, plural, =1 {{count} participant sélectionné} other {{count} participants sélectionnés}}",
        "success-message": "{count, plural, =1 {{firstname} {lastname} a bien été supprimé de la liste des participants.} other {Les {count} participants sélectionnés ont bien été supprimés de la liste.}}"
      },
      "deletion-modal": {
        "confirmation-checkbox": "Je confirme avoir bien compris les impacts des {count} suppressions",
        "content": {
          "footer": "Attention, cette action est irréversible.",
          "header": "{count, plural, =1 {Ce participant ne sera plus visible} other {Ces participants ne seront plus visibles}} dans Pix Orga.",
          "main-campaign-prevent": "Cela impactera donc les résultats et analyses des campagnes qu' {count, plural, =1 {il a} other {ils ont}} réalisées.",
          "main-participation-prevent": "Toutes {count, plural, =1 {ses} other {leurs}} participations aux campagnes seront supprimées."
        },
        "title": "{count, plural, =1 {Supprimer '<strong>'{firstname} {lastname}'</strong>' de vos} other {Êtes-vous sûr(e) de vouloir supprimer '<strong>'{count}'</strong>'}} participants ?"
      },
      "empty-state": {
        "action": "Voir mes campagnes",
        "call-to-action": "Invitez-les à rejoindre une campagne ou créez-en une nouvelle.",
        "message": "Aucun participant pour l’instant !"
      },
      "filters": {
        "aria-label": "Filtres sur les participants",
        "participations-count": "{count, plural, =0 {0 participant} =1 {1 participant} other {{count} participants}}",
        "students-count": "{count, plural, =0 {0 élèves} =1 {1 élève} other {{count} élèves}}",
        "type": {
          "certificability": {
            "label": "Rechercher par certificabilité",
            "placeholder": "Certificabilité"
          }
        }
      },
      "page-title": "Participants",
      "table": {
        "actions": {
          "disable-oralization": "Désactiver la lecture de consigne",
          "enable-oralization": "Activer la lecture de consigne"
        },
        "column": {
          "checkbox": "Sélectionner/Désélectionner {firstname} {lastname}",
          "first-name": "Prénom",
          "is-certifiable": {
            "label": "Certificabilité"
          },
          "last-name": {
            "ariaLabelDefaultSort": "Le tableau n'est actuellement pas trié par nom. Cliquez pour trier par ordre alphabétique.",
            "ariaLabelSortDown": "Le tableau est trié par nom, dans l'ordre alphabétique inverse. Cliquez pour trier par ordre alphabétique.",
            "ariaLabelSortUp": "Le tableau est trié par nom, dans l'ordre alphabétique. Cliquez pour trier par ordre alphabétique inverse.",
            "label": "Nom"
          },
          "latest-participation": {
            "ariaLabelDefaultSort": "Le tableau n'est actuellement pas trié par date de participations. Cliquez pour trier par ordre croissant.",
            "ariaLabelSortDown": "Le tableau est trié par date de participation décroissante. Cliquez pour trier en ordre croissant.",
            "ariaLabelSortUp": "Le tableau est trié par date de participation croissante. Cliquez pour trier en ordre décroissant.",
            "label": "Dernière participation"
          },
          "mainCheckbox": "Selectionner/Deselectionner toute la colonne",
          "participation-count": {
            "ariaLabelDefaultSort": "Le tableau n'est actuellement pas trié par nombre de participations. Cliquez pour trier par ordre croissant.",
            "ariaLabelSortDown": "Le tableau est trié par nombre de participation décroissant. Cliquez pour trier en ordre croissant.",
            "ariaLabelSortUp": "Le tableau est trié par nombre de participation croissant. Cliquez pour trier en ordre décroissant.",
            "label": "Nombre de participations"
          }
        },
        "description": "Tableau des participants trié par nom.",
        "empty": "Aucun participant",
        "oralization-header-tooltip": "Activer “lecture de la consigne” permettra à l'élève d’avoir sa transcription orale.",
        "row-value": {
          "oralization": {
            "false": "Désactivée",
            "true": "Activée"
          }
        }
      }
    },
    "organization-participants-import": {
      "actions": {
        "add-sup": {
          "details": "Permet d'ajouter une liste d'étudiants à celle déjà importée et/ou modifier les informations des étudiants déjà importés.",
          "label": "Ajouter des étudiants",
          "title": "Ajouter / modifier"
        },
        "participants": {
          "details": "Cette action vous permet de :",
          "details-add": "ajouter de nouveaux participants",
          "details-disable": "désactiver les anciens participants",
          "details-update": "modifier les participants déjà importés",
          "label": "Importer la liste",
          "title": "Importer la liste des participants"
        },
        "replace": {
          "details": "Permet d’importer une nouvelle liste d'étudiants à la place de l’existante.",
          "label": "Importer une nouvelle liste",
          "title": "Remplacer"
        }
      },
      "banner": {
        "anchor-error": "Voir la liste des erreurs",
        "fix-error-text": "Merci de corriger les erreurs et d’importer à nouveau le fichier.",
        "import-error": "L'import des participants a échoué.",
        "import-in-progress": "Le contenu du fichier est validé, l’import des participants est en cours.",
        "in-progress-text": "Merci de rafraîchir cette page dans quelques instants pour connaitre l’état de traitement du fichier.",
        "retry-error-text": "Une erreur est survenue, merci d'importer plus tard ou d'écrire au support Pix",
        "upload-completed": "Le fichier a été importé le {date} par {firstName} {lastName}.",
        "upload-error": "Le fichier n'a pas pu être importé.",
        "upload-in-progress": "L’import du fichier peut prendre quelques minutes. Merci de ne pas quitter cette page.",
        "validation-error": "Le contenu du fichier comporte des erreurs.",
        "validation-in-progress": "Le contenu du fichier est en cours de validation.",
        "warning-banner": "Certaines valeurs n’ont pas été reconnues. Elles ont été remplacées par “Non reconnu”. Si vous considérez qu’il manque des valeurs dans la liste limitative, veuillez nous contacter à '<a href=\"mailto:sup@pix.fr\">'sup@pix.fr'</a></div>'"
      },
      "error-panel": {
        "error-wrapper": "Aucun participant n’a été importé. Veuillez modifier votre fichier et l’importer à nouveau.",
        "global-error": "Aucun participant n’a été importé. Veuillez réessayer ou nous contacter via '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.pix.fr/support/tickets/new\">'le formulaire du centre d’aide'</a>'.",
        "title": "Erreurs dans le dernier fichier importé :"
      },
      "file-type-separator": ", ",
      "global-success": "Dernier fichier importé avec succès le {date} par {firstName} {lastName}.",
      "sco": {
        "title": "Importer des élèves"
      },
      "sup": {
        "title": "Importer des étudiants"
      },
      "supported-formats": "(formats supportés : {types})",
      "title": "Importer",
      "warnings": {
        "diploma": "Diplômes non reconnus : {diplomas}; ",
        "study-scheme": "Régimes non reconnus : {studySchemes}; "
      }
    },
    "participants-list": {
      "latest-participation-information-tooltip": {
        "aria-label": "Informations sur la dernière participation",
        "campaign-ASSESSMENT-type": "Évaluation",
        "campaign-PROFILES_COLLECTION-type": "Collecte de profils",
        "campaign-name": "Campagne : ",
        "campaign-status": "Statut : ",
        "campaign-type": "Type : ",
        "participation-SHARED-status": "Reçu",
        "participation-STARTED-status": "En cours",
        "participation-TO_SHARE-status": "En attente d'envoi"
      }
    },
    "places": {
      "before-date": "au",
      "places-lots": {
        "statuses": {
          "active": "Actif",
          "expired": "Expiré",
          "pending": "À venir"
        },
        "table": {
          "caption": "Tableau listant les achats de places de votre organisation. Pour chaque achat, il indique : le nombre de places, la date d’activation, la date d’expiration ainsi que le statut (actif, à venir ou expiré). Il est ordonné selon le statut des achats et leur date d’expiration.",
          "empty-state": "Aucune place pour le moment !",
          "headers": {
            "activation-date": "Date d'activation",
            "count": "Nombre de places",
            "expiration-date": "Date d'expiration",
            "status": "Statut"
          },
          "title": "Historique d'achat de places"
        }
      },
      "title": "Places"
    },
    "preselect-target-profile": {
      "download": "Télécharger la sélection des sujets ({ numberOfTubesSelected }) (JSON, { fileSize }ko)",
      "download-filename": "selection-sujets-{ organizationName }-{ date }.json",
      "no-tube-selected": "Télécharger la sélection des sujets (JSON, { fileSize }ko)",
      "table": {
        "caption": "Sélection des sujets",
        "column": {
          "action": "Sélection",
          "mobile": "Compatible smartphone",
          "name": "Nom du sujet",
          "tablet": "Compatible tablette",
          "theme-name": "Nom de la thématique"
        },
        "is-responsive": "oui",
        "not-responsive": "non",
        "row-title": "Sujet"
      },
      "title": "Sélection des sujets"
    },
    "profiles-individual-results": {
      "breadcrumb-current-page-label": "Participation de {firstName} {lastName}",
      "certifiable": "Certifiable",
      "competences-certifiables": "COMP. CERTIFIABLES",
      "pix": "PIX",
      "pix-score": "{score, number}",
      "table": {
        "column": {
          "level": "Niveau",
          "pix-score": "Score Pix",
          "skill": "Compétence"
        },
        "empty": "En attente de résultats",
        "title": "Résultats par compétence"
      },
      "title": "Profil de {firstName} {lastName}"
    },
    "profiles-list": {
      "table": {
        "caption": "Ce tableau comporte la liste des participants ayant partagé leurs profils. Il indique pour chaque participant leur nom, prénom, la date d’envoi, le score Pix, l'évolution, le statut de certificabilité et le nombre de compétences certifiables.",
        "column": {
          "ariaSharedProfileCount": "Nombre de partages de profil",
          "certifiable": "Certifiable",
          "certifiable-tag": "Certifiable",
          "competences-certifiables": "Comp. certifiables",
          "evolution": "Évolution",
          "first-name": "Prénom",
          "last-name": "Nom",
          "pix-score": {
            "label": "Score Pix",
            "value": "{score, number}"
          },
          "sending-date": {
            "label": "Date d'envoi",
            "on-hold": "En attente d'envoi"
          },
          "sharedProfileCount": "Nb de partages de profil"
        },
        "empty": "En attente de profils",
        "evolution": {
          "decrease": "En régression",
          "increase": "En progression",
          "stable": "Constant",
          "unavailable": "Non disponible"
        },
        "evolution-tooltip": {
          "content": "Évolution du score pix entre les deux derniers partages de profil."
        },
        "title": "Liste des profils reçus"
      },
      "title": "Profils reçus"
    },
    "sco-organization-participant-activity": {
      "title": "Activité de l'élève"
    },
    "sco-organization-participants": {
      "action-bar": {
        "generate-username-password-button": "Générer les identifiants et/ou les mots de passe des élèves sélectionnés",
        "information": "{count, plural, =1 {{count} élève sélectionné} other {{count} élèves sélectionnés}}",
        "reset-password-button": "Réinitialiser les mots de passe des élèves sélectionnés"
      },
      "actions": {
        "manage-account": "Gérer le compte",
        "show-actions": "Afficher les actions"
      },
      "connection-types": {
        "email": "Adresse e-mail",
        "empty": "–",
        "identifiant": "Identifiant",
        "mediacentre": "Mediacentre",
        "none": "Aucune",
        "without-mediacentre": "Sans Mediacentre"
      },
      "filter": {
        "aria-label": "Filtres sur les élèves",
        "certificability": {
          "label": "Rechercher par certificabilité",
          "placeholder": "Certificabilité"
        },
        "division": {
          "empty": "Aucune classe",
          "label": "Rechercher par classe"
        },
        "first-name": {
          "label": "Rechercher par prénom"
        },
        "last-name": {
          "label": "Rechercher par nom"
        },
        "login-method": {
          "empty-option": "Méthode de connexion",
          "label": "Rechercher par méthode de connexion"
        },
        "students-count": "{count, plural, =0 {0 élève} =1 {1 élève} other {{count} élèves}}"
      },
      "generate-username-password-modal": {
        "content-message-1": "Les élèves qui ne disposent pas encore d’une méthode de connexion doivent passer par une campagne de votre établissement pour créer leur compte PIX.",
        "content-message-2": "Un fichier CSV contenant les identifiants ainsi que les mots de passe à usage unique sera généré.",
        "content-message-3": "Communiquez ces nouveaux mots de passe à usage unique aux élèves. Lorsqu'ils se connecteront avec ce mot de passe, Pix leur demandera d'en saisir un nouveau",
        "title": "Générer les identifiants et/ou les mots de passe des élèves sélectionnés",
        "warning-message": "Un identifiant et un mot de passe seront générés pour les élèves ayant un accès au Médiacentre et/ou une adresse e-mail. Les élèves possédant déjà un identifiant verront leur mot de passe réinitialisé."
      },
      "manage-authentication-method-modal": {
        "authentication-methods": "Méthodes de connexion",
        "copied": "Copié !",
        "error": {
          "default": "Une erreur interne est survenue, nos équipes sont en train de résoudre le problème. Veuillez réessayer ultérieurement.",
          "unexpected": "Quelque chose s'est mal passé. Veuillez réessayer."
        },
        "section": {
          "add-username": {
            "button": "Ajouter l’identifiant",
            "label": "Ajouter une connexion avec un identifiant"
          },
          "email": {
            "copy": "Copier l’adresse e-mail",
            "label": "Adresse e-mail"
          },
          "mediacentre": {
            "label": "Médiacentre"
          },
          "password": {
            "copy": "Copier le mot de passe unique",
            "label": "Nouveau mot de passe à usage unique",
            "warning-1": "Communiquez ce nouveau mot de passe à votre élève.",
            "warning-2": "L’élève se connecte avec ce mot de passe à usage unique.",
            "warning-3": "Pix lui demande d'en choisir un nouveau."
          },
          "reset-password": {
            "button": "Réinitialiser le mot de passe",
            "warning": "Réinitialiser supprime le mot de passe actuel de l’élève."
          },
          "username": {
            "copy": "Copier l’identifiant",
            "label": "Identifiant"
          }
        },
        "title": "Gestion du compte Pix de l’élève"
      },
      "messages": {
        "password-reset-success": "La réinitialisation des mots de passe des élèves sélectionnés a été effectuée."
      },
      "no-participants": "Aucun élève pour l’instant !",
      "no-participants-action": "L’administrateur doit importer la base élèves en cliquant sur le bouton importer.",
      "page-title": "Élèves",
      "reset-password-modal": {
        "content-message-1": "Sur {totalSelectedStudents, plural, =1 {<strong>{totalSelectedStudents} élève</strong> sélectionné} other {<strong>{totalSelectedStudents} élèves</strong> sélectionnés}}, {totalAffectedStudents, plural, =0 {<strong>aucun mot de passe</strong> ne sera réinitialisé} =1 {le mot de passe de <strong>{totalAffectedStudents} élève</strong> va être réinitialisé} other {les mots de passe de <strong>{totalAffectedStudents} élèves</strong> vont être réinitialisés}}.",
        "content-message-2": "Un fichier CSV contenant les identifiants ainsi que les mots de passe à usage unique sera généré.",
        "content-message-3": "Communiquez ces nouveaux mots de passe à usage unique aux élèves. Lorsqu'ils se connecteront avec ce mot de passe, Pix leur demandera d'en saisir un nouveau.",
        "title": "Réinitialisation des <strong>mots de passe</strong> des élèves avec <strong>identifiant</strong>",
        "warning-message": "Seuls les mots de passe des accès par identifiant peuvent être réinitialisés. Les accès par adresse email et Mediacentre ne sont pas impactés."
      },
      "table": {
        "column": {
          "checkbox": "Sélectionner/Désélectionner {firstname} {lastname}",
          "date-of-birth": "Date de naissance",
          "division": {
            "ariaLabelDefaultSort": "Le tableau n'est actuellement pas trié par classe. Cliquez pour trier par ordre alphanumérique.",
            "ariaLabelSortDown": "Le tableau est trié par classe, dans l'ordre alphanumérique inverse. Cliquez pour trier par ordre alphanumérique.",
            "ariaLabelSortUp": "Le tableau est trié par classe, dans l'ordre alphanumérique. Cliquez pour trier par ordre alphanumérique inverse.",
            "label": "Classe"
          },
          "first-name": "Prénom",
          "is-certifiable": {
            "eligible": "Certifiable",
            "label": "Certificabilité",
            "non-eligible": "Non Certifiable",
            "not-available": "Non communiqué"
          },
          "last-name": {
            "ariaLabelDefaultSort": "Le tableau n'est actuellement pas trié par nom. Cliquez pour trier par ordre alphabétique.",
            "ariaLabelSortDown": "Le tableau est trié par nom, dans l'ordre alphabétique inverse. Cliquez pour trier par ordre alphabétique.",
            "ariaLabelSortUp": "Le tableau est trié par nom, dans l'ordre alphabétique. Cliquez pour trier par ordre alphabétique inverse.",
            "label": "Nom"
          },
          "last-participation-date": "Dernière participation",
          "login-method": "Méthode(s) de connexion",
          "mainCheckbox": "Selectionner/Deselectionner toute la colonne",
          "participation-count": {
            "ariaLabelDefaultSort": "Le tableau n'est actuellement pas trié par nombre de participations. Cliquez pour trier par ordre croissant.",
            "ariaLabelSortDown": "Le tableau est trié par nombre de participation décroissant. Cliquez pour trier en ordre croissant.",
            "ariaLabelSortUp": "Le tableau est trié par nombre de participation croissant. Cliquez pour trier en ordre décroissant.",
            "label": "Nombre de participations"
          }
        },
        "description": "Tableau des élèves trié par nom. Pour les élèves ayant fourni une méthode de connexion, vous pouvez, via un menu situé dans la colonne 'Actions', gérer les modes de connexion autorisés et réinitialiser le mot de passe de l'élève",
        "empty": "Aucun élève."
      },
      "title": "{count, plural, =0 {Élèves} =1 {Élève ({count})} other {Élèves ({count})}}"
    },
    "statistics": {
      "before-date": "au",
      "description": "Le tableau ci-dessous vous permet de visualiser le positionnement de vos participants par sujet.'<br>' Le positionnement rend compte du niveau moyen de vos participants sur le niveau maximum qu’ils auraient pu atteindre.'<br>' Ces données tiennent compte de toutes les participations partagées dans le cadre des campagnes d’évaluation non supprimées de votre organisation.",
      "empty-state": "Aucune donnée disponible",
      "level": {
        "advanced": "Avancé",
        "expert": "Expert",
        "independent": "Indépendant",
        "novice": "Novice"
      },
      "select-label": "Domaine",
      "table": {
        "caption": "Ce tableau affiche l'analyse des résultats de tous les participants par sujets. Il indique pour chaque ligne la compétence, le sujet, le taux de couverture ainsi que le niveau atteint",
        "headers": {
          "competences": "Compétences",
          "positioning": "Positionnement",
          "reached-level": "Niveau atteint",
          "topics": "Sujets"
        }
      },
      "title": "Statistiques"
    },
    "sup-organization-participant-activity": {
      "title": "Activité de l'étudiant"
    },
    "sup-organization-participants": {
      "action-bar": {
        "delete-button": "Supprimer",
        "error-message": "{count, plural, =1 {Une erreur est survenue, {firstname} {lastname} n'a pas été supprimé de la liste des étudiants.} other {Une erreur est survenue, les {count} étudiants sélectionnés n'ont pas été supprimés de la liste.}}",
        "information": "{count, plural, =1 {{count} étudiant sélectionné} other {{count} étudiants sélectionnés}}",
        "success-message": "{count, plural, =1 {{firstname} {lastname} a bien été supprimé de la liste des étudiants.} other {Les {count} étudiants sélectionnés ont bien été supprimés de la liste.}}"
      },
      "actions": {
        "download-template": "Télécharger le modèle",
        "edit-student-number": "Éditer le numéro étudiant",
        "show-actions": "Afficher les actions"
      },
      "deletion-modal": {
        "content": {
          "footer": "Attention, cette action est irréversible.",
          "header": "{count, plural, =1 {Cet étudiant ne sera plus visible} other {Ces étudiants ne seront plus visibles}} dans Pix Orga.",
          "main-campaign-prevent": "Cela impactera donc les résultats et analyses des campagnes qu' {count, plural, =1 {il a} other {ils ont}} réalisées.",
          "main-participation-prevent": "Toutes {count, plural, =1 {ses} other {leurs}} participations aux campagnes seront supprimées."
        },
        "title": "{count, plural, =1 {Supprimer '<strong>'{firstname} {lastname}'</strong>' de vos} other {Êtes-vous sûr(e) de vouloir supprimer '<strong>'{count}'</strong>'}} étudiants ?"
      },
      "edit-student-number-modal": {
        "actions": {
          "update": "Mettre à jour"
        },
        "form": {
          "error": "Le numéro étudiant ne doit pas être vide.",
          "new-student-number-label": "Nouveau numéro étudiant",
          "student-number": "Numéro étudiant actuel de {firstName} {lastName} est : ",
          "success": "La modification du numéro étudiant de {firstName} {lastName} a bien été effectuée."
        },
        "title": "Édition du numéro étudiant"
      },
      "empty-state": {
        "no-participants": "Aucun étudiants pour l’instant !",
        "no-participants-action": "L’administrateur doit importer les étudiants en cliquant sur le bouton importer."
      },
      "filter": {
        "aria-label": "Filtrer les étudiants",
        "certificability": {
          "label": "Rechercher par certificabilité",
          "placeholder": "Certificabilité"
        },
        "group": {
          "empty": "Aucun groupe",
          "label": "Entrer un groupe",
          "placeholder": "Rechercher par groupe"
        },
        "student-number": {
          "label": "Entrer un numéro étudiant",
          "placeholder": "1234658P"
        },
        "students-count": "{count, plural, =0 {0 étudiant} =1 {1 étudiant} other {{count} étudiants}}"
      },
      "page-title": "Étudiants",
      "replace-students-modal": {
        "confirm": "Oui, je remplace",
        "confirmation-checkbox": "Je confirme avoir bien compris les impacts",
        "footer-content": "Les étudiants existants dans l'application et présents dans le nouvel import ne seront pas supprimés et seront mis à jour si nécessaire.",
        "last-warning": "Attention, cette action est irréversible. Les étudiants non présents dans le nouvel import vont être supprimés de Pix Orga.",
        "main-content": "Toutes leurs participations aux campagnes seront supprimées. Cela impactera donc les résultats et analyses des campagnes qu’ils ont réalisées. Ils ne pourront plus participer aux campagnes auxquelles ils avaient participé par le passé. Cependant, ils pourront participer à de nouvelles campagnes.",
        "title": "Êtes-vous sûr(e) de vouloir remplacer les étudiants existants ?"
      },
      "table": {
        "column": {
          "date-of-birth": "Date de naissance",
          "first-name": "Prénom",
          "group": "Groupes",
          "is-certifiable": {
            "label": "Certificabilité"
          },
          "last-name": {
            "ariaLabelDefaultSort": "Le tableau n'est actuellement pas trié par nom. Cliquez pour trier par ordre alphabétique.",
            "ariaLabelSortDown": "Le tableau est trié par nom, dans l'ordre alphabétique inverse. Cliquez pour trier par ordre alphabétique.",
            "ariaLabelSortUp": "Le tableau est trié par nom, dans l'ordre alphabétique. Cliquez pour trier par ordre alphabétique inverse.",
            "label": "Nom"
          },
          "last-participation-date": "Dernière participation",
          "participation-count": {
            "ariaLabelDefaultSort": "Le tableau n'est actuellement pas trié par nombre de participations. Cliquez pour trier par ordre croissant.",
            "ariaLabelSortDown": "Le tableau est trié par nombre de participation décroissant. Cliquez pour trier en ordre croissant.",
            "ariaLabelSortUp": "Le tableau est trié par nombre de participation croissant. Cliquez pour trier en ordre décroissant.",
            "label": "Nombre de participations"
          },
          "student-number": "Numéro étudiant"
        },
        "description": "Tableau des étudiants trié par nom. Vous pouvez, via un menu situé dans une colonne supplémentaire, modifier le numéro étudiant.",
        "empty": "Aucun étudiant."
      },
      "title": "{count, plural, =0 {Étudiants} =1 {Étudiant ({count})} other {Étudiants ({count})}}"
    },
    "team-invitations": {
      "cancel-invitation": "Supprimer l’invitation",
      "invitation-cancelled-succeed-message": "L’invitation a bien été supprimée.",
      "invitation-resent-succeed-message": "L'invitation a bien été renvoyée.",
      "resend-invitation": "Renvoyer l'invitation",
      "table": {
        "column": {
          "email-address": "Adresse e-mail",
          "pending-invitation": "Date de dernier envoi"
        },
        "row": {
          "aria-label": "Invitation en attente"
        }
      },
      "title": "Invitations"
    },
    "team-list": {
      "add-member-button": "Inviter un membre",
      "tabs": {
        "invitation": "Invitations ({count, plural, =0 {-} other {{count}}})",
        "member": "Membres ({count, plural, =0 {-} other {{count}}})"
      },
      "title": "Équipe"
    },
    "team-members": {
      "actions": {
        "edit-organization-membership-role": "Modifier le rôle",
        "leave-organization": "Quitter cet espace Pix Orga",
        "manage": "Gérer",
        "remove-membership": "Supprimer",
        "save": "Enregistrer",
        "select-role": {
          "label": "Sélectionner un rôle",
          "options": {
            "admin": "Administrateur",
            "member": "Membre"
          }
        }
      },
      "modals": {
        "leave-organization": {
          "message": "Êtes-vous sûr de vouloir quitter cet espace Pix Orga ? Vous n’aurez plus accès à <strong>{organizationName}</strong>.<br/><br/>Vos campagnes restent accessibles au reste de l'équipe, elles ne seront pas archivées.<br/><br/>Vos accès à d’autres espaces Pix Orga ne seront pas impactés.<br/><br/>Vous allez être déconnecté.",
          "title": "Quitter cet espace Pix Orga"
        }
      },
      "notifications": {
        "change-member-role": {
          "error": "Une erreur est survenue lors de la modification du rôle du membre.",
          "success": "Le rôle a bien été changé."
        },
        "leave-organization": {
          "error": "Une erreur est survenue lors de la désactivation du membre.",
          "success": "Vous avez été supprimé avec succès de l'organisation {organizationName}. Vous allez être déconnecté de Pix Orga..."
        },
        "remove-membership": {
          "error": "Une erreur est survenue lors de la désactivation du membre.",
          "success": "{memberFirstName} {memberLastName} a été supprimé avec succès de votre équipe Pix Orga."
        }
      },
      "remove-membership-modal": {
        "actions": {
          "remove": "Oui, supprimer le membre"
        },
        "message": "{memberFirstName} {memberLastName} n'aura plus accès à cet espace Pix Orga.'<br>'Ses campagnes restent accessibles au reste de l'équipe.",
        "title": "Confirmez-vous la suppression ?"
      },
      "table": {
        "column": {
          "first-name": "Prénom",
          "last-name": "Nom",
          "organization-membership-role": "Rôle"
        },
        "empty": "En attente de membres"
      },
      "title": "Membres"
    },
    "team-new": {
      "email-requirement": "Saisissez ici l'adresse e-mail du membre que vous souhaitez inviter.",
      "errors": {
        "default": "Le service est momentanément indisponible. Veuillez réessayer ultérieurement.",
        "invalid-input": "Les données que vous avez soumises ne sont pas au bon format",
        "mandatory-email-field": "Ce champ est obligatoire",
        "sending-email-to-invalid-email-address": "L'envoi d'e-mail pour l'adresse {email} a échoué. Le serveur d'envoi a répondu : \"{errorMessage}\"",
        "status": {
          "400": "Le format de l'adresse e-mail est incorrect.",
          "404": "Cet email n'appartient à aucun utilisateur.",
          "412": "Ce membre a déjà été ajouté.",
          "500": "Quelque chose s'est mal passé. Veuillez réessayer."
        }
      },
      "invite-form-modal": {
        "confirm": "Valider",
        "question": "Voulez-vous continuer ? ",
        "title": "Confirmer l’ajout de nouveaux membres dans l'équipe",
        "warning": "Les membres que vous ajoutez auront accès aux résultats des participants et à l’analyse des campagnes."
      },
      "invited-members": "À la réception de l'e-mail, les invités pourront choisir de se créer un compte Pix ou de se connecter avec un compte Pix existant.",
      "several-email-requirement": "Vous pouvez inviter plusieurs membres en séparant les adresses e-mails par des virgules.",
      "success": {
        "invitation": "Une invitation a bien été envoyée à l’adresse e-mail {email}.",
        "multiple-invitations": "Une invitation a bien été envoyée aux adresses e-mails listées."
      },
      "title": "Inviter un membre",
      "warning": "Les membres que vous ajoutez ci-dessous auront accès aux résultats des participants et à l’analyse des campagnes. Veuillez vous assurer que les personnes invitées sont des membres de votre organisation."
    },
    "team-new-item": {
      "input-label": "Adresse(s) e-mail",
      "invite-button": "Inviter"
    },
    "terms-of-service": {
      "accept": "J’accepte les conditions d’utilisation",
      "title": "Conditions d'utilisation"
    }
  }
}], ["nl", {
  "api-error-messages": {
    "campaign-creation": {
      "custom-landing-page_too_long": "De presentatietekst van de campagne is te lang.",
      "external-user-id-required": "Geef de tekst op van het veld dat de deelnemers aan het begin van de test moeten invullen.",
      "id-pix-type-required": "Selecteer een extern identificatietype.",
      "name-required": "Geef je campagne een naam.",
      "owner_not_in_organization": "De eigenaar maakt geen deel uit van de organisatie.",
      "purpose-required": "Kies het doel van je campagne: Beoordeling of Verzameling van profielen.",
      "target-profile-required": "Selecteer een traject voor je campagne.",
      "title_too_long": "De campagnetitel is te lang."
    },
    "csv-import": {
      "property-not-uniq": "Regel {line}: Het veld “{field}” moet uniek zijn binnen het bestand."
    },
    "default": "De service is tijdelijk niet beschikbaar. Probeer het later nog eens.",
    "edit-student-number": {
      "student-number-exists": "Het ingevoerde studentnummer is al in gebruik door de student {firstName} {lastName}"
    },
    "global": "Er is een fout opgetreden. Probeer het later nog eens.",
    "or-separator": "of",
    "student-csv-import": {
      "bad-csv-format": "Het bestand moet in csv-formaat zijn met als scheidingsteken komma’s of puntkomma's.",
      "encoding-not-supported": "Bestandscodering niet ondersteund.",
      "field-bad-values": "Regel {line}: Het veld \"{field}\" moet zijn \"{valids}\".",
      "field-date-format": "Regel {line}: Het veld \"{field}\" moet het format “{acceptedFormat}” hebben.",
      "field-email-format": "Regel {line}: Het veld \"{field}\" moet een geldig e-mailadres zijn.",
      "field-length": "Regel {line}: Het veld \"{field}\" moet {limit} karakters lang zijn.",
      "field-max-length": "Regel {line}: Het veld \"{field}\" moet minder dan {limit} tekens zijn.",
      "field-min-length": "Regel {line}: Het veld \"{field}\" moet minstens {limit} tekens lang zijn.",
      "field-required": "Regel {line}: Het veld \"{field}\" is verplicht.",
      "header-required": "De kolom \"{field}\" is verplicht.",
      "header-unknown": "De kolomtitels moeten identiek zijn aan die van het model.",
      "identifier-unique": "Regel {line}: Het veld \"{field}\" in deze regel komt meerdere keren voor in het bestand.",
      "insee-code-invalid": "Regel {line}: Het veld \"{field}\" is niet in INSEE-formaat.",
      "payload-too-large": "De bestandsgrootte moet kleiner zijn dan {maxSize} MB.",
      "student-number-format": "Regel {line}: Het veld \"{field}\" mag geen speciale tekens bevatten.",
      "student-number-unique": "Regel {line}: Het veld “{field}” moet uniek zijn binnen het bestand."
    },
    "student-password-reset": {
      "organization-learner-does-not-belong-to-organization-error": "Sommige van de geselecteerde studenten maken niet langer deel uit van deze organisatie.",
      "organization-learner-without-username-error": "Sommige van de geselecteerde studenten hebben geen gebruikersnaam meer. Vernieuw de pagina.",
      "user-does-not-belong-to-organization-error": "Je hebt niet langer de rechten voor deze organisatie."
    },
    "student-xml-import": {
      "birth-city-code-required-for-french-student": "Een student met INE {nationalStudentId} heeft geen geboorteplaatscodeveld. Het is verplicht voor alle studenten die in Frankrijk geboren zijn.",
      "birthdate-required": "Bij de student met de ID {nationalStudentId} is het veld geboortedatum niet ingevuld. Dit is verplicht voor elke leerling.",
      "empty": "Studenten moeten een INE en een klas hebben.",
      "encoding-not-supported": "Bestandscodering niet ondersteund.",
      "first-name-required": "{nationalStudentId} Bij leerlingen met de INE is het veld voornaam niet ingevuld. Het is verplicht voor elke leerling.",
      "ine-required": "Het INE-veld is verplicht voor elke student.",
      "ine-unique": "De INE {nationalStudentId} komt meerdere keren voor in het bestand voor verschillende studenten.",
      "invalid-birthdate-format": "De student met de INE {nationalStudentId} heeft niet het juiste format voor de geboortedatum. Deze moet in het format 'DD/MM/JJJJ' zijn.",
      "invalid-file": "Het bestand is niet conform.",
      "invalid-file-extension": "Uitbreiding {fileExtension} niet ondersteund.",
      "last-name-required": "{nationalStudentId} Bij een leerling met een INE van is het veld Achternaam niet ingevuld. Dit is verplicht voor alle leerlingen.",
      "payload-too-large": "De bestandsgrootte moet kleiner zijn dan {maxSize} MB.",
      "sex-code-required": "Bij de student met de INE {nationalStudentId} is het veld geslacht niet ingevuld. Dit is verplicht voor elke student.",
      "uai-mismatched": "De UAI in het SIECLE-bestand komt niet overeen met die van jouw instelling."
    }
  },
  "application": {
    "description": "Het platform gewijd aan educatieve evaluatie en opvolging. Met je Pix Orga ruimte kun je een beoordelingscampagne starten of Pix-profielen verzamelen, de voortgang van je studenten of leerlingen in een campagne volgen of hun resultaten bekijken."
  },
  "banners": {
    "certification": {
      "message": "'<strong>'Certificaten:'</strong>' Vergeet niet om '<'a href={documentationLink} class=\"{linkClasses}\" target=\"_blank\" rel=\"noopener noreferrer\"'>'de sessies af te ronden in Pix Certif'</a>' en de certificaten hier te downloaden via het tabblad \"Certificaten\" voor de start van het schooljaar {year}."
    },
    "import": {
      "message": "Belangrijke fasen in het schooljaar :",
      "step1a": "Implement&nbsp;: '<'a href='https://cloud.pix.fr/s/WjTnkSbFs9TDcSC' title='Gids download resultaten' class='link link--banner link--bold link--underlined''>'download resultaten'</a>' certificering en",
      "step1b": "Importeren",
      "step1c": "studentendatabase (admin)",
      "step2": "'<'a href='https://cloud.pix.fr/s/RaPpKjFHNX2kSR4' title='Gids voor het lanceren van back-to-school cursussen' class='link- banner link-old link--underlined' '>'Campagnes maken'</a>' (cursussen rentrée, 6e, thematisch, disciplinair, gericht...).",
      "step3": "Certificering van lerenden. '<'a href='https://cloud.pix.fr/s/2q4c4QT9jGbGbEq' title='Gids Certificering van lerenden voorbereiden en organiseren' class='link link--banner link--bold link--underlined' '>'Lees meer over de nieuwe certificering'</a>'."
    },
    "language-availability": {
      "message": "Jouw taal is nog niet beschikbaar op Pix Orga. Voor jouw gemak wordt de applicatie in het Engels weergegeven. Het Pix-team werkt eraan om jouw taal toe te voegen."
    },
    "last-places-lot-available": {
      "message": "{days, number} Houd er rekening mee dat je tickets over enkele dagen verlopen."
    },
    "maximum-places-exceeded": {
      "message": "<b>Uw organisatie heeft geen plaatsen meer beschikbaar !</b><br />Om gebruik te kunnen maken van alle mogelijkheden, kunt u een aantal plaatsen vrijmaken. Neem contact op met uw Pix-vertegenwoordiger of '<'a href='https://pix.org/en/support-contact-form' title='contact met ons' class=\"{linkClasses}\" '>contact met ons op via dit formulier</a>'."
    },
    "over-capacity": {
      "message": "Houd er rekening mee dat je meer plaats inneemt dan je totale capaciteit."
    },
    "survey": {
      "message": "Help Pix Orga te evolueren door deze korte enquête te beantwoorden over hoe jij campagnes gebruikt! '<'a href={documentationLink} class=\"{linkClasses}\" target=\"_blank\" rel=\"noopener noreferrer\"'>'Toegang tot de enquête'</a>'"
    }
  },
  "cards": {
    "available-seats-count": {
      "title": "Beschikbare plaatsen",
      "value": "/{total} plaatsen"
    },
    "badges-acquisitions": {
      "information": "Hier vind je het aantal badges die je deelnemers in deze campagne hebben behaald en hun percentage.",
      "obtained": "verkregen",
      "title": "Badges"
    },
    "occupied-seats-count": {
      "anonymous": "inclusief {count, plural, =1 {1 plaats} other {{count, number} plaatsen}} met toegang zonder account",
      "title": "Plaatsen bezet",
      "value": "/{total} plaatsen"
    },
    "participants-average-results": {
      "information": "Hier vind je de gemiddelde resultaten van je campagne. Dit aantal omvat alle deelnemers die hun test hebben afgerond en hun resultaten hebben ingestuurd.",
      "title": "Gemiddeld resultaat"
    },
    "participants-average-stages": {
      "information": "Hier kun je het gemiddelde aantal deelnemers van je campagne zien. Dit aantal omvat alle deelnemers die hun test hebben afgerond en hun resultaten hebben ingestuurd.",
      "title": "Gemiddelde succesratio "
    },
    "participants-count": {
      "information": "Hier vind je het totale aantal deelnemers van je campagne. Dit aantal omvat alle deelnemers die de code hebben ingevoerd en aan hun test zijn begonnen of hun profiel hebben ingezonden.",
      "loader": "Het totale aantal deelnemers laden",
      "title": "Totaal aantal deelnemers"
    },
    "place-info": {
      "with-account": {
        "heading": "'<strong>'De deelnemer heeft een Pix-account:'</strong>'",
        "message-description": "Je kunt plaatsen vrijmaken door deelnemers te verwijderen van het tabblad Deelnemers.",
        "message-main": "1 deelnemer met ten minste één deelname aan een campagne = 1 plaats bezet."
      },
      "without-account": {
        "heading": "'<strong>'De deelnemer heeft geen Pix-account'</strong>' (campagne met toegang zonder account):",
        "message-description": "U kunt deze ruimten vrijmaken door items in de campagne zonder accounttoegang te verwijderen of door de campagne te verwijderen.",
        "message-main": "1 deelname zonder account = 1 plaats bezet."
      }
    },
    "submitted-count": {
      "information": "Hier vind je de resultaten die door je deelnemers zijn verzonden. Dit aantal omvat alle deelnemers die klaar zijn en op de knop \"Ik verstuur mijn resultaten\" of \"Ik verstuur mijn profiel\" hebben geklikt.",
      "loader": "Ontvangen resultaten of profielen laden",
      "title": "Ontvangen resultaten",
      "title-profiles": "Ontvangen profielen"
    }
  },
  "charts": {
    "participants-by-day": {
      "captions": {
        "shared": "Totaal aantal deelnemers per dag die hun resultaten instuurden",
        "shared-profile": "Totaal aantal deelnemers dat per dag hun profiel instuurde",
        "started": "Totaal aantal deelnemers per dag"
      },
      "labels-a11y": {
        "date": "Datum",
        "shared": "Totaal aantal deelnemers die hun resultaten hebben ingestuurd",
        "shared-profile": "Totaal aantal deelnemers die hun profiel hebben ingestuurd",
        "started": "Totaal aantal deelnemers"
      },
      "labels-legend": {
        "shared": "Ontvangen resultaten",
        "shared-profile": "Ontvangen profielen",
        "started": "Totaal aantal deelnemers"
      },
      "loader": "Deelnemersactiviteit laden",
      "title": "Deelnemersactiviteit"
    },
    "participants-by-mastery-percentage": {
      "label-a11y": "Van {from, number, ::percent} tot {to, number, ::percent}: {count, plural, =0 {0 deelnemer} =1 {1 deelnemer} other {{count, number} deelnemers}}",
      "loader": "Laden van de verdeling van deelnemers per resultaat",
      "title": "Verdeling van deelnemers per resultaat",
      "tooltip": {
        "label": "Aantal deelnemers: {count}",
        "legend": "{from, number, ::percent} - {to, number, ::percent}",
        "title": "Resultaten {legend}"
      }
    },
    "participants-by-stage": {
      "loader": "Laden van de verdeling van deelnemers per succesratio",
      "participants": "{count, plural, =0 {0 deelnemer} =1 {1 deelnemer} other {{count, number} deelnemers}}",
      "title": "Verdeling van deelnemers naar succesratio"
    },
    "participants-by-status": {
      "a11y-title": "Detail per status",
      "labels-a11y": {
        "completed": "{count, plural, =0 {0 deelnemer} =1 {1 deelnemer} other {{count, number} deelnemers}} in afwachting van insturen",
        "shared": "{count, plural, =0 {0 deelnemer} =1 {1 deelnemer} other {{count, number} deelnemers}} die hun resultaten hebben ingestuurd",
        "shared-profile": "{count, plural, =0 {0 deelnemer} =1 {1 deelnemer} other {{count, number} deelnemers}} die hun profiel hebben ingestuurd",
        "started": "{count, plural, =0 {0 deelnemer} =1 {1 deelnemer} other {{count, number} deelnemers}} bezig met test"
      },
      "labels-legend": {
        "completed-assessment": "In afwachting van verzending ({count})",
        "completed-assessment-tooltip": "In afwachting van verzending: Deze deelnemers hebben hun test afgerond maar hun resultaten nog niet ingestuurd.",
        "completed-profile": "In afwachting van verzending ({count})",
        "completed-profile-tooltip": "In afwachting van verzending: Deze deelnemers hebben hun profiel nog niet ingestuurd.",
        "shared": "Ontvangen resultaten ({count})",
        "shared-profile": "Ontvangen profielen ({count})",
        "shared-profile-tooltip": "Ontvangen profielen: Deze deelnemers hebben hun profiel ingestuurd.",
        "shared-tooltip": "Resultaten ontvangen: Deze deelnemers hebben hun test afgerond en hun resultaten ingestuurd.",
        "started": "Bezig ({count})",
        "started-tooltip": "Bezig: Deze deelnemers hebben hun test nog niet voltooid."
      },
      "labels-tooltip": {
        "completed-assessment": "In afwachting van verzending: {percentage, number, ::percent .0}",
        "completed-profile": "In afwachting van verzending: {percentage, number, ::percent .0}",
        "shared": "Ontvangen resultaten: {percentage, number, ::percent .0}",
        "shared-profile": "Ontvangen profielen: {percentage, number, ::percent .0}",
        "started": "Bezig: {percentage, number, ::procent .0}"
      },
      "loader": "Laden verhoudingen per status",
      "title": "Statussen"
    }
  },
  "common": {
    "actions": {
      "back": "Terug",
      "cancel": "Annuleren",
      "close": "Sluiten",
      "confirm": "Bevestigen",
      "global": "Acties",
      "link-to-participant": "Alle activiteiten van de deelnemer bekijken"
    },
    "api-error-messages": {
      "bad-request-error": "De gegevens die je hebt opgegeven, hebben niet het juiste format.",
      "gateway-timeout-error": "De service ondervindt vertragingen. Probeer het later nog eens.",
      "internal-server-error": "Er is een interne fout opgetreden. Onze teams zijn bezig het probleem op te lossen. Probeer het later nog eens.",
      "login-unauthorized-error": "Het ingevoerde e-mailadres en/of wachtwoord is onjuist.",
      "login-user-blocked-error": "Je account is geblokkeerd omdat je te veel inlogpogingen hebt gedaan. Hef de blokkering op door contact op te nemen via'<'a href=\"{url}\"'>'contact'</a>'.",
      "login-user-temporary-blocked-error": "Je hebt te veel inlogpogingen gedaan. Probeer het later nog eens of klik op '<'a href=\"{url}\"'>'wachtwoord vergeten'</a>' om het opnieuw in te stellen."
    },
    "breadcrumb": "Leidraad",
    "filters": {
      "actions": {
        "clear": "Alle filters verwijderen"
      },
      "divisions": {
        "empty": "Geen klas",
        "label": "Zoeken op klas",
        "placeholder": "Klassen"
      },
      "fullname": {
        "label": "Zoeken op voor- en achternaam",
        "placeholder": "Achternaam, voornaam"
      },
      "loading": "Laden...",
      "placeholder": "-- Selecteer --",
      "title": "Filters"
    },
    "form": {
      "mandatory-all-fields": "Alle velden zijn verplicht.",
      "mandatory-fields": "geeft een verplicht veld aan",
      "mandatory-fields-title": "verplicht"
    },
    "fullname": "{firstName} {lastName}",
    "help-form": "https://support.pix.fr/support/tickets/new",
    "home-page": "Startpagina van Pix Orga",
    "import": {
      "field": {
        "birthdate": "Geboortedatum",
        "division": "Klasse",
        "oralization": "Oralisatie"
      }
    },
    "loading": "Bezig met laden",
    "no-content": "Geen inhoud",
    "result": {
      "accessibility-description": "Verkregen resultaat = {percentage, number, ::percent}, ofwel de succesratio {stage} op {totalStage}",
      "percentage": "{value, number, ::percent}",
      "stages": "{count, plural, =0 {0 sterren} =1 {1 ster} other {{count, number} sterren}} op {total}"
    },
    "target-profile-details": {
      "results": {
        "common": "Resultaten weergegeven in",
        "percent": "percentage",
        "star": "ster"
      },
      "simplified-access": {
        "with-account": "Toegang account",
        "without-account": "Toegang zonder account"
      },
      "subjects": "Onderwerpen: {value, number}",
      "thematic-results": "Badges: {value, number}"
    }
  },
  "components": {
    "analysis-per-competence": {
      "cover-rate-gauge-label": "Je deelnemers hebben een niveau bereikt van {reachedLevel} uit een maximaal haalbaar niveau van {maxLevel}.",
      "description": "Hieronder staan de campagnevaardigheden en hun beschrijvingen, evenals de positionering van de deelnemers.",
      "table": {
        "caption": "Competenties",
        "column": {
          "competences": "Naam en beschrijving van de competentie",
          "level": "Niveau",
          "positioning": "Positionering"
        }
      }
    },
    "analysis-per-tube": {
      "cover-rate-gauge-label": "Over het onderwerp hebben je deelnemers een niveau van {reachedLevel} gehaald uit een maximaal haalbaar niveau van {maxLevel}.",
      "description": "Hieronder vind je de campagneonderwerpen en hun beschrijvingen, evenals de standpunten van de deelnemers.",
      "table": {
        "caption": "{index} - {name}",
        "column": {
          "level": "Niveau",
          "positioning": "Positionering",
          "tubes": "Naam en beschrijving van het onderwerp"
        }
      }
    },
    "analysis-per-tube-or-competence": {
      "title": "Gedetailleerde positionering",
      "toggle": {
        "label": "Bekijken door:",
        "label-competences": "Competenties",
        "label-tubes": "Onderwerpen"
      }
    },
    "campaign": {
      "type": {
        "explanation": {
          "ASSESSMENT": "Beoordelingscampagne",
          "EXAM": "Vraagmodus [beta]",
          "PROFILES_COLLECTION": "Campagne profielverzameling"
        },
        "information": {
          "ASSESSMENT": "Beoordeling",
          "EXAM": "Vraagmodus [beta]",
          "PROFILES_COLLECTION": "Profielverzameling"
        }
      }
    },
    "certificability": {
      "placeholder-select": "Certificeerbaar / Niet certificeerbaar"
    },
    "certificability-tooltip": {
      "aria-label": "Uitleg over certificeerbaarheid",
      "content": "Certificeerbaarheid betekent dat de deelnemer niveau 1 heeft bereikt in ten minste 5 verschillende vaardigheden.",
      "from-collect-notice": "De informatie is afkomstig van de profielverzamelingscampagnes die door de deelnemer zijn uitgevoerd. Als de deelnemer zijn profiel al heeft ingestuurd, worden de datum en status van de laatste verzending weergegeven.",
      "from-compute-certificability": "Deze status wordt automatisch bijgewerkt (elke 24 uur) en tijdens profielverzamelingscampagnes."
    },
    "cover-rate-gauge": {
      "label": "Op deze campagne hebben je deelnemers een niveau bereikt van {reachedLevel} uit een maximaal haalbaar niveau van {maxLevel}."
    },
    "date": {
      "no-date": "Nog geen datum"
    },
    "global-positioning": {
      "description": "De algehele positionering is het gemiddelde niveau dat deelnemers hebben bereikt (paarse balk) vergeleken met het maximum dat ze in deze campagne hadden kunnen bereiken (witte balk).",
      "gauge-label": "Bij deze test behaalden je deelnemers een gemiddeld niveau van {reachedLevel} uit een maximaal haalbaar niveau van {maxLevel}.",
      "title": "Wereldwijde positionering"
    },
    "group": {
      "SCO": "Klas",
      "SUP": "Groep"
    },
    "import-information-banner": {
      "error": "Fout bij importeren",
      "error-link": "(zie de importpagina).",
      "in-progress": "Bezig met importeren",
      "in-progress-link": "(controleer importstatus).",
      "success": "De deelnemers zijn geïmporteerd op {date} door {firstName} {lastName}."
    },
    "organization-participants-header": {
      "default": {
        "title": "{count, plural, =0 {Deelnemers} =1 {Participant ({count})} other {Deelnemers ({count})}}"
      },
      "import-button": "Importeren",
      "sco": {
        "title": "{count, plural, =0 {Leerlingen} =1 {Leerlingen ({count})} other {Leerlingen ({count})}}"
      },
      "sco-title": "{count, plural, =0 {Leerling} =1 {Leerling ({count})} other {Leerlingen ({count})}}",
      "title": "{count, plural, =0 {Deelnemer} =1 {Deelnemer ({count})} other {Deelnemers ({count})}}"
    },
    "participation-status": {
      "SHARED-ASSESSMENT": "Ontvangen resultaten",
      "SHARED-PROFILES_COLLECTION": "Profiel ontvangen",
      "STARTED-ASSESSMENT": "Bezig",
      "TO_SHARE-ASSESSMENT": "In afwachting van verzending",
      "TO_SHARE-PROFILES_COLLECTION": "In afwachting van verzending"
    },
    "terms-of-service": {
      "actions": {
        "accept": "Accepteren en doorgaan",
        "document-link": "Gebruiksvoorwaarden lezen",
        "reject": "Weigeren en stoppen"
      },
      "message": {
        "requested": "Lees en accepteer onze servicevoorwaarden om Pix te blijven gebruiken.",
        "update-requested": "We hebben onze Servicevoorwaarden bijgewerkt. Bekijk de wijzigingen en accepteer ze om verder te gaan."
      },
      "title": {
        "requested": "Accepteer onze servicevoorwaarden",
        "update-requested": "Belangrijke update van de servicevoorwaarden"
      }
    },
    "ui": {
      "deletion-modal": {
        "confirm-deletion": "Ja, verwijderen",
        "confirmation-checkbox": "Ik kan bevestigen dat ik de gevolgen van de {count} schrappingen volledig begrijp. "
      }
    }
  },
  "navigation": {
    "assessment-individual-results": {
      "aria-label": "Navigatie door het deel met individuele beoordelingsresultaten"
    },
    "campaign-page": {
      "aria-label": "Navigeren door het deel campagnedetails"
    },
    "credits": {
      "number": "{count, plural, =0 {0 credit} =1 {1 credit} other {{count, number} credits}}",
      "tooltip-text": "Het aantal weergegeven credits komt overeen met het aantal credits dat door de organisatie is verworven en momenteel geldig is (ongeacht hun activering). Neem voor meer informatie contact met ons op via '<a href=mailto:pro@pix.fr>'pro@pix.fr'</a>'."
    },
    "external-link-title": "Open in a new window",
    "footer": {
      "a11y": "Toegankelijkheid: gedeeltelijk conform",
      "aria-label": "Navigatie voetnoot",
      "copyrights": "©",
      "legal-notice": "Wettelijke informatie",
      "pix": "Pix",
      "server-status": "Status diensten"
    },
    "main": {
      "aria-label": "Hoofdnavigatie",
      "attestations": "certificaten",
      "campaigns": "Campagnes",
      "certifications": "Certificeringen",
      "close": "Sluit de navigatie",
      "documentation": "Documentatie",
      "home": "Home",
      "missions": "Opdrachten",
      "open": "Open navigatie",
      "organization-participants": "Deelnemers",
      "places": "Plaatsen",
      "sco-organization-participants": "Leerlingen",
      "statistics": "Statistieken",
      "sup-organization-participants": "Studenten",
      "support": "Helpcentrum",
      "team": "Team"
    },
    "places": {
      "link": "Zie details",
      "number": "{count, plural, =0 {0 plaatsen beschikbaar} =1 {1 plaats beschikbaar} other {{count} plaatsen beschikbaar}}"
    },
    "school-sessions": {
      "activate-button": "De sessie activeren",
      "extend-button": "De sessie verlengen",
      "status": {
        "active-label": "Sessie actief tot {sessionExpirationDate}",
        "aria-label": "Uitleg over de sessie",
        "code-label": "Schoolcode",
        "inactive-label": "Sessie inactief",
        "info-text": "Leerlingen kunnen alleen toegang krijgen tot opdrachten als de sessie actief is.'<br>' Aan het einde van de sessie worden leerlingen die midden in een opdracht zitten niet uitgelogd.",
        "title": "Status sessie"
      }
    },
    "team-members": {
      "aria-label": "Navigeren door het gedeelte Team"
    },
    "user-logged-menu": {
      "button": "Veranderende organisatie",
      "logout": "Uitloggen"
    }
  },
  "pages": {
    "assessment-individual-results": {
      "badges": "Badges",
      "breadcrumb-current-page-label": "Deelname van {firstName} {lastName}",
      "participation-label": "Deelname #{participationNumber}",
      "participation-not-shared": "Resultaten niet verzonden",
      "participation-selector": "Een deelname kiezen",
      "participation-shared": "Verzonden resultaten",
      "progression": "Voortgang",
      "result": "Resultaat",
      "tab": {
        "results": "Resultaten",
        "review": "Analyse"
      },
      "table": {
        "column": {
          "competences": "Vaardigheden ({count, plural, =0 {-} other {{count}}})",
          "results": {
            "label": "Resultaten",
            "tooltip": "'<span class=\"screen-reader-only\">'Deze deelnemer heeft bevestigd'</span>' {result, number, ::percent} '<span class=\"screen-reader-only\">'van de vaardigheid {competence}.'</span>'"
          }
        },
        "empty": "In afwachting van resultaten",
        "title": "Resultaten per vaardigheid"
      },
      "title": "Resultaten voor {firstName} {lastName}"
    },
    "attestations": {
      "PARENTHOOD": "Attestation de sensibilisation au numérique",
      "SIXTH_GRADE": "Attestation de sensibilisation au numérique",
      "basic-description": "Alle attesten exporteren",
      "download-attestations-button": "Downloaden (.pdf)",
      "no-attestations": "Er zijn geen certificaten beschikbaar voor jouw selectie",
      "section": {
        "download": "Downloaden",
        "list": "Follow-up"
      },
      "select-divisions-label": "Selecteer de certificaten voor een of meer klassen",
      "select-label": "Certificat",
      "table": {
        "column": {
          "division": "Klasse",
          "first-name": "Voornaam",
          "last-name": "Naam",
          "status": "Verkrijgen"
        },
        "filter": {
          "divisions": {
            "empty-option": "Klasse",
            "label": "Klasse"
          },
          "legend": "Filters voor de tabel met certificaten: invoervelden kunnen worden gebruikt om de tabel te filteren op de voor- of achternaam van een leerling en op klas. Met knoppen kun je de behaalde certificaten filteren of niet.",
          "results": "{total, plural, =0 {0 resultaat} =1 {1 resultaat} other {{total, number} resultaten}}",
          "status": {
            "empty-option": "Verkrijgen / Niet verkregen",
            "label": "Verkrijgen",
            "not-obtained": "Niet verkregen",
            "obtained": "Verkrijgen"
          }
        },
        "status": {
          "not-obtained": "Niet verkregen",
          "obtained": "Verkregen op {date}"
        }
      },
      "title": "Certificaten"
    },
    "campaign": {
      "actions": {
        "export-results": "Resultaten exporteren (.csv)",
        "unarchive": "Campagne de-archiveren"
      },
      "archived": "Gearchiveerde campagne",
      "code": "Code",
      "copy": {
        "code": {
          "default": "De code kopiëren",
          "success": "Gekopieerd"
        },
        "link": {
          "default": "De directe link kopiëren",
          "success": "Gekopieerd"
        }
      },
      "created-by": "Eigenaar",
      "created-on": "Gemaakt op",
      "empty-state": "Geen deelnemers op het moment",
      "empty-state-with-copy-link": "Geen deelnemers op het moment! Stuur ze de volgende link om mee te doen aan je campagne.",
      "multiple-sendings": {
        "status": {
          "disabled": "Nee",
          "enabled": "Ja"
        },
        "title": "Meervoudig verzenden"
      },
      "name": "Naam Campagne",
      "tab": {
        "activity": "Activiteit",
        "results": "Resultaten ({count, number})",
        "review": "Analyse",
        "settings": "Instellingen"
      }
    },
    "campaign-activity": {
      "actions": {
        "delete": "Verwijderen"
      },
      "delete-participation-modal": {
        "actions": {
          "cancel": "Nee",
          "confirmation": "Ja, verwijderen"
        },
        "error": "Er is een probleem opgetreden bij het verwijderen van de deelname.",
        "success": "Deelname werd succesvol verwijderd.",
        "text": "Als je een deelname gaat verwijderen, is deze niet langer zichtbaar of opgenomen in de campagnestatistieken.",
        "title": "De deelname van <strong>{firstName} {lastName}</strong> verwijderen?",
        "warning": {
          "assessment-campaign-participation": {
            "shared-participation": "De deelnemer heeft geen toegang meer tot de resultaten van deze test.",
            "started-participation": "De deelnemer kan deze test niet voltooien.",
            "to-share-participation": "The Participant will not be able to send in their results."
          },
          "profiles-collection-campaign-participation": {
            "shared-participation": "De deelnemer zal niet langer kunnen deelnemen aan deze profielverzameling.",
            "to-share-participation": "Deelnemers kunnen hun profiel niet verzenden."
          }
        }
      },
      "table": {
        "column": {
          "delete": "Deelname verwijderen",
          "first-name": "Voornaam",
          "last-name": "Achternaam",
          "participationCount": "Aantal deelnames",
          "status": "Status"
        },
        "delete-button-label": "Deelname verwijderen",
        "empty": "Geen deelnemers",
        "see-results": "Bekijk de resultaten van {firstName} {lastName}",
        "title": "Lijst van deelnemers"
      },
      "title": "Activiteit"
    },
    "campaign-analysis": {
      "description": {
        "explanation": "Elke toets beoordeelt een selectie van digitale vaardigheden uit het Pix referentiekader. De positionering geeft het gemiddelde niveau weer dat deelnemers hebben bereikt ten opzichte van het maximaal haalbare niveau op de toets.",
        "nota-bene": "Alle gepresenteerde gegevens zijn afkomstig van gedeelde en niet verwijderde deelname aan beoordelingscampagnes en worden in realtime bijgewerkt.",
        "resume": "Analyseer op onderwerp of vaardigheid, de positionering van je deelnemers aan deze campagne, die een selectie van onderwerpen uit het Pix-referentiekader omvat."
      },
      "levels-correspondence": {
        "infos": {
          "link": "https://pix.org/nl-be/scores-en-niveaus",
          "text": "Meer weten over niveaus."
        },
        "levels": {
          "advanced": "5 of 6: Advanced level",
          "beginner": "1 of 2: Beginnersniveau",
          "expert": "7 of 8: Expert level",
          "independent": "3 of 4: Independent level"
        },
        "title": "Correspondentie tussen niveaus"
      },
      "second-title": "Analyse van resultaten",
      "title": "Uitleg"
    },
    "campaign-creation": {
      "actions": {
        "create": "De campagne maken",
        "delete": "Wissen"
      },
      "copy-of": "Kopie van",
      "external-id-label": {
        "label": "Type externe user-ID",
        "question-label": "Wil je een externe gebruikers-ID aanvragen?",
        "required": "De externe id is verplicht",
        "suggestion": "Voorbeeld: \"Studentnummer\" of \"Professioneel e-mailadres\" *."
      },
      "external-id-type": {
        "question-label": "Wat is het type externe identifier?"
      },
      "landing-page-text": {
        "label": "Tekst op de startpagina",
        "sublabel": "Dit veld wordt weergegeven voor deelnemers aan de campagne."
      },
      "legal-warning": "* In overeenstemming met de Franse wet op gegevensbescherming en als verantwoordelijke voor de verwerking van de gegevens, vragen we niet naar bijzonder identificerende of belangrijke gegevens, tenzij dit absoluut noodzakelijk is. Het burgerservicenummer (BSN) moet worden vermeden, net als gevoelige gegevens.",
      "multiple-sendings": {
        "assessments": {
          "info": "Als je ervoor kiest om meerdere inzendingen te verzenden, kan de deelnemer de campagne 4 dagen later opnieuw uitvoeren en zijn resultaten meerdere keren verzenden door de code opnieuw in te voeren. In Pix Orga zie je hun laatste inzending.",
          "question-label": "Wil je deelnemers toestaan hun resultaten meer dan één keer te versturen?"
        },
        "info-title": "Meervoudig verzenden",
        "knowledge-elements-resettable": "Als onderdeel van de cursus kunnen deelnemers proberen hun resultaten te verbeteren door alle vragen in de cursus opnieuw te maken.",
        "profiles": {
          "info": "Als je kiest voor meervoudige verzending, kunnen deelnemers hun profiel meerdere keren versturen door de campagnecode opnieuw in te voeren. In Pix Orga vind je het laatst verzonden profiel.",
          "question-label": "Wil je deelnemers toestaan hun profiel meerdere keren te versturen?"
        }
      },
      "name": {
        "label": "Naam Campagne"
      },
      "no": "Nee",
      "owner": {
        "info": "De eigenaar van de campagne en de beheerders van deze organisatie zijn de enige personen die deze campagne kunnen wijzigen of archiveren.",
        "label": "Eigenaar van de campagne",
        "placeholder": "Naam en voornaam eigenaar",
        "search-placeholder": "Een eigenaar zoeken",
        "title": "Eigenaar van de campagne"
      },
      "purpose": {
        "assessment": "Deelnemers evalueren",
        "assessment-info": "Een beoordelingscampagne stelt deelnemers in staat om getest te worden op specifieke onderwerpen.",
        "exam": "Vraagmodus [beta]",
        "exam-info": "Met een campagne in de “quizmodus” kunnen deelnemers worden getest op specifieke onderwerpen, zonder rekening te houden met hun gebruikersprofiel of er invloed op te hebben. De aangeboden tests zijn gepersonaliseerd voor elke deelnemer, afhankelijk van hoe ver ze gevorderd zijn in het traject.",
        "label": "Wat is het doel van je campagne?",
        "profiles-collection": "Pix-profielen van deelnemers verzamelen",
        "profiles-collection-info": "Een campagne voor het verzamelen van profielen wordt gebruikt om het profiel van de deelnemers te achterhalen: niveaus per vaardigheid en pix-score.",
        "profiles-collection-info-certificability-calculation": "De certificeerbare status wordt automatisch bijgewerkt in het tabblad '<'a href=\"/eleves\" class=\"{linkClasses}\"'>'Studenten'</a>'."
      },
      "tags": {
        "BACK_TO_SCHOOL": "Terug naar school cursus / 6e",
        "COMPETENCES": "De 16 vaardigheden",
        "CUSTOM": "Cursus op maat",
        "DISCIPLINE": "Disciplines",
        "OTHER": "Autres",
        "PIX_PLUS": "Pix+",
        "PREDEFINED": "Vooraf gedefinieerde test",
        "SUBJECT": "Thema's",
        "TARGETED": "Gerichte cursussen"
      },
      "tags-title": "Filter zoekopdracht:",
      "target-profiles-category-label": "Filter tests op categorie",
      "target-profiles-category-placeholder": "Categorieën",
      "target-profiles-label": "Selecteer een test",
      "target-profiles-list-label": "Wat wil je testen?",
      "target-profiles-search-placeholder": "Zoeken op naam",
      "test-title": {
        "label": "Titel test",
        "sublabel": "Dit veld wordt weergegeven voor deelnemers aan de campagne."
      },
      "title": "Een campagne maken",
      "yes": "Ja"
    },
    "campaign-individual-results": {
      "shared-date": "Verzonden op",
      "start-date": "Begonnen op"
    },
    "campaign-individual-review": {
      "title": "Analyse voor {firstName} {lastName}"
    },
    "campaign-modification": {
      "actions": {
        "edit": "Wijzigen"
      },
      "campaign-modification-success-message": "De wijzigingen zijn opgeslagen.",
      "campaign-name": "Naam Campagne",
      "landing-page-text": {
        "label": "Tekst op de startpagina",
        "sublabel": "Dit veld wordt weergegeven voor deelnemers aan de campagne."
      },
      "owner": {
        "info": "De eigenaar van de campagne en de beheerders van deze organisatie zijn de enige personen die deze campagne kunnen wijzigen en archiveren.",
        "label": "Eigenaar van de campagne",
        "placeholder": "Naam en voornaam eigenaar",
        "title": "Eigenaar van de campagne"
      },
      "personalised-test-title": {
        "label": "Titel test",
        "sublabel": "Dit veld wordt weergegeven voor deelnemers aan de campagne."
      },
      "title": "Een campagne wijzigen"
    },
    "campaign-results": {
      "average": "Gemiddelde van de resultaten",
      "filters": {
        "aria-label": "Filters op deelnames",
        "participations-count": "{count, plural, =0 {0 deelnemer} =1 {1 deelnemer} other {{count} deelnemers}}",
        "type": {
          "badges": "Verkregen onderwerpen",
          "groups": {
            "empty": "Geen groep",
            "title": "Groepen"
          },
          "stages": "Succesratio",
          "status": {
            "empty": "Alle statussen",
            "title": "Status"
          },
          "unacquired-badges": "Thema's niet verkregen"
        }
      },
      "result": "Resultaat",
      "table": {
        "badge-tooltip": {
          "acquired": "Verworven",
          "unacquired": "Niet verworven"
        },
        "caption": "In deze tabel staan de deelnemers die hun resultaten hebben gedeeld. Voor elke deelnemer worden de achternaam, voornaam en resultaten weergegeven.",
        "column": {
          "ariaSharedResultCount": "Aantal verzonden resultaten",
          "badges": "Badges",
          "evolution": "Evolutie",
          "first-name": "Voornaam",
          "last-name": "Achternaam",
          "results": {
            "label": "Resultaten",
            "on-hold": "In afwachting van verzending",
            "under-test": "Test bezig"
          },
          "sharedResultCount": "Aantal verzonden resultaten"
        },
        "empty": "Geen deelname",
        "evolution": {
          "decrease": "In verval",
          "increase": "In uitvoering",
          "stable": "Constante",
          "unavailable": "Niet beschikbaar"
        },
        "evolution-tooltip": {
          "content": "Evolutie van de deelnemer tussen hun laatste twee gedeelde resultaten."
        },
        "title": "Lijst van ontvangen resultaten"
      },
      "tested-items": "Beoordeelde verworvenheden",
      "title": "Resultaten",
      "validated-items": "Bevestigde items"
    },
    "campaign-review": {
      "description": "Afhankelijk van het geteste kader en de resultaten van de campagne, zal Pix je deze onderwerpen aanbevelen om op te focussen, gerangschikt op mate van relevantie {bubble}.",
      "sub-table": {
        "column": {
          "source": {
            "value": "Door {source}"
          }
        },
        "title": "{count, plural, =1 {1 tutorial aanbevolen} other{{count} tutorials aanbevolen}} door de Pix Community"
      },
      "sub-title": "Aanbeveling van onderwerpen om aan te werken",
      "table": {
        "analysis": {
          "caption": "Tabel met onderwerpen om aan te werken, sommige met extra kolommen met het aantal tutorials over het onderwerp en de toegang hiertoe.",
          "column": {
            "relevance": {
              "ariaLabelDefaultSort": "De tabel is momenteel niet gesorteerd op relevantie. Klik om in oplopende volgorde te sorteren.",
              "ariaLabelSortDown": "De tabel is gesorteerd op aflopende volgorde van relevantie. Klik om in oplopende volgorde te sorteren.",
              "ariaLabelSortUp": "De tabel is gesorteerd op oplopende relevantie. Klik om aflopend te sorteren.",
              "label": "Relevantie"
            },
            "subjects": "Onderwerpen ({count, plural, =0 {-} other {{count}}})",
            "tutorial": {
              "aria-label": "De lijst met tutorials weergeven"
            },
            "tutorial-count": {
              "aria-label": "Aantal aanbevolen tutorials",
              "value": "{count, plural, =1 {1 tutorial} other {{count} tutorials}}"
            }
          },
          "recommendations": {
            "moderately-recommended": "Enigszins aanbevolen",
            "recommended": "Aanbevolen",
            "strongly-recommended": "Sterk aanbevolen",
            "very-strongly-recommended": "Zeer aanbevolen"
          }
        },
        "competences": {
          "column": {
            "competences": "Vaardigheden ({count})",
            "results": {
              "label": "Resultaten",
              "tooltip": "'<span class=\"screen-reader-only\">'De deelnemers valideerden</span>' {result} % '<span class=\"screen-reader-only\">'van de vaardigheid {competence}.'</span>'"
            }
          },
          "title": "Resultaten per vaardigheid"
        },
        "empty": "In afwachting van resultaten"
      },
      "title": "Analyse"
    },
    "campaign-settings": {
      "actions": {
        "archive": "Archiveren",
        "duplicate": "Dupliceren",
        "edit": "Wijzigen"
      },
      "campaign-type": {
        "assessment": "Beoordelingscampagne",
        "exam": "Quiz-kampanje [beta]",
        "profiles-collection": "Verzamelcampagne profielen",
        "title": "Soort campagne"
      },
      "direct-link": "Directe link",
      "external-user-id-label": "Type externe user-ID",
      "external-user-id-types": {
        "email": "E-mail",
        "string": "Andere"
      },
      "landing-page-text": "Tekst op de startpagina",
      "multiple-sendings": {
        "status": {
          "disabled": "Nee",
          "enabled": "Ja"
        },
        "title": "Meervoudig verzenden",
        "tooltip": {
          "aria-label": "Beschrijving van meervoudige verzending",
          "text": "Als meervoudige verzending is geactiveerd, kan de deelnemer zijn deelname meerdere keren versturen door de campagnecode opnieuw in te voeren. Je vindt de laatst verzonden inzending in Pix Orga."
        }
      },
      "personalised-test-title": "Titel test",
      "reset-to-zero": {
        "status": {
          "disabled": "Nee",
          "enabled": "Ja"
        },
        "title": "Reset",
        "tooltip": {
          "aria-label": "Beschrijving van Reset",
          "text": "Als de reset-functie is geactiveerd, kan de deelnemer de hele tests opnieuw doorlopen en zijn resultaten meerdere keren terugsturen door de campagnecode opnieuw in te voeren."
        }
      },
      "target-profile": {
        "title": "Test",
        "tooltip": "Beschrijving test"
      },
      "title": "Instellingen"
    },
    "campaigns-list": {
      "action": {
        "campaign": {
          "archived": "Gearchiveerd",
          "label": "Actieve of gearchiveerde campagnes weergeven",
          "ongoing": "Actief"
        },
        "create": "Een campagne maken"
      },
      "action-bar": {
        "delete-button": "Verwijderen",
        "error-message": "{count, plural, =1 {Er is een fout opgetreden, de campagne is niet verwijderd uit de lijst.} other {Er is een fout opgetreden, de{count} geselecteerde campagnes zijn niet verwijderd uit de lijst.}}",
        "information": "{count, plural, =1 {{count} geselecteerde campagne} other {{count} geselecteerde campagnes}}",
        "success-message": "{count, plural, =1 {De campagne is verwijderd uit de lijst.} other {De {count} geselecteerde campagnes zijn verwijderd uit de lijst.}}"
      },
      "deletion-modal": {
        "confirmation-checkbox": "Ik kan bevestigen dat ik de gevolgen van de {count} schrappingen volledig begrijp. ",
        "content": {
          "footer": "Houd er rekening mee dat deze actie onomkeerbaar is.",
          "header": "{count, plural, =1 {Deze campagne zal niet langer zichtbaar zijn} other {Deze campagnes zullen niet langer zichtbaar zijn}} in Pix Orga.",
          "main-participation-prevent": "Alle deelnames voor {count, plural, =1 {deze campagne} other {deze campagnes}} en hun resultaten worden verwijderd."
        },
        "title": "{count, plural, =1 {Weet je zeker dat je de geselecteerde campagne wilt verwijderen?} other {Weet je zeker dat je de '<strong>'{count}'</strong>' geselecteerde campagnes ?}}"
      },
      "filter": {
        "by-name": "Een campagne zoeken",
        "by-owner": "Een eigenaar zoeken",
        "legend": "Filters voor de campagnetabel: invoervelden kunnen worden gebruikt om de tabel te filteren op campagnenaam en naam van de eigenaar. Knoppen kunnen worden gebruikt om actieve en gearchiveerde campagnes te filteren.",
        "results": "{total, plural, =0 {0 campagne} =1 {1 campagne} other {{total, number} campagnes}}"
      },
      "navigation": "Navigeren door het gedeelte Campagnes",
      "no-campaign": "Geen campagne, klik om te beginnen op de knop 'Een campagne maken'.",
      "table": {
        "column": {
          "code": "Code",
          "created-by": "Eigenaar",
          "created-on": "Gemaakt op",
          "mainCheckbox": "Hele kolom selecteren/deselecteren",
          "name": "Naam Campagne",
          "participants": "Deelnemers",
          "results": "Ontvangen resultaten"
        },
        "description-all-campaigns": "Deze tabel geeft een overzicht van alle campagnes die zijn aangemaakt in je Pix Orga-ruimte. Voor elke campagne staat de code, de eigenaar, de datum waarop de campagne is gemaakt, het aantal deelnemers en het aantal ontvangen resultaten.",
        "description-my-campaigns": "In deze tabel staan de campagnes waarvan je de eigenaar bent. Voor elke campagne wordt de code weergegeven, de aanmaakdatum, het aantal deelnemers en het aantal ontvangen resultaten.",
        "empty": "Geen campagne"
      },
      "tabs": {
        "all-campaigns": "Alle campagnes",
        "my-campaigns": "Mijn campagnes"
      },
      "title": "Campagnes"
    },
    "certifications": {
      "description": "Selecteer de klas waarvoor je de certificeringsresultaten wilt exporteren (.csv) of de certificaten wilt downloaden (.pdf).'<br>' Je kunt deze lijst filteren door de naam van de klas direct in het veld in te voeren.",
      "documentation-link": "https://cloud.pix.fr/s/8pJqgNNntwDtsDY",
      "documentation-link-label": "Interpretatie van de resultaten.",
      "documentation-link-notice": "Volg deze link voor meer informatie over de interpretatie van de resultaten:",
      "download-attestations-button": "Getuigschriften downloaden",
      "download-button": "Resultaten exporteren",
      "errors": {
        "invalid-division": "De klas {selectedDivision} bestaat niet.",
        "no-certificates": "Geen bewijs van certificering voor de klas {selectedDivision}.",
        "no-results": "Geen bewijs van certificering voor de klas {selectedDivision}."
      },
      "no-students-imported-yet": "In dit tabblad vind je de resultaten en certificaten van de studenten. Eerst moet je de studentendatabase van je instelling importeren.",
      "select-label": "Klas",
      "title": "Resultaten certificering"
    },
    "join-request-form": {
      "firstname": "Je voornaam",
      "lastname": "Je achternaam",
      "legal-information": {
        "link-text": "Meer info over mijn rechten.",
        "link-url": "https://pix.fr/dp-formulaire-recuperation-pixorga-sco",
        "text": "De informatie die op dit formulier wordt verzameld, wordt opgenomen in een bestand dat door de GIP Pix wordt verwerkt in opdracht van het Franse Ministerie van Onderwijs, als verantwoordelijke voor de verwerking van de gegevens, zodat je instelling toegang kan krijgen tot de Pix Orga-portal door een uitnodiging te sturen om lid te worden van deze ruimte."
      },
      "organization-code": "UAI/RNE van de instelling"
    },
    "login": {
      "choose-language-aria-label": "Taal selecteren",
      "title": "Inloggen"
    },
    "login-form": {
      "active-or-retrieve": "Are you a headteacher? Activate or become the administrator of your school's Pix Orga space",
      "email": "E-mailadres",
      "errors": {
        "empty-password": "Het veld wachtwoord is verplicht.",
        "invalid-email": "Je e-mailadres is ongeldig.",
        "should-change-password": "Je hebt momenteel een tijdelijk wachtwoord. Klik op '<'a href=\"{url}\"'>'wachtwoord vergeten'</a>' om het opnieuw in te stellen.",
        "status": {
          "403": "Toegang tot Pix Orga is beperkt tot uitgenodigde leden. Elke ruimte wordt beheerd door een Pix Orga-beheerder die specifiek is voor de organisatie die het gebruikt. Neem contact met hem/haar op om je uit te nodigen.",
          "404": "Het ingevoerde e-mailadres en/of wachtwoord is onjuist.",
          "409": "Deze uitnodiging is al geaccepteerd of geannuleerd."
        }
      },
      "forgot-password": "Wachtwoord vergeten?",
      "invitation-already-accepted": "Deze uitnodiging is al geaccepteerd. Log in of neem contact op met de beheerder van je Pix Orga-ruimte.",
      "invitation-was-cancelled": "Deze uitnodiging is niet langer geldig. Neem contact op met de beheerder van je Pix Orga-ruimte.",
      "is-only-accessible": "Toegang tot Pix Orga is beperkt tot uitgenodigde leden. Neem contact op met de Pix Orga-beheerder van je organisatie om je uit te nodigen.",
      "login": "Ik log in",
      "only-for-admin": "Gereserveerd voor directiepersoneel van openbare en privéscholen onder contract.",
      "password": "Wachtwoord"
    },
    "login-or-register": {
      "login-form": {
        "button": "Inloggen",
        "title": "Ik heb al een PIX-account"
      },
      "register-form": {
        "button": "Aanmelden",
        "errors": {
          "default": "De service is tijdelijk niet beschikbaar. Probeer het later nog eens.",
          "email-already-exists": "Dit e-mailadres is al geregistreerd, log in.",
          "invalid-or-already-used-email": "Invalid or already used e-mail address"
        },
        "fields": {
          "button": {
            "label": "Ik meld me aan"
          },
          "cgu": {
            "accept": "Ik accepteer de",
            "and": "en de",
            "aria-label": "De gebruiksvoorwaarden van Pix accepteren",
            "data-protection-policy": "privacybeleid",
            "error": "Je moet de gebruiksvoorwaarden en het privacybeleid van Pix accepteren om een account aan te maken.",
            "terms-of-use": "gebruiksvoorwaarden van Pix"
          },
          "email": {
            "error": "Je e-mailadres is ongeldig.",
            "label": "E-mailadres"
          },
          "first-name": {
            "error": "Je voornaam is niet ingevuld.",
            "label": "Voornaam"
          },
          "last-name": {
            "error": "Je achternaam is niet ingevuld.",
            "label": "Achternaam"
          },
          "password": {
            "error": "Je wachtwoord moet minstens 8 tekens lang zijn en minstens één hoofdletter, één kleine letter en één cijfer bevatten.",
            "label": "Wachtwoord"
          }
        },
        "title": "Ik meld me aan"
      },
      "title": "Je bent uitgenodigd om lid te worden van de organisatie {organizationName}"
    },
    "missions": {
      "list": {
        "actions": {
          "see-mission-details": "Zie details"
        },
        "aria-label": "Opdracht",
        "banner": {
          "copypaste-container": {
            "abstract": "Start je eerste opdrachten met je studenten door de sessie te activeren via de knop hierboven en door de code te gebruiken",
            "button": {
              "success": "gekopieerd !",
              "tooltip": "de link kopiëren"
            }
          },
          "hint": "Aarzel niet om toe te voegen aan je favorieten.",
          "import-text": "link school",
          "step1": {
            "admin": {
              "head": "Stap 1: <b>Gelieve</b>.",
              "link": "de studentendatabase importeren",
              "tail": "<b>Van Onde</b> (exporteerbaar bestand in het menu Lijsten & documenten > Uittreksels > Schoolleerlingen of hun begeleiders <b>door alleen leerlingen uit cyclus 3 te selecteren</b>)."
            },
            "non-admin": "Stap 1: <b>Vraag de beheerder</b> Pix Orga van je ruimte om de leerlingen te importeren."
          },
          "step2": {
            "option1": "Gebruik&nbsp<b>de link</b>&nbsp'<'a href=\"{pixJuniorUrl}\"'>'junior.pix.fr'</a>'.&nbspDe code voor je school wordt elke keer gevraagd als je inlogt.",
            "option2": {
              "body": "of gebruik de directe link&nbsp'<'a href=\"{pixJuniorUrl}\" target=_blank >junior.pix.fr/schools/{code}'</a>",
              "hint": "Je kunt deze favoriet opslaan op de computers."
            },
            "title": "Stap 2: Om leerlingen toegang te geven tot de Pix Junior-ruimte van je school, kun je :"
          },
          "step3": "Stap 3: <b>Activeer de Pix Junior sessie</b> met de knop in de sidebar. <b>Deze actie moet voor elke sessie met je leerlingen worden uitgevoerd</b>.",
          "welcome": "Hallo en welkom bij Pix Orga!"
        },
        "caption": "Lijst van opdrachten",
        "empty-state": "Er zijn geen opdrachten",
        "headers": {
          "actions": "Acties",
          "competences": "Vaardigheden waaraan is gewerkt",
          "name": "Opdracht",
          "started-by": "Gestart door"
        },
        "no-division": "Geen klas",
        "non-admin": {
          "abstract": "Om te beginnen vraag je je beheerder om de studenten te importeren."
        }
      },
      "mission": {
        "details": {
          "button-label": "Bekijk het educatieve blad",
          "competence": {
            "title": "Vaardigheden waaraan is gewerkt :"
          },
          "objective": {
            "title": "Missie doelstellingen :"
          }
        },
        "table": {
          "activities": {
            "aria-label": "Student",
            "caption": "Tabel van studenten met hun deelname aan de missie {missionName}",
            "filters": {
              "aria-label": "Filter studenten",
              "learners-count": "{count, plural, =0 {Geen student} =1 {1 student} other {{count} studenten}}",
              "status": {
                "label": "Status opdracht"
              }
            },
            "headers": {
              "division": "Klasse",
              "first-name": "Voornaam",
              "last-name": "Achternaam",
              "status": "Status opdracht"
            },
            "mission-status": {
              "completed": "Voltooid",
              "not-started": "Niet gestart",
              "started": "Actief"
            },
            "no-data": "Er zijn geen deelnemers"
          },
          "result": {
            "aria-label": "Student",
            "caption": "Tabel van studenten met de resultaten van hun deelname aan de opdracht {missionName}",
            "filters": {
              "aria-label": "Filter studenten",
              "global-result": {
                "label": "Missiebeoordeling",
                "options": {
                  "exceeded": "Overtroffen",
                  "no-result": "Geen beoordeling",
                  "not-reached": "Niet bereikt",
                  "partially-reached": "Gedeeltelijk bereikt",
                  "reached": "Bereikt"
                }
              },
              "learners-count": "{count, plural, =0 {Geen student} =1 {1 student} other {{count} studenten}}"
            },
            "headers": {
              "dare-challenge": "Uitdaging",
              "division": "Klasse",
              "first-name": "Voornaam",
              "last-name": "Achternaam",
              "result": "Positionering",
              "step": "Stap {number}"
            },
            "mission-dare-result": {
              "not-reached": "NB",
              "reached": "B",
              "undefined": "-"
            },
            "mission-result": {
              "exceeded": "Overtroffen",
              "not-reached": "Niet bereikt",
              "partially-reached": "Gedeeltelijk bereikt",
              "reached": "Bereikt",
              "undefined": "-"
            },
            "no-data": "Er zijn geen deelnemers",
            "step-result": {
              "not-reached": "NB",
              "partially-reached": "GB",
              "reached": "B",
              "undefined": "-"
            }
          }
        },
        "tabs": {
          "activities": "Activiteiten",
          "aria-label": "Navigatie tussen de activiteit of resultaten van de missie",
          "results": "Resultaten"
        },
        "title": "Details van een opdracht"
      },
      "title": "Opdrachten"
    },
    "organization-learner": {
      "activity": {
        "assessment-summary": "Samenvatting van deelname aan beoordelingscampagnes",
        "cards": {
          "shared": "Verzonden: {count}",
          "started": "Bezig: {count}",
          "title": {
            "assessment": "Beoordelingen",
            "profiles-collection": "Verzamelingen van profielen"
          },
          "to-share": "In afwachting van: {count}"
        },
        "empty-state": "Momenteel geen activiteit! Stuur een campagne naar {organizationLearnerFirstName} {organizationLearnerLastName} en begin met het bijhouden van de voortgang.",
        "participation-list": {
          "table": {
            "column": {
              "campaign-name": "Campagne",
              "campaign-type": "Type",
              "created-at": "Startdatum",
              "participation-count": "Aantal deelnames",
              "shared-at": "Verzenddatum",
              "status": "Status"
            }
          }
        },
        "participations-title": "Lijst van alle deelnames",
        "profile-collection-summary": "Samenvatting van deelname aan profielverzamelingscampagnes",
        "title": "Activiteit"
      },
      "header": {
        "aria-label-title": "Detailpagina van {firstName} {lastName}"
      }
    },
    "organization-participant-activity": {
      "title": "Activiteit deelnemer"
    },
    "organization-participants": {
      "action-bar": {
        "delete-button": "Verwijderen",
        "error-message": "{count, plural, =1 {Er is een fout opgetreden, {firstname} {lastname} is niet verwijderd uit de deelnemerslijst.} other {Er is een fout opgetreden, de {count} geselecteerde deelnemers zijn niet verwijderd uit de lijst.}}",
        "information": "{count, plural, =1 {{count} geselecteerde deelnemer} other {{count} geselecteerde deelnemers}}",
        "success-message": "{count, plural, =1 {{firstname} {lastname} is verwijderd van de lijst met deelnemers.} other {De {count} geselecteerde deelnemers zijn verwijderd van de lijst.}}"
      },
      "deletion-modal": {
        "confirmation-checkbox": "Ik kan bevestigen dat ik de gevolgen van de {count} schrappingen volledig begrijp. ",
        "content": {
          "footer": "Houd er rekening mee dat deze actie onomkeerbaar is.",
          "header": "{count, plural, =1 {Deze deelnemer is niet meer zichtbaar} other {Deze deelnemers zijn niet meer zichtbaar}} in Pix Orga.",
          "main-campaign-prevent": "Dit heeft invloed op de resultaten en analyses van de campagnes die {count, plural, =1 {hij/zij heeft} other {zij hebben}} uitgevoerd.",
          "main-participation-prevent": "Alle campagne-items {count, plural, =1 {van hem} other {van hen}} worden verwijderd. "
        },
        "title": "{count, plural, =1 {Verwijder '<strong>'{firstname} {lastname}’</strong>' uit jouw deelnemers?} other {Weet je zeker dat je '<strong>'{count}'</strong>'}} deelnemers wilt verwijderen?"
      },
      "empty-state": {
        "action": "Mijn campagnes bekijken",
        "call-to-action": "Nodig ze uit om deel te nemen aan een campagne of om een nieuwe campagne aan te maken.",
        "message": "Geen deelnemers op het moment"
      },
      "filters": {
        "aria-label": "Filters deelnemers",
        "participations-count": "{count, plural, =0 {0 deelnemer} =1 {1 deelnemer} other {{count} deelnemers}}",
        "students-count": "{count, plural, =0 {0 leerling} =1 {1 leerling} other {{count} leerlingen}}",
        "type": {
          "certificability": {
            "label": "Zoeken op certificeerbaarheid",
            "placeholder": "Certificeerbaarheid"
          }
        }
      },
      "page-title": "Deelnemers",
      "table": {
        "actions": {
          "disable-oralization": "Deactivate oralization",
          "enable-oralization": "Activate oralization"
        },
        "column": {
          "checkbox": "Selecteren/Deselecteren {firstname} {lastname}",
          "first-name": "Voornaam",
          "is-certifiable": {
            "label": "Certificeerbaarheid"
          },
          "last-name": {
            "ariaLabelDefaultSort": "De tabel is momenteel niet gesorteerd op naam. Klik op om alfabetisch te sorteren.",
            "ariaLabelSortDown": "De tabel is gesorteerd op naam, in omgekeerde alfabetische volgorde. Klik om alfabetisch te sorteren.",
            "ariaLabelSortUp": "De tabel is alfabetisch gesorteerd op naam. Klik op om in omgekeerde alfabetische volgorde te sorteren.",
            "label": "Achternaam"
          },
          "latest-participation": {
            "ariaLabelDefaultSort": "De tabel is momenteel niet gesorteerd op datum van deelname. Klik om in oplopende volgorde te sorteren.",
            "ariaLabelSortDown": "De tabel is gesorteerd op aflopende datum van deelname. Klik om in oplopende volgorde te sorteren.",
            "ariaLabelSortUp": "De tabel is gesorteerd op datum van deelname in oplopende volgorde. Klik om aflopend te sorteren.",
            "label": "Laatste deelname"
          },
          "mainCheckbox": "Hele kolom selecteren/deselecteren",
          "participation-count": {
            "ariaLabelDefaultSort": "De tabel is momenteel niet gesorteerd op aantal deelnames. Klik op om in oplopende volgorde te sorteren.",
            "ariaLabelSortDown": "De tabel is gesorteerd op aflopend aantal deelnames. Klik op om in oplopende volgorde te sorteren.",
            "ariaLabelSortUp": "De tabel is gesorteerd op oplopend aantal deelnames. Klik om aflopend te sorteren.",
            "label": "Aantal deelnames"
          }
        },
        "description": "Tabel met deelnemers gesorteerd op naam.",
        "empty": "Geen deelnemers",
        "oralization-header-tooltip": "Door ‘leesinstructies’ te activeren, kan de student zijn mondelinge transcriptie krijgen.",
        "row-value": {
          "oralization": {
            "false": "Gedeactiveerd",
            "true": "Geactiveerd"
          }
        }
      }
    },
    "organization-participants-import": {
      "actions": {
        "add-sup": {
          "details": "Hiermee kun je een lijst met studenten toevoegen aan de lijst die al geïmporteerd is en/of de gegevens van studenten die al zijn geïmporteerd, wijzigen.",
          "label": "Studenten toevoegen",
          "title": "Toevoegen/wijzigen"
        },
        "participants": {
          "details": "Met deze actie kun je:",
          "details-add": "nieuwe deelnemers toevoegen",
          "details-disable": "voormalige deelnemers deactiveren",
          "details-update": "reeds geïmporteerde deelnemers wijzigen",
          "label": "De lijst importeren",
          "title": "De deelnemerslijst importeren"
        },
        "replace": {
          "details": "Hiermee kun je een nieuwe lijst met studenten importeren in plaats van de bestaande.",
          "label": "Een nieuwe lijst importeren",
          "title": "Vervangen"
        }
      },
      "banner": {
        "anchor-error": "De lijst met foutmeldingen bekijken",
        "fix-error-text": "Corrigeer de fouten en importeer het bestand opnieuw.",
        "import-error": "De import van deelnemers is mislukt.",
        "import-in-progress": "De inhoud van het bestand is gevalideerd en de deelnemers worden geïmporteerd.",
        "in-progress-text": "Vernieuw deze pagina over enkele ogenblikken om de status van het bestand te controleren.",
        "retry-error-text": "Er is een fout opgetreden, importeer later of schrijf naar Pix support.",
        "upload-completed": "Het bestand werd geïmporteerd op {date} door {firstName} {lastName}.",
        "upload-error": "Het bestand kon niet worden geïmporteerd.",
        "upload-in-progress": "Het importeren van het bestand kan enkele minuten duren. Verlaat deze pagina niet.",
        "validation-error": "De inhoud van het bestand bevat fouten.",
        "validation-in-progress": "De inhoud van het bestand wordt momenteel gevalideerd.",
        "warning-banner": "Sommige waarden zijn niet herkend. Ze zijn vervangen door \"Niet herkend\". Als je van mening bent dat er waarden ontbreken in de lijst, neem dan contact met ons op via '<a href=\"mailto:sup@pix.fr\">'sup@pix.fr'</a></div>'."
      },
      "error-panel": {
        "error-wrapper": "Er zijn geen deelnemers geïmporteerd. Wijzig het bestand en importeer het opnieuw.",
        "global-error": "Er zijn geen deelnemers geïmporteerd. Probeer het opnieuw of neem contact met ons op via '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.pix.fr/support/tickets/new\">'het supportformulier'</a>'.",
        "title": "Fouten in het laatst geïmporteerde bestand:"
      },
      "file-type-separator": ",",
      "global-success": "Laatste bestand succesvol geïmporteerd op {date} door {firstName} {lastName}.",
      "sco": {
        "title": "Leerlingen importeren"
      },
      "sup": {
        "title": "Studenten importeren"
      },
      "supported-formats": "(ondersteunde formats: {types})",
      "title": "Importeren",
      "warnings": {
        "diploma": "Niet erkende diploma's: {diplomas};",
        "study-scheme": "Niet-erkende programma’s: {studySchemes};"
      }
    },
    "participants-list": {
      "latest-participation-information-tooltip": {
        "aria-label": "Informatie over laatste deelname",
        "campaign-ASSESSMENT-type": "Beoordeling",
        "campaign-PROFILES_COLLECTION-type": "Verzameling profielen",
        "campaign-name": "Campagne:",
        "campaign-status": "Status:",
        "campaign-type": "Type:",
        "participation-SHARED-status": "Ontvangen",
        "participation-STARTED-status": "Bezig",
        "participation-TO_SHARE-status": "In afwachting van verzending"
      }
    },
    "places": {
      "before-date": "op",
      "places-lots": {
        "statuses": {
          "active": "Actief",
          "expired": "Vervallen",
          "pending": "Binnenkort"
        },
        "table": {
          "caption": "Tabel met de ticketaankopen van je organisatie. Voor elke aankoop zie je: het aantal plaatsen, de activeringsdatum, de vervaldatum en de status (actief, binnenkort of verlopen). De tabel is gerangschikt op basis van de status van de aankopen en de vervaldatum.",
          "empty-state": "Er is momenteel geen plaats!",
          "headers": {
            "activation-date": "Datum van activering",
            "count": "Aantal plaatsen",
            "expiration-date": "Vervaldatum",
            "status": "Status"
          },
          "title": "Aankoopgeschiedenis van tickets"
        }
      },
      "title": "Plaatsen"
    },
    "preselect-target-profile": {
      "download": "Downloaden selectie onderwerpen ({ numberOfTubesSelected }) (JSON, { fileSize }kB)",
      "download-filename": "selectie-onderwerpen-{ organizationName }-{ date }.json",
      "no-tube-selected": "Downloaden selectie onderwerpen (JSON, { fileSize }kB)",
      "table": {
        "caption": "Selectie van onderwerpen",
        "column": {
          "action": "Selectie",
          "mobile": "Geschikt voor smartphone",
          "name": "Naam onderwerp",
          "tablet": "Geschikt voor tablet",
          "theme-name": "Naam van thema"
        },
        "is-responsive": "ja",
        "not-responsive": "nee",
        "row-title": "Onderwerp"
      },
      "title": "Selectie van onderwerpen"
    },
    "profiles-individual-results": {
      "breadcrumb-current-page-label": "Deelname van {firstName} {lastName}",
      "certifiable": "Certificeerbaar",
      "competences-certifiables": "CERTIFICEERBARE VAARD",
      "pix": "Pix",
      "pix-score": "{score, number}",
      "table": {
        "column": {
          "level": "Niveau",
          "pix-score": "Pix-score",
          "skill": "Vaardigheid"
        },
        "empty": "In afwachting van resultaten",
        "title": "Resultaten per vaardigheid"
      },
      "title": "Profiel van {firstName} {lastName}"
    },
    "profiles-list": {
      "table": {
        "caption": "Deze tabel bevat de lijst met deelnemers die hun profiel hebben gedeeld. Het geeft voor elke deelnemer zijn achternaam, voornaam, de verzonden datum, de Pix-score, de evolutie, de certificeerbaarheidsstatus en het aantal certificeerbare competenties.",
        "column": {
          "ariaSharedProfileCount": "Aantal profielaandelen",
          "certifiable": "Certificeerbaar",
          "certifiable-tag": "Certificeerbaar",
          "competences-certifiables": "Certificeerbare vaard.",
          "evolution": "Evolutie",
          "first-name": "Voornaam",
          "last-name": "Achternaam",
          "pix-score": {
            "label": "Pix-score",
            "value": "{score, number}"
          },
          "sending-date": {
            "label": "Verzenddatum",
            "on-hold": "In afwachting van verzending"
          },
          "sharedProfileCount": "Aantal profielaandelen"
        },
        "empty": "In afwachting van profielen",
        "evolution": {
          "decrease": "In verval",
          "increase": "In uitvoering",
          "stable": "Constante",
          "unavailable": "Niet beschikbaar"
        },
        "evolution-tooltip": {
          "content": "Evolutie van de pix score tussen de laatste twee profielaandelen."
        },
        "title": "Lijst van ontvangen profielen"
      },
      "title": "Ontvangen profielen"
    },
    "sco-organization-participant-activity": {
      "title": "Activiteit van de student"
    },
    "sco-organization-participants": {
      "action-bar": {
        "generate-username-password-button": "Aanmeldingen en/of wachtwoorden genereren voor geselecteerde studenten",
        "information": "{count, plural, =1 {{count} geselecteerde student} other {{count} geselecteerde studenten}}",
        "reset-password-button": "Reset de wachtwoorden van geselecteerde studenten"
      },
      "actions": {
        "manage-account": "Account beheren",
        "show-actions": "Acties weergeven"
      },
      "connection-types": {
        "email": "E-mailadres",
        "empty": "-",
        "identifiant": "Gebruikersnaam",
        "mediacentre": "Mediacentrum",
        "none": "Geen",
        "without-mediacentre": "Zonder Mediacentrum"
      },
      "filter": {
        "aria-label": "Filters voor studenten",
        "certificability": {
          "label": "Zoeken op certificeerbaarheid",
          "placeholder": "Certificeerbaarheid"
        },
        "division": {
          "empty": "Geen klas",
          "label": "Zoeken op klas"
        },
        "first-name": {
          "label": "Zoeken op voornaam"
        },
        "last-name": {
          "label": "Zoeken op achternaam"
        },
        "login-method": {
          "empty-option": "Inlogmethode",
          "label": "Zoeken op inlogmethode"
        },
        "students-count": "{count, plural, =0 {0 studenten} =1 {1 student} other {{count} studenten}}"
      },
      "generate-username-password-modal": {
        "content-message-1": "Studenten die nog geen inlogmethode hebben, moeten een campagne op jouw school doorlopen om hun PIX-account aan te maken.",
        "content-message-2": "Er wordt een CSV-bestand gegenereerd met de gebruikersnamen en eenmalige wachtwoorden.",
        "content-message-3": "Deel deze nieuwe eenmalige wachtwoorden met je leerlingen. Wanneer ze inloggen met dit wachtwoord, zal Pix hen vragen een nieuw wachtwoord in te voeren.",
        "title": "Aanmeldingen en/of wachtwoorden genereren voor geselecteerde studenten",
        "warning-message": "Een login en wachtwoord worden gegenereerd voor studenten die toegang hebben tot het Mediacenter en/of een e-mailadres. Studenten die al een login hebben, krijgen een nieuw wachtwoord."
      },
      "manage-authentication-method-modal": {
        "authentication-methods": "Inlogmethoden",
        "copied": "Gekopieerd",
        "error": {
          "default": "Er is een interne fout opgetreden. Onze teams zijn bezig het probleem op te lossen. Probeer het later nog eens.",
          "unexpected": "Er is iets fout gegaan. Probeer het opnieuw."
        },
        "section": {
          "add-username": {
            "button": "Gebruikersnaam toevoegen",
            "label": "Een verbinding met een gebruikersnaam toevoegen"
          },
          "email": {
            "copy": "E-mailadres kopiëren",
            "label": "E-mailadres"
          },
          "mediacentre": {
            "label": "Mediacentrum"
          },
          "password": {
            "copy": "Het unieke wachtwoord kopiëren",
            "label": "Nieuw eenmalig wachtwoord",
            "warning-1": "Geef dit nieuwe wachtwoord door aan je student.",
            "warning-2": "De student logt in met dit eenmalige wachtwoord.",
            "warning-3": "Pix vraagt een nieuw wachtwoord te kiezen."
          },
          "reset-password": {
            "button": "Wachtwoord resetten",
            "warning": "De reset verwijdert het huidige wachtwoord van de leerling."
          },
          "username": {
            "copy": "Gebruikersnaam kopiëren",
            "label": "Gebruikersnaam"
          }
        },
        "title": "Het Pix-account van de student beheren"
      },
      "messages": {
        "password-reset-success": "De wachtwoorden van de geselecteerde studenten zijn gereset."
      },
      "no-participants": "Tot nu toe geen studenten!",
      "no-participants-action": "De beheerder moet de studentendatabase importeren door op de knop importeren te klikken.",
      "page-title": "Leerlingen",
      "reset-password-modal": {
        "content-message-1": "Voor {totalSelectedStudents, plural, =1 {<strong>{totalSelectedStudents} student</strong> geselecteerd} other {<strong>{totalSelectedStudents} studenten</strong> geselecteerd}}, {totalAffectedStudents, plural, =0 {<strong>zal het wachtwoord</strong> niet worden gereset} =1 {het wachtwoord van <strong>{totalAffectedStudents} student</strong> zal worden gereset} other {de wachtwoorden van <strong>{totalAffectedStudents} studenten</strong> zullen worden gereset}}.\n\n\n",
        "content-message-2": "Er wordt een CSV-bestand gegenereerd met de gebruikersnamen en eenmalige wachtwoorden.",
        "content-message-3": "Communiceer deze nieuwe eenmalige wachtwoorden aan de studenten. Wanneer ze inloggen met dit wachtwoord, zal Pix hen vragen een nieuw wachtwoord in te voeren.",
        "title": "<strong>Wachtwoorden</strong> van studenten opnieuw instellen met <strong>gebruikersnaam</strong>.",
        "warning-message": "Alleen inlogwachtwoorden kunnen opnieuw worden ingesteld. Toegang via e-mailadres en Mediacentrum worden niet beïnvloed."
      },
      "table": {
        "column": {
          "checkbox": "Selecteren/Deselecteren {firstname} {lastname}",
          "date-of-birth": "Geboortedatum",
          "division": {
            "ariaLabelDefaultSort": "De tabel is momenteel niet gesorteerd op klas. Klik om alfanumeriek te sorteren.",
            "ariaLabelSortDown": "De tabel is gesorteerd op klas, in omgekeerde alfanumerieke volgorde. Klik om te sorteren op alfanumerieke volgorde.",
            "ariaLabelSortUp": "De tabel is gesorteerd op klas, in alfanumerieke volgorde. Klik om in omgekeerde alfanumerieke volgorde te sorteren.",
            "label": "Klas"
          },
          "first-name": "Voornaam",
          "is-certifiable": {
            "eligible": "Certificeerbaar",
            "label": "Certificeerbaarheid",
            "non-eligible": "Niet Certificeerbaar",
            "not-available": "Niet gecommuniceerd"
          },
          "last-name": {
            "ariaLabelDefaultSort": "De tabel is momenteel niet gesorteerd op naam. Klik op om alfabetisch te sorteren.",
            "ariaLabelSortDown": "De tabel is gesorteerd op naam, in omgekeerde alfabetische volgorde. Klik om alfabetisch te sorteren.",
            "ariaLabelSortUp": "De tabel is alfabetisch gesorteerd op naam. Klik op om in omgekeerde alfabetische volgorde te sorteren.",
            "label": "Achternaam"
          },
          "last-participation-date": "Laatste deelname",
          "login-method": "Inlogmethode(n)",
          "mainCheckbox": "Hele kolom selecteren/deselecteren",
          "participation-count": {
            "ariaLabelDefaultSort": "De tabel is momenteel niet gesorteerd op aantal deelnames. Klik op om in oplopende volgorde te sorteren.",
            "ariaLabelSortDown": "De tabel is gesorteerd op aflopend aantal deelnames. Klik op om in oplopende volgorde te sorteren.",
            "ariaLabelSortUp": "De tabel is gesorteerd op oplopend aantal deelnames. Klik om aflopend te sorteren.",
            "label": "Aantal deelnames"
          }
        },
        "description": "Studententabel gesorteerd op naam. Voor studenten die een inlogmethode hebben opgegeven, kun je een menu in de kolom 'Acties' gebruiken om de geautoriseerde inlogmethoden te beheren en het wachtwoord van de student opnieuw in te stellen.",
        "empty": "Geen studenten."
      },
      "title": "{count, plural, =0 {Studenten} =1 {Studenten ({count})} other {studenten ({count})}}"
    },
    "statistics": {
      "before-date": "op",
      "description": "De tabel hieronder laat zien hoe je deelnemers per onderwerp zijn gepositioneerd.'<br>' Positionering geeft het gemiddelde niveau van je deelnemers weer ten opzichte van het maximale niveau dat ze hadden kunnen bereiken.'<br>' Deze gegevens houden rekening met alle deelnames die zijn gedeeld als onderdeel van de evaluatiecampagnes van je organisatie en die niet zijn verwijderd.",
      "empty-state": "Geen gegevens beschikbaar",
      "level": {
        "advanced": "Geavanceerd",
        "expert": "Expert",
        "independent": "Onafhankelijk",
        "novice": "Beginnende"
      },
      "select-label": "Domein",
      "table": {
        "caption": "Deze tabel toont de resultaten van alle deelnemers per onderwerp. Voor elke regel wordt de vaardigheid, het onderwerp, het dekkingspercentage en het behaalde niveau aangegeven.",
        "headers": {
          "competences": "Vaardigheden",
          "positioning": "positionering",
          "reached-level": "Bereikt niveau",
          "topics": "Onderwerpen"
        }
      },
      "title": "Statistieken"
    },
    "sup-organization-participant-activity": {
      "title": "Activiteit van de student"
    },
    "sup-organization-participants": {
      "action-bar": {
        "delete-button": "Verwijderen",
        "error-message": "{count, plural, =1 {Er is een fout opgetreden, {firstname} {lastname} is niet verwijderd uit de lijst met studenten} other {Er is een fout opgetreden, de {count} geselecteerde studenten zijn niet verwijderd uit de lijst.}}",
        "information": "{count, plural, =1 {{count} geselecteerde student} other {{count} geselecteerde studenten}}",
        "success-message": "{count, plural, =1 {{firstname} {lastname} is verwijderd uit de lijst met studenten.} other {De {count} geselecteerde studenten zijn verwijderd uit de lijst.}}"
      },
      "actions": {
        "download-template": "Het model downloaden",
        "edit-student-number": "Studentnummer bewerken",
        "show-actions": "Acties weergeven"
      },
      "deletion-modal": {
        "content": {
          "footer": "Houd er rekening mee dat deze actie onomkeerbaar is.",
          "header": "{count, plural, =1 {Deze student is niet meer zichtbaar} other {Deze studenten zijn niet meer zichtbaar}} in Pix Orga.",
          "main-campaign-prevent": "Dit heeft invloed op de resultaten en analyses van de campagnes die {count, plural, =1 {hij/zij heeft} other {zij hebben}} uitgevoerd.",
          "main-participation-prevent": "Alle campagne-items {count, plural, =1 {van hem} other {van hen}} worden verwijderd."
        },
        "title": "{count, plural, =1 {Verwijder '<strong>'{firstname} {lastname}'</strong>' uit je studenten?} other {Weet je zeker dat je '<strong>'{count}'</strong>'}} studenten wilt verwijderen?"
      },
      "edit-student-number-modal": {
        "actions": {
          "update": "Bijwerken"
        },
        "form": {
          "error": "Het studentnummer mag niet leeg zijn.",
          "new-student-number-label": "Nieuw studentnummer",
          "student-number": "Huidig studentnummer van {firstName} {lastName} is:",
          "success": "Het studentnummer van {firstName} {lastName} is gewijzigd."
        },
        "title": "Bewerking van studentnummer"
      },
      "empty-state": {
        "no-participants": "Nog geen studenten!",
        "no-participants-action": "De beheerder moet de studenten importeren door op de knop importeren te klikken."
      },
      "filter": {
        "aria-label": "Filter studenten",
        "certificability": {
          "label": "Zoeken op certificeerbaarheid",
          "placeholder": "Certificeerbaarheid"
        },
        "group": {
          "empty": "Geen groep",
          "label": "Een groep invoeren",
          "placeholder": "Zoeken op groep"
        },
        "student-number": {
          "label": "Voer een studentnummer in",
          "placeholder": "1234658P"
        },
        "students-count": "{count, plural, =0 {0 studenten} =1 {1 student} other {{count} studenten}}"
      },
      "page-title": "Studenten",
      "replace-students-modal": {
        "confirm": "Ja, vervangen",
        "confirmation-checkbox": "Ik kan bevestigen dat ik de gevolgen volledig begrijp",
        "footer-content": "Bestaande studenten in de applicatie en aanwezig in de nieuwe import zullen niet verwijderd worden en zullen bijgewerkt worden indien nodig.",
        "last-warning": "Houd er rekening mee dat deze actie onomkeerbaar is. Studenten die niet aanwezig zijn in de nieuwe import worden verwijderd uit Pix Orga.",
        "main-content": "Al hun campagnebijdragen zullen worden verwijderd. Dit heeft gevolgen voor de resultaten en analyses van de campagnes die ze hebben uitgevoerd. Ze zullen niet langer kunnen deelnemen aan campagnes waaraan ze in het verleden hebben deelgenomen. Ze kunnen echter wel deelnemen aan nieuwe campagnes.",
        "title": "Weet je zeker dat je bestaande studenten wilt vervangen?"
      },
      "table": {
        "column": {
          "date-of-birth": "Geboortedatum",
          "first-name": "Voornaam",
          "group": "Groepen",
          "is-certifiable": {
            "label": "Certificeerbaarheid"
          },
          "last-name": {
            "ariaLabelDefaultSort": "De tabel is momenteel niet gesorteerd op naam. Klik op om alfabetisch te sorteren.",
            "ariaLabelSortDown": "De tabel is gesorteerd op naam, in omgekeerde alfabetische volgorde. Klik om alfabetisch te sorteren.",
            "ariaLabelSortUp": "De tabel is alfabetisch gesorteerd op naam. Klik op om in omgekeerde alfabetische volgorde te sorteren.",
            "label": "Achternaam"
          },
          "last-participation-date": "Laatste deelname",
          "participation-count": {
            "ariaLabelDefaultSort": "De tabel is momenteel niet gesorteerd op aantal deelnames. Klik op om in oplopende volgorde te sorteren.",
            "ariaLabelSortDown": "De tabel is gesorteerd op aflopend aantal deelnames. Klik op om in oplopende volgorde te sorteren.",
            "ariaLabelSortUp": "De tabel is gesorteerd op oplopend aantal deelnames. Klik om aflopend te sorteren.",
            "label": "Aantal deelnames"
          },
          "student-number": "Studentnummer"
        },
        "description": "Tabel van studenten gesorteerd op naam. Je kunt via een menu in een extra kolom het studentnummer wijzigen.",
        "empty": "Geen studenten."
      },
      "title": "{count, plural, =0 {Studenten} =1 {Student ({count})} other {Studenten ({count})}}"
    },
    "team-invitations": {
      "cancel-invitation": "Uitnodiging verwijderen",
      "invitation-cancelled-succeed-message": "De uitnodiging is verwijderd.",
      "invitation-resent-succeed-message": "De uitnodiging is opnieuw gestuurd.",
      "resend-invitation": "Uitnodiging opnieuw versturen",
      "table": {
        "column": {
          "email-address": "E-mailadres",
          "pending-invitation": "Datum laatste verzending"
        },
        "row": {
          "aria-label": "Uitnodiging in behandeling"
        }
      },
      "title": "Uitnodigingen"
    },
    "team-list": {
      "add-member-button": "Een lid uitnodigen",
      "tabs": {
        "invitation": "Uitnodigingen ({count, plural, =0 {-} other {{count}}})",
        "member": "Leden ({count, plural, =0 {-} other {{count}}})"
      },
      "title": "Team"
    },
    "team-members": {
      "actions": {
        "edit-organization-membership-role": "Taak wijzigen",
        "leave-organization": "Verlaat deze Pix Orga-ruimte",
        "manage": "Beheren",
        "remove-membership": "Verwijderen",
        "save": "Opslaan",
        "select-role": {
          "label": "Een taak selecteren",
          "options": {
            "admin": "Beheerder",
            "member": "Lid"
          }
        }
      },
      "modals": {
        "leave-organization": {
          "message": "Weet je zeker dat je deze Pix Orga-ruimte wilt verlaten? Je zult geen toegang meer hebben tot <strong>{organizationName}</strong><br/><br/>Je campagnes blijven toegankelijk voor de rest van het team en worden niet gearchiveerd.<br/><br/>Je toegang tot andere Pix Orga-ruimtes wordt niet beïnvloed. <br/><br/>Je wordt uitgelogd.",
          "title": "Verlaat deze Pix Orga-ruimte"
        }
      },
      "notifications": {
        "change-member-role": {
          "error": "Er is een fout opgetreden bij het wijzigen van de taak van het lid.",
          "success": "De taak is veranderd."
        },
        "leave-organization": {
          "error": "Er is een fout opgetreden bij het deactiveren van het lid.",
          "success": "Je bent succesvol verwijderd uit de organisatie {organizationName}. Je wordt uitgelogd van Pix Orga..."
        },
        "remove-membership": {
          "error": "Er is een fout opgetreden bij het deactiveren van het lid.",
          "success": "{memberFirstName} {memberLastName} is succesvol verwijderd uit je Pix Orga-team."
        }
      },
      "remove-membership-modal": {
        "actions": {
          "remove": "Ja, het lid verwijderen"
        },
        "message": "{memberFirstName} {memberLastName} zal niet langer toegang hebben tot deze Pix Orga-ruimte.'<br> 'Zijn campagnes blijven toegankelijk voor de rest van het team.",
        "title": "Bevestig je de verwijdering?"
      },
      "table": {
        "column": {
          "first-name": "Voornaam",
          "last-name": "Achternaam",
          "organization-membership-role": "Taak"
        },
        "empty": "In afwachting van leden"
      },
      "title": "Leden"
    },
    "team-new": {
      "email-requirement": "Voer hier het e-mailadres in van het lid dat je wilt uitnodigen.",
      "errors": {
        "default": "De service is tijdelijk niet beschikbaar. Probeer het later nog eens.",
        "invalid-input": "The data entered was not in the correct format",
        "mandatory-email-field": "This field is mandatory",
        "sending-email-to-invalid-email-address": "Het verzenden van e-mail naar adres {email} is mislukt. De verzendende server antwoordde: \"{errorMessage}\".",
        "status": {
          "400": "De indeling van het e-mailadres is onjuist.",
          "404": "Dit mailadres is van geen enkele gebruiker.",
          "412": "Dit lid is al toegevoegd.",
          "500": "Er is iets fout gegaan. Probeer het opnieuw."
        }
      },
      "invite-form-modal": {
        "confirm": "Confirm",
        "question": "Do you want to continue? ",
        "title": "Confirm the addition of new team members",
        "warning": "Members you add will have access to participant results and campaign analytics."
      },
      "invited-members": "Als gasten de e-mail ontvangen, kunnen ze kiezen of ze een Pix-account willen aanmaken of willen inloggen met een bestaand Pix-account.",
      "several-email-requirement": "Je kunt meerdere leden uitnodigen door e-mailadressen te scheiden met komma's.",
      "success": {
        "invitation": "Er is een uitnodiging verstuurd naar het e-mailadres {email}.",
        "multiple-invitations": "Er is een uitnodiging gestuurd naar de vermelde e-mailadressen."
      },
      "title": "Een lid uitnodigen",
      "warning": "De leden die je hieronder toevoegt, krijgen toegang tot deelnemersresultaten en campagneanalyses. Zorg ervoor dat de mensen die u uitnodigt lid zijn van uw organisatie."
    },
    "team-new-item": {
      "input-label": "E-mailadres(sen)",
      "invite-button": "Uitnodigen"
    },
    "terms-of-service": {
      "accept": "Ik accepteer de gebruiksvoorwaarden",
      "title": "Gebruiksvoorwaarden"
    }
  }
}]];